import { Link } from '@material-ui/core';
import {
  AccountParticipationLevel,
  AmountOfEmployees,
  ArticleCategory,
  ArticleType,
  ArticleTypeExternal,
  AssetType,
  BorrowerFileType,
  BusinessType,
  CashInCashOutType,
  ChannelType,
  CompanyActivity,
  CustomLanguage,
  CustomRegistry,
  DeclaredBusinessType,
  deleteAgentInLenderContextById,
  deleteCheckoutSessionByCheckoutSessionId,
  DownPaymentCollection,
  EmploymentStatus,
  FeePaymentType,
  FeeType,
  Gender,
  HolderType,
  HppStatus,
  IberiaCompanyActivity,
  IberiaEmploymentStatus,
  IncomeType,
  LenderApprovalStatus,
  LenderName,
  LoanApplicationStatus,
  LoanDesistReason,
  LoanFileType,
  LoanStatusExternal,
  MerchantFileType,
  NetIncomeType,
  OnboardingDetailsRole,
  OperativeType,
  OtpStatus,
  patchAddCashInCashOutMethodByMerchantId,
  patchAddPricingSpecInLenderContextInPricingSpec,
  patchAddRequiredFileTypeToDocumentationRequired,
  patchBlockUser,
  patchChangeAcquisitionChannelByMerchantId,
  patchChangeAgentIdChannel,
  patchChangeApprovalStatusByMerchantId,
  patchChangeDescription,
  patchChangeLoanStatus,
  patchChangeMerchantStatusByMerchantId,
  patchChangeRegistrationFieldsByMerchantId,
  patchChangeType,
  patchChangeUserId,
  patchCreateSignatureReminderRequestForMerchantContract,
  patchCreateSignatureRequestForMerchantContract,
  patchPaymentMethodModification,
  patchProcessLoanApplicationInLenderManually,
  patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId,
  patchRemoveRequiredFileTypeFromDocumentationRequired,
  patchSendDocumentationIncidenceNotification,
  patchSetAgentConfiguration,
  patchSetAgentIdInLenderContextById,
  patchSetAreDocumentsConfirmed,
  patchSetBorrowerOnboardingDetailsByRole,
  patchSetBrandInformationAndUploadLogoToCDN,
  patchSetBusinessDetailsToBusinessOnboardingDetails,
  patchSetCart,
  patchSetDocumentRequiredIsNotSent,
  patchSetDocumentStatus,
  patchSetHoldersToBusinessOnboardingDetails,
  patchSetLegalAddress,
  patchSetLenderRequestId,
  patchSetNieData,
  patchSetPricingIdsToAgent,
  patchSetProcessingConfigToMerchantAgents,
  patchSetRangesForAgent,
  patchSignLoanLenderBorrowerContract,
  patchSyncBorrowerDocumentationByLoanId,
  patchUnblockUser,
  patchUnSignLoanLenderBorrowerContract,
  patchUpdateBorrowerContractLoan,
  patchUpdateBorrowerDetails,
  patchUpdateCashInCashOutMethod,
  patchUpdateCashInCashOutMethodByMerchantId,
  patchUpdateDeclaredIncome,
  patchUpdateDownPayment,
  patchUpdateInvitationByType,
  patchUpdateLoanApplicationInLender,
  patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod,
  patchUpdatePaymentDateByPaymentLineId,
  patchUpdatePaymentMethodOptions,
  patchUpdatePaymentPlanLineSentDate,
  patchUpdatePaymentPlanLineStatus,
  patchUploadDocumentationToLender,
  patchUploadFileToDocumentationRequired,
  PaymentMethodType,
  PaymentMode,
  PaymentPlanLineStatus,
  PayoutStatus,
  PetitionType,
  postAgentInLenderContext,
  postCloneOrUpdateAgent,
  postCreateAgent,
  postCreateChannel,
  postCreateCheckoutSession,
  postCreateMerchant,
  postCreateMerchantData,
  postCreatePaymentIntent,
  postCreateUser,
  postCreditCardIberiaCards,
  postPaymentMethodModificationPreview,
  postSendEmailForNewVideoId,
  postSyncPricingsToCdnByAgentId,
  Priority,
  Product,
  ProductExternal,
  ProfessionalPosition,
  Program,
  PurchaseCountry,
  Relation,
  SecurityCheckName,
  SentCodeStatus,
  SimilarityLevel,
  StopCondition,
  TransactionType,
  TravelCategory,
  Turnover,
  UserType,
  WorkflowPlace,
} from '@nemuru-eng/js-api-client';
import {
  InsuranceProvider,
  InsuranceType,
  PaymentAttemptFailReason,
  PaymentAttemptStatus,
  PaymentProvider,
  RangeType,
} from '@nemuru-eng/js-api-client/slim';
import esLocale from 'date-fns/locale/es';

import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
import { FilterType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/Filter';
import { ApplicationIberiaCardsStep } from '@/components/modules/Application/IberiaCards/_shared/types/ApplicationIberiaCardsStep';
import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { KycIntegrationMethodOwner } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { CreditCardName } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { ValidationStep } from '@/components/modules/DocumentsValidation/types/ValidationStep';
import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { TimeIntervalType } from '@/components/modules/Metrics/shared/types/TimeIntervalType';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { DistributionMethod } from '@/components/shared/components/DistributionDialog/types/DistributionMethod';
import { FilterByType } from '@/components/shared/components/SuperSearchBar/types/FilterByType';
import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';
import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

import { OverduePlanLineStatus } from '../../components/modules/PaymentPlan/types/PaymentPlanLineStatusExtended';
import { FilterByDate } from '../../components/shared/components/SuperSearchBar/types/FilterByDate';
import { APP_ROLES } from '../config';
import { statusSections } from '../loanConfig';
import { PendingDataType } from '../types';
import { DictionaryType } from './types/dictionaryType';
/* eslint-disable quotes */

const en: DictionaryType = {
  // GENERAL
  YES: 'Yes',
  NO: 'No',
  EDIT_INFORMATION: 'Edit information',
  DATE_FORMAT_DAY_MONTH_YEAR: 'Day, month, year',
  DATE_FORMAT_MONTH_YEAR: 'Month, year',
  DATE_FORMAT_YEAR: 'Year',
  DATE_LOCALE: esLocale,
  SEND: 'Send',
  CANCEL: 'Cancel',
  SEE_MORE: 'See more',
  BY: 'by',
  OF: 'of',
  COPY: 'Copy',
  EDIT: 'Edit',
  NO_OPTIONS_TO_DISPLAY: 'No options available',
  ITEM: 'Item',
  ITEMS: 'Items',
  INFORMATION: 'Information',
  WELCOME_TO_THE_OFFER_PROCESS: 'Welcome $v1',
  WELCOME_TO_THE_OFFER_PROCESS_SUBTITLE: 'Associate a reference of your order for this new application.',

  // PAGES
  HOME: 'Home',
  CONSUMER_LOAN_LIST: 'Consumer loans',
  CONSUMER_LOAN_DETAIL: 'Loan detail',
  DOCUMENTS_VALIDATION: 'Documents validation',
  AUTO_LOAN_LIST: 'Auto loans',
  AUTO_LIST: 'Auto loans',
  AUTO_LOAN_DETAIL: 'Loan detail',
  CREDIT_LINE_LIST: 'Credit lines',
  CREDIT_LINE_DETAIL: 'Credit line detail',
  ORDER_LIST: 'BNPL',
  PAY_BY_LINK_LIST: 'Pay by link',
  ORDER_DETAIL: 'Order detail',
  MERCHANTS_LIST: 'Merchant list',
  MERCHANTS_LIST_TITLE: 'Merchants',
  CONSUMER_LOAN_SUBSECTION_TITLE: 'Consumer loan list',
  AUTO_SUBSECTION_TITLE: 'Auto loan list',
  CREDIT_LINE_SUBSECTION_TITLE: 'Credit line list',
  ORDER_SUBSECTION_TITLE: 'BNPL list',
  PAY_BY_LINK_SUBSECTION_TITLE: 'Pay by link list',
  MERCHANT_DETAIL: 'Merchant detail',
  MERCHANT_DETAILS: 'Merchant details',
  BORROWER_LIST: 'Borrowers',
  BORROWER_DETAIL: 'Borrower detail',
  APPLICATIONS: 'Applications',
  OPEN_APPLICATION: 'Open application',
  CONTINUE_APPLICATION: 'Continue application',
  CONTINUE_APPLICATION_TEXT:
    'You have started this payment method but you have not completed the information necessary to send the application to the entities.',
  CUSTOMER_CONTINUE_APPLICATION_TEXT:
    'Your client has started this payment method but has not completed the information necessary to send the application to the entities.',
  PAY_FIRST_INSTALMENT_TITLE: 'Pending first instalment payment...',
  PAY_FIRST_INSTALMENT_DESCRIPTION:
    'You should share the payment link with your client to allow them to access the process and pay the first instalment with $v1. Once paid, the process will be completed automatically.',
  PAY_FIRST_INSTALMENT_DESCRIPTION_NOT_SHAREABLE:
    'Your client must pay the first instalment with $v1. Once paid, the process will be completed automatically.',
  BNPL_LENDER_SELECTED_APPROVED_TITLE: 'Lender selected',
  BNPL_LENDER_SELECTED_APPROVED_DESCRIPTION:
    'The client has selected the lender $v1. You should share the payment link with your client to allow them to access the process and pay the first instalment with $v1. Once paid, the process will be completed automatically.',
  BNPL_LENDER_SELECTED_REJECTED_TITLE: 'Lender not selected',
  BNPL_LENDER_SELECTED_REJECTED_DESCRIPTION:
    'The client has not selected the lender. You can continue with the payment process by selecting another payment method.',
  CAPTURE_ORDER_TITLE: 'Capture order',
  CAPTURE_ORDER_DESCRIPTION:
    'To receive the payment of this order, you must capture it. The order capture should be done when the products or services are delivered.',

  START: 'Start',

  // LOGIN
  EMAIL: 'Email',
  PASSWORD: 'Password',
  PASSWORD_OPTIONAL: 'Password (optional)',
  ENTER: 'Enter',
  LOGOUT: 'Logout',
  FORGOT_PASSWORD: 'Forgot Password',
  REQUIRED_FIELD_EMAIL: 'Email is required',
  REQUIRED_FIELD_PASSWORD: 'Password is missing',
  LOGIN: 'Log In',
  DID_YOU_FORGET_YOUR_PASSWORD: 'Did you forget your password?',
  PLEASE_REVIEW_YOUR_LOGIN_CREDENTIALS: 'Please review your login credentials',

  //ACCOUNT DETAIL
  ACTIVE_PROFILE: 'Active profile',
  ACTIVE_PROFILE_CAPTION: 'You have $v1 profiles. Switching profile reloads the page.',
  ACTIVE_PROFILE_TAG: 'Active',
  MORE_PROFILES: '$v1 more profiles',
  MORE_PROFILES_ONE: '1 more profile',
  GO_TO_ACCOUNT: 'Go to Account',
  PROFILE_SWITCH_ERROR: 'The profile could not be switched',
  PROFILE_SWITCHING_TO: 'Switching to $v1…',
  ORGANIZATION: 'Organization',
  ORGANIZATION_STRUCTURE: 'Hierarchical organization of your account',

  // FORGOT PASSWORD
  CREDENTIALS_RECOVERY: 'Credentials Recovery',
  CREDENTIALS_RECOVERY_EXPLANATION:
    'Please enter your email address. You will soon receive an email to create a new password and regain access.',
  CREDENTIALS_RECOVERY_EMAIL_SENT: 'An email has been sent to the provided address',
  CREDENTIALS_RECOVERY_EMAIL_SENT_EXPLANATION:
    'Please check your inbox. If the address was associated with a valid account, you will receive an email to create a new password and regain access.',
  RECOVERY_PASSWORD_EMAIL_FAILED: 'Failed to send password recovery email.',
  PLEASE_CHECK_INPUT_DATA_OR_TRY_LATER:
    'Please check the entered data. If the problem persists, try again later or contact customer support.',
  CREATE_YOUR_PASSWORD_EXPLANATION: 'Create a new password to regain access to the platform',
  BACK_TO_HOME: 'Back to Home',
  INVALID_EMAIL: 'Invalid email',
  INVALID_URL: 'Invalid URL',
  INVALID_JSON: 'Invalid JSON',
  FORMAT_JSON: 'Format JSON',
  YOU_CAN_SAFELY_CLOSE_THE_DIALOG: 'You can safely close this window',
  RETRY: 'Retry',
  CLOSE: 'Close',
  OPEN_IN_NEW_TAB: 'Open in new tab',
  UPDATING: 'Updating...',
  BACK_TO_LOGIN: 'Back to Login',
  ACTION_REQUEST_AUTH_REJECTED: 'Error starting session',

  YOU_CAN_CLOSE_THIS_WINDOW_AND_LOGIN_WITH_YOUR_NEW_PASSWORD:
    'You can close this window and log in to your account with the new password',

  // SET PASSWORD
  CREATE_YOUR_PASSWORD: 'Create your password',
  MIN_PASSWORD_LENGTH: 'Must be at least 6 characters long',
  CURRENT_PASSWORD: 'Current password',
  NEW_PASSWORD: 'New password',
  REPEAT_NEW_PASSWORD: 'Repeat new password',
  CHANGE_PASSWORD: 'Change password',
  CHANGE: 'Change',
  NEW_PASSWORD_CANNOT_BE_SAME_AS_CURRENT: 'New password cannot be the same as the current one',
  NEW_PASSWORD_AND_CONFIRMATION_DONT_MATCH: "New password and confirmation don't match",

  // FORM INPUT HELP
  REQUIRED_FIELD: 'Required field',
  PLEASE_COMPLETE_THIS_FIELD_CORRECTLY: 'Please complete this field correctly',
  INVALID_FORMAT: 'Invalid format',
  PLEASE_CHECK_INPUT_DATA: 'Please check the entered data',
  CANNOT_BE_LESS_THAN_LOAN_AMOUNT: 'Cannot be less than the loan amount',
  REQUIRED_MIN_LENGTH: 'Minimum characters length not reached',
  REQUIRED_MAX_LENGTH: 'Maximum characters length reached',
  EQUAL_OR_LARGER_THAN: 'Must be equal or larger than $v1',

  // NOTIFICATIONS
  NOTIFICATIONS: 'Notifications',
  ALL_NOTIFICATIONS_READ_AND_NO_NEW_NOTIFICATIONS:
    'All notifications have been read and there are no new notifications',
  ALL_NOTIFICATIONS_READ: 'All notifications have been read',
  NO_NEW_NOTIFICATIONS: 'No new notifications',
  BORROWER_NOTIFICATIONS: 'Notifications sent to the client',
  AGENT_NOTIFICATIONS: 'Notifications sent to the merchant',
  NO_NOTIFICATIONS: 'No notifications have been sent yet',
  EXTERNAL_ID_TYPE: 'Type',
  NOTIFICATION_TYPE: 'Notification type',
  DELIVERED_AT: 'Delivery date',
  MESSAGE_SUBJECT: 'Subject',
  DELIVERY_STATUS: 'Delivered',
  LOADING_NOTIFICATIONS: 'Loading notifications',

  // TASKS:
  MANAGEMENT: 'Management',
  SUPPORT: 'Support',
  TASKS: 'Tasks',
  NO_NEW_TASKS: 'No new tasks',
  ALL_TASKS_COMPLETED: 'All tasks are completed',

  // SUPER SEARCH BAR:
  SEARCH_BAR: 'Search bar',
  SEARCH_APPLICATIONS: 'Search application...',
  SEARCH_MERCHANTS: 'Search merchant...',
  SEARCH_AGENTS: 'Search agent...',
  LOADING_RESULTS: 'Loading results...',
  DYNAMIC_CUSTOMER_NAME_WITH_APPLICATION_AMOUNT: '$v1 for $v2',
  [FilterByDate.TODAY]: 'Today',
  [FilterByDate.LAST_7_DAYS]: 'Last 7 days',
  [FilterByDate.LAST_30_DAYS]: 'Last 30 days',
  [FilterByDate.ALL_DATES]: 'Any date',
  [FilterByType.APPLICATIONS]: 'Products',
  [FilterByType.CHECKOUT_SESSIONS]: 'Applications',
  [FilterByType.MERCHANTS]: 'Merchants',
  UPDATED_AT_DESCEND: 'Last updated: newest first',
  UPDATED_AT_ASCEND: 'Last updated: oldest first',
  CREATED_AT_ASCEND: 'Creation date: oldest first',
  CREATED_AT_DESCEND: 'Creation date: newest first',
  SORT_BY: 'Sort by',
  ITEMS_PER_PAGE: 'Results per page',
  COPY_ID: 'Copy ID',
  SELECT: 'Select',
  OPEN: 'Open',
  NAVIGATE: 'Navigate',

  // HOME
  WELCOME_TO_PANEL: 'Welcome, $v1!',
  CHOOSE_SECTION:
    'These are the sections you have access to with your role $v1. Choose the one you want to start managing.',

  //GLOBAL METRICS
  [TimeIntervalType.TODAY]: 'Today',
  [TimeIntervalType.THIS_WEEK]: 'Last Week',
  [TimeIntervalType.THIS_MONTH]: 'Last Month',
  [TimeIntervalType.MONTH_TO_DATE]: 'This month',
  [TimeIntervalType.CUSTOM]: 'Custom…',
  METRICS_PERIOD_MONTH_TO_DATE: '$v1 $v2 · 1 to $v3',
  METRICS_PERIOD_CUSTOM: '$v1 to $v2',
  METRICS_PERIOD_CUSTOM_TITLE: 'Custom period',
  METRICS_PERIOD_CUSTOM_INVALID: 'Pick a start date on or before the end date, up to today',
  METRICS_PERIOD_FROM: 'From',
  METRICS_PERIOD_TO: 'To',
  METRICS_PERIOD_APPLY: 'Apply',
  METRICS_COMPARISON_MONTH_TO_DATE: 'Compared with the same days (1–$v1) of the previous month',
  NO_PREVIOUS_RESULTS: 'No Previous Results',
  OF_PREV_PERIOD: 'previous period ($v1)',
  [`${ScoreCardMetricKey.totalLoansNumber}_TID`]: 'Requests',
  [`${ScoreCardMetricKey.totalPrincipalAmount}_TID`]: 'Amount',
  [ScoreCardMetricKey.totalLoansNumber]: 'Requests',
  [ScoreCardMetricKey.totalPrincipalAmount]: 'Amount',
  METRICS_COMPARISON_PREVIOUS_DAY: 'Compared with the previous day',
  METRICS_COMPARISON_PREVIOUS_DAYS: 'Compared with the previous $v1 days',
  LENDER_RANKING_TITLE: 'Lender ranking',
  LENDER_RANKING_DESCRIPTION: 'Confirmed sales, approval and time to formalization of each lender during $v1.',
  LENDER_RANKING_LENDER: 'Lender',
  LENDER_RANKING_AMOUNT: 'Amount',
  LENDER_RANKING_LOANS: 'Loans',
  LENDER_RANKING_SHARE: 'Share',
  LENDER_RANKING_VARIATION: 'vs. previous period',
  LENDER_RANKING_APPROVAL: 'Approval',
  LENDER_RANKING_APPROVAL_TOOLTIP:
    'Approved applications over those sent to the lender in the period (approved, denied, in study and with error)',
  LENDER_RANKING_AVERAGE_TICKET: 'Average ticket',
  LENDER_RANKING_FORMALIZATION: 'Formalization',
  LENDER_RANKING_FORMALIZATION_TOOLTIP:
    'Average time from sending the application to the lender until the documents are approved, only loans formalized with this lender',
  LENDER_RANKING_TOP: 'Top $v1',
  LENDER_RANKING_REST: 'Other lenders',
  LENDER_RANKING_TOTAL: 'Total',
  LENDER_RANKING_ERROR: 'The lender ranking could not be loaded',
  DURATION_MINUTES: '$v1 min',
  DURATION_HOURS: '$v1 h',
  DURATION_DAYS: '$v1 days',

  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.INITIAL}`]: 'Initiated',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.ON_HOLD}`]: 'Requested',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.REQUESTED}`]: 'Pre-approved',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.APPROVED}`]: 'Pre-approved',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.CONFIRMED}`]: 'Confirmed',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.PAID}`]: 'Paid',

  [`PRODUCT_EXTERNAL_${ProductExternal.CONSUMER_LOAN}`]: 'Consumer Loan',
  [`PRODUCT_EXTERNAL_${ProductExternal.AUTO}`]: 'Auto Loan',
  [`PRODUCT_EXTERNAL_${ProductExternal.CREDIT_LINE}`]: 'Credit Line',
  [`PRODUCT_EXTERNAL_${ProductExternal.BNPL}`]: 'BNPL',
  [`PRODUCT_EXTERNAL_${ProductExternal.PAY_BY_LINK}`]: 'Pay by link',

  TOP_MERCHANTS_TITLE: 'Top merchants',
  TOP_MERCHANTS_DESCRIPTION: 'With more confirmed requests during $v1.',

  PRODUCT_EXTERNAL_TITLE: 'Types of request',
  PRODUCT_EXTERNAL_DESCRIPTION: 'Confirmed during $v1.',

  CHANNEL_METRICS: 'Channel Metrics',
  MERCHANT_METRICS: 'Merchant Metrics',
  AGENT_METRICS: 'Agent Metrics',
  NO_METRICS_INFORMATION: 'No data to show',

  // CONSUMER LOAN LIST
  LOAN: 'Loan',
  PRODUCTS_LIST: 'Products list',
  TYPE: 'Type',
  CLIENT: 'Client',
  CREATION_DATE: 'Creation date',
  CREATED: 'Created:',
  UPDATE_DATE: 'Update date',
  ID: 'ID',
  STATUS: 'Status',
  CHECKOUT_SESSION_STATUS: 'Checkout status',
  SELECTED_PAYMENT_INTENT: 'Payment method',
  ALL: 'All',
  DEFAULT: 'Default',
  [CustomRegistry.DEFAULT]: 'Default',
  [CustomRegistry.TECHNOLOGICAL_PLATFORM]: 'Technological platform',
  SELECT_ALL: 'Select all',
  DESELECT_ALL: 'Deselect all',
  FROM_DATE: 'From date',
  TO_DATE: 'To date',
  LENDER: 'Lender',
  ORDER_DETAILS: 'Order details',
  LOAN_DETAILS: 'Loan details',
  BORROWER_DETAILS: 'Borrower details',
  STATUS_DETAILS: 'Status details',
  LENDER_ASSIGNMENT_DETAILS: 'Lender assignment details',
  ID_DETAILS: 'ID details',
  MAIN_RESIDENCE_ADDRESS: 'Address',
  EDIT_DOCUMENT_ID: 'Edit personal data',
  EDIT_MAIN_RESIDENCE_INFORMATION: 'Edit main residence information',
  EDIT_FAMILIAR_SITUATION: 'Edit family information',
  EDIT_PROFESSIONAL_DETAILS: 'Edit professional information',
  DOCUMENT_EXPEDITOR: 'Document expeditor',

  REFERENCES_DETAILS: 'References details',

  [statusSections.PENDING]: 'Started',
  [statusSections.ANALYSING]: 'Requested',
  [statusSections.APPROVED]: 'Pre-approved',
  [statusSections.FORMALIZED]: 'Confirmed',
  [statusSections.DENIED]: 'Denied',
  [statusSections.CANCELLED]: 'Cancelled',
  [statusSections.DESISTED]: 'Desisted',
  [statusSections.EXPIRED]: 'Expired',

  PROCESS_TERMINATED: 'Process terminated',

  ['status_active,status_active_trial']: 'Payment made',
  ['status_cancelled,status_cancelled_test']: 'Cancelled',

  STATUS_NEXT_STEP_INITIAL_CERTIFICATION: 'First certification',
  STATUS_DESC_INITIAL_CERTIFICATION: 'Pending first certification',
  STATUS_DESC_APPLICATION_STARTED: 'Application started',

  STATUS_NEXT_STEP_PARTIALLY_CERTIFICATED: 'Certifications and payment',
  STATUS_DESC_PARTIALLY_CERTIFICATED: 'Pending ccrtifications',

  STATUS_NEXT_STEP_INITIATED: 'Customer data filling',
  STATUS_DESC_INITIATED: 'Pending customer data',

  STATUS_NEXT_STEP_LENDER_HAS_BEEN_SELECTED: 'Contract sign',
  STATUS_DESC_PENDING_CONTRACT_SENDING: 'Pending contract send',
  STATUS_DESC_LENDER_HAS_BEEN_SELECTED: 'Contract sent, pending signature',

  STATUS_NEXT_STEP_CONTRACT_SIGNED: 'Application validation',
  STATUS_DESC_CONTRACT_SIGNED: 'Signed, awaiting formalization',

  STATUS_NEXT_STEP_DOCUMENTATION: 'Transfer submission',
  STATUS_DESC_DOCUMENTATION: 'Payment pending',

  STATUS_NEXT_STEP_UNOPENED: 'Initial',
  STATUS_DESC_UNOPENED: 'Not opened',

  STATUS_NEXT_STEP_ANALYSING: 'Risk analysis',
  STATUS_DESC_ANALYSING: 'Under risk analysis',

  STATUS_NEXT_STEP_UNPAID: 'Unpaid',
  STATUS_DESC_UNPAID: 'Customer in default',

  STATUS_NEXT_STEP_DENIED: 'Denial',
  STATUS_DESC_DENIED: 'Application denied',

  STATUS_NEXT_STEP_DESISTED: 'Desisted',
  STATUS_DESC_DESISTED: 'Customer has desisted',

  STATUS_NEXT_STEP_EXPIRED: 'Expiration',
  STATUS_DESC_EXPIRED: '30 days inactivity',
  STATUS_DESC_ORDER_EXPIRED: 'Order expired',

  STATUS_NEXT_STEP_CANCELLED: 'Cancellation',
  STATUS_DESC_CANCELLED: 'Cancelled',

  STATUS_NEXT_STEP_CANCELLED_TEST: '-',
  STATUS_DESC_CANCELLED_TEST: 'Test cancelled',

  STATUS_NEXT_STEP_ACTIVE: 'Payment',

  STATUS_DESC_FRONT_COMPLETED: 'Completed',

  STATUS_DESC_ACTIVE: 'Payment made',
  STATUS_DESC_INFORMATION_PENDING: 'Pending filling',
  STATUS_DESC_PAYMENT_PENDING: 'Payment pending',
  FILTER_FROM: 'Filter from',
  FILTER_TO: 'Filter to',
  updated_at: 'Last update date',
  created_at: 'Creation date',
  expiration_date: 'Expiration date',

  // CONSUMER LOAN DETAILS

  TOTAL_COST_PER_QUOTA: 'Total Cost ($v1 per instalment)',
  TOTAL_COST_PER_QUOTA_UPFRONT_PERCENTAGE: 'Total Cost ($v1 upfront)',

  // MERCHANT LIST
  CONTACT_PERSON: 'Contact person',
  STATUS_PENDING_DOCUMENTS: 'Pending documentation',
  STATUS_DOCUMENTS_COMPLETED: 'Documentation completed',
  STATUS_DENIED_PENDING_MANUAL: 'Denied pending manual',
  STATUS_DENIED_EVALUATED: 'Evaluated denied',
  STATUS_PRE_APPROVED: 'Pre-approved',
  STATUS_ASLEEP: 'Asleep',
  STATUS_SUSPENDED: 'Suspended',
  STATUS_BANNED: 'Banned',
  contact_person: 'Contact person',
  status_pending_documents: 'Pending documentation',
  status_documents_completed: 'Documentation completed',
  status_denied_pending_manual: 'Denied pending manual',
  status_denied_evaluated: 'Evaluated denied',
  status_pre_approved: 'Pre-approved',
  status_asleep: 'Asleep',
  status_suspended: 'Suspended',
  status_banned: 'Banned',

  // MERCHANT LIST WIDGET
  ACTIONS: 'Actions',
  ADD_MERCHANT: 'Create merchant',
  CREATE_MERCHANT: 'Create new merchant',

  // MERCHANT DETAIL WIDGET
  APPROVE_BY_COMMERCIAL: 'Approve by commercial',
  APPROVE_BY_COMMERCIAL_TEXT: 'Do you want to approve this merchant by commercial?',
  APPROVE_BY_COMMERCIAL_BTN: 'Approve',
  APPROVE_BY_RISK: 'Approve by risk',
  APPROVE_BY_RISK_TEXT: 'Do you want to approve this merchant by risk?',
  APPROVE_BY_RISK_BTN: 'Approve',
  SUSPEND_ACTION: 'Suspend merchant',
  SUSPEND_ACTION_TEXT: 'Do you want to temporarily suspend this merchant?',
  SUSPEND_ACTION_BTN: 'Suspend',
  BAN_ACTION: 'Ban merchant',
  BAN_ACTION_TEXT: 'Do you want to permanently ban this merchant?',
  BAN_ACTION_BTN: 'Ban',
  REACTIVATE_ACTION: 'Reactivate merchant',
  REACTIVATE_ACTION_TEXT: 'Do you want to reactivate this merchant?',
  REACTIVATE_ACTION_BTN: 'Reactivate',
  APPROVE: 'Approve',
  SUSPEND: 'Suspend',
  BAN: 'Ban',

  // MERCHANT OVERVIEW
  PENDING_TODO_ACTIONS: 'Pending actions',
  MERCHANT_OVERVIEW: 'Merchant detail',
  REGISTRATION_DATA: 'Registration data',
  COMPANY_INFORMATION: 'Company information',
  BUSINESS_NAME: 'Business name',
  BUSINESS_NAME_FISCAL: 'Legal name',
  BUSINESS_TYPE: 'Business type',
  DECLARED_BUSINESS_TYPE: 'Business type',
  [DeclaredBusinessType.SELF_EMPLOYED]: 'Self employed',
  [DeclaredBusinessType.LTD]: 'Company',
  MERCHANT_CATEGORY: 'Category',
  BUSINESS_DETAILS: 'Business details',
  SECTOR: 'Sector',
  ACQUISITION_CHANNEL: 'Acquisition channel',
  CIF: 'Tax ID',
  TURNOVER: 'Annual turnover',
  [Turnover.ZERO_300]: '0€ to 300K€',
  [Turnover.THREE_HUNDRED_1MILLION]: '300K€ to 1M€',
  [Turnover.ONE_MILLION_2_MILLION]: '1M€ to 2M€',
  [Turnover.TWO_MILLION_5_MILLION]: '2M€ to 5M€',
  [Turnover.FIVE_MILLION_PLUS]: '5M€+',
  POSTAL_CODE: 'Postal Code',
  AMOUNT_OF_EMPLOYEES: 'Number of Employees',
  [AmountOfEmployees.ZERO_THREE]: '0 to 3',
  [AmountOfEmployees.THREE_TEN]: '3 to 10',
  [AmountOfEmployees.TEN_TWENTY]: '10 to 20',
  [AmountOfEmployees.TWENTY_PLUS]: '20+',

  CONTACT_PERSON_DETAILS: 'Contact person details',
  CONTACT_PERSON_FIRSTNAME: 'Contact person first name',
  CONTACT_PERSON_LASTNAME: 'Contact person last name',
  NAME: 'Name',
  FIRSTNAME: 'First name',
  LASTNAME: 'Last name',
  FULLNAME: 'Full name',
  PHONE: 'Phone',

  LEGAL_ADDRESS: 'Legal address',
  ADD_LEGAL_ADDRESS: 'Add legal address',
  EDIT_LEGAL_ADDRESS: 'Edit legal address',

  CASH_IN_CASH_OUT_METHOD: 'Banking information',
  ACCOUNT_HOLDER_FIRSTNAME: 'Account holder first name',
  ACCOUNT_HOLDER_LASTNAME: 'Account holder last name',
  [`${AccountParticipationLevel.OWNER}_OPTION`]: 'Owner',
  [`${AccountParticipationLevel.CO_OWNER}_OPTION`]: 'Co-owner',
  [`${AccountParticipationLevel.OTHER}_OPTION`]: 'Other',
  [`${AccountParticipationLevel.PARTICIPATED}_OPTION`]: 'Participated',
  [`${AccountParticipationLevel.UNKNOWN}_OPTION`]: 'Unknown',

  [PaymentMethodType.A2A_PAYMENT]: 'Instant bank transfer',
  [PaymentMethodType.B2B_LOAN]: 'B2B Loan',
  [PaymentMethodType.BNPL_INSTALMENTS]: 'Instalments',
  [PaymentMethodType.BNPL_SPLIT_PAY]: 'Split pay',
  [PaymentMethodType.CONSUMER_LOAN_INSTALMENTS]: 'Financing',
  [PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY]: 'Interest-free financing',
  [PaymentMethodType.CARD_PAYMENT]: 'Card payment',
  [PaymentMethodType.SUBSCRIPTION]: 'Subscription',
  [PaymentMethodType.CARD_ONBOARDING]: 'Credit card',
  // [PaymentMethodType.AUTO_LOAN]: 'Auto loan',   // Same as Product.AUTO
  // [PaymentMethodType.CREDIT_LINE]: 'Credit line',   // Same as Product.CREDIT_LINE

  [`${PaymentMethodType.A2A_PAYMENT}_SHORT`]: 'Bank transfer',
  [`${PaymentMethodType.B2B_LOAN}_SHORT`]: 'B2B Loan',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_SHORT`]: 'Instalments',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_SHORT`]: 'Split pay',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_SHORT`]: 'Financing',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_SHORT`]: 'Interest-free financing',
  [`${PaymentMethodType.CARD_PAYMENT}_SHORT`]: 'Card payment',
  [`${PaymentMethodType.SUBSCRIPTION}_SHORT`]: 'Subscription',
  [`${PaymentMethodType.AUTO_LOAN}_SHORT`]: 'Auto loan',
  [`${PaymentMethodType.CREDIT_LINE}_SHORT`]: 'Credit line',
  [`${PaymentMethodType.CREDIT_CARD}_SHORT`]: 'Credit card',
  [`${PaymentMethodType.CARD_ONBOARDING}_SHORT`]: 'Credit card',

  [OperativeType.STANDARD]: 'Standard operation',
  [OperativeType.NO_PAYROLL]: 'No payroll operation',

  PAYMENT_METHODS: 'Payment methods',
  PER_MONTH: '/month',

  ACCOUNT_HOLDER_FIRST_NAME: 'First name',
  ACCOUNT_HOLDER_FIRST_LAST_NAME: 'First last name',
  ACCOUNT_HOLDER_SECOND_LAST_NAME: 'Second last name',
  ACCOUNT_HOLDER_PARTICIPATION_LEVEL: 'Participant type',
  EDIT_BANK_ACCOUNT: 'Edit bank account',

  BANK: 'Bank',
  ACCOUNT_NUMBER_IS_NOT_VALID: 'The bank account number is not valid',
  BANK_RELATED_TO_ACCOUNT_NUMBER_DOES_NOT_EXIST_IN_TABLE: 'The account number corresponds to an unsupported bank',
  BANK_ACCOUNT_NUMBER_DOES_NOT_MATCHES_THE_SELECTED_BANK: 'The selected bank does not match the entered account number',

  ADD_CASH_IN_CASH_OUT_METHOD: 'Add Banking Information',
  EDIT_CASH_IN_CASH_OUT_METHOD: 'Edit Banking Information',
  ADD_BRAND_INFORMATION: 'Add brand information',
  EDIT_BRAND_INFORMATION: 'Edit brand information',
  BRANDING: 'Branding',
  BRAND_NAME: 'Brand name',
  CUSTOMER_SUPPORT_EMAIL: 'Customer support email',
  CUSTOMER_SUPPORT_PHONE_NUMBER: 'Customer support phone number',
  HOMEPAGE_URL: 'Homepage url',
  BRAND_LOGO: 'Brand logo',
  BRAND_LOGO_URL: 'Logo url',
  ADD_BRANDING_INFROMATION: 'Add branding',
  EDIT_BRANDING_INFORMATION: 'Edit branding',
  CHOOSE_IMAGE_FILE: 'Select file',
  CHOOSE_LOGO_IMAGE_FILE: 'Select logo file',
  IMAGE_SIZE: 'Image size',

  // MERCHANT COMPLIANCE
  MERCHANT_CONTRACT: 'Collaboration contract',
  CONTRACT_SENT_DATE: 'Contract sent date',
  CONTRACT_SIGNED_DATE: 'Contract signed date',
  CONTRACT_STATUS: 'Contract status',
  SIGNED: 'Signed',
  NOT_SENT: 'Not sent',
  MERCHANT_DATA: 'Company data',
  COMPANY_MANAGER_DATA: 'Manager data',
  COMPANY_MANAGER_NAME: 'Full name',
  ID_NUMBER: 'ID document number',

  SEE_MERCHANT_CONTRACT_FIELDS: 'See sent contract data',
  SEE_MERCHANT_CONTRACT_FIELDS_FROM_CRM: 'See current crm data',
  MERCHANT_CONTRACT_DATA: 'Contract data',
  MERCHANT_CONTRACT_DATA_FROM_CRM: 'Crm contract data',
  MERCHANT_CONTRACT_DATA_TEXT: 'The following data corresponds to the contract sent on $v1.',
  PROVINCE: 'Province',
  COMPANY_MANAGER_FULLNAME: 'Administrator full name',
  COMPANY_MANAGER_DOCUMENT_NUMBER: 'Administrator ID',
  CONTACT_EMAIL: 'Contact email',
  CONTACT_PHONE_NUMBER: 'Contact phone number',

  SEND_MERCHANT_CONTRACT_REMINDER: 'Send contract reminder',
  SEND_REMINDER: 'Send reminder',
  SEND_MERCHANT_CONTRACT_REMINDER_TEXT: 'Do you want to send a reminder to sign the already sent contract?',
  SEND_NEW_MERCHANT_CONTRACT: 'Send new contract',
  SEND_NEW_MERCHANT_CONTRACT_TEXT:
    'Do you want to send a new contract with the current CRM data? You can see the data that will be included in the new contract by clicking on "See Current CRM Data".',

  // MERCHANT IN LENDER CONTEXT
  FINANCIAL_ENTITIES_ENABLED: 'Financial entities enabled',
  ADD_MERCHANT_IN_LENDER_CONTEXT: 'Add financial entities',
  EDIT_MERCHANT_IN_LENDER_CONTEXT: 'Edit financial entities',
  EDIT_MERCHANT_IN_LENDER_CONTEXT_TEXT: 'Select the enabled financial entities for this merchant.',

  REFRESH: 'Refresh',
  LIVE: 'Live: this page updates automatically',
  LIVE_RECONNECTING: 'Reconnecting to live updates…',
  LIVE_PENDING_CHANGES: '$v1 changes · Refresh',
  REFRESH_DATA: 'Refresh information',
  MAIL: 'Email',
  ADD_MERCHANT_STRUCTURE: 'Add channels and agents',
  MERCHANT_STRUCTURE: 'Structure',
  CHANNEL_STRUCTURE: 'Channel structure',
  CHANNELS_AND_AGENTS: 'Channels and agents',
  SELECT_CHANNEL_TO_VIEW_ITS_AGENTS_AND_DETAILS: 'Select a channel to view its agents and details.',
  X_CHANNELS_AND_Y_AGENTS_IN_TOTAL: '$v1 channels and $v2 agents in total.',
  SELECT_CHANNEL_TO_VIEW_DETAILS: 'Select this channel to view its agents and details.',
  X_ONLY_INCLUDES_ONE_CHANNEL: 'Consists of a single channel with $v2 agent(s)',
  AGENTS: 'Agents',
  AGENT: 'Agent',
  SEARCH_AGENT: 'Search agent',
  SALES_AGENT: 'Agent (Salesperson)',
  CHANNEL: 'Channel',
  CHANNELS: 'Channels',
  SALES_CHANNEL: 'Sales channel',
  NO_ASSOCIATED_CHANNEL_ACCOUNT: 'No access',
  THERE_ARE_NO_AGENTS_ON_THIS_CHANNEL_YET: 'No agents have been created in this channel yet',
  THERE_ARE_NO_CHANNEL_YET: 'No channels have been created yet',
  THERE_ARE_NO_LISTS_TO_SHOW: 'No requests to display yet',
  AGENTS_OF_CHANNEL_X: 'Agents of channel $v1',
  MERCHANT_STATISTICS: 'Merchant statistics',
  COPY_MERCHANT_ID: 'Copy merchant ID',
  COPY_AGENT_ID: 'Copy agent ID',
  COPY_CHANNEL_ID: 'Copy channel ID',
  COPY_BORROWER_ID: 'Copy borrower ID',
  ADD_CHANNEL: 'Add channel',
  ADD_ANOTHER_AGENT: 'Add another agent',
  ADD_AGENT_TO_CHANNEL: 'Add agent to $v1',
  NUMBER_OF_CHANNELS: '$v1 channels',
  NUMBER_OF_CHANNEL_1: '1 channel',
  NUMBER_OF_AGENTS: '$v1 agents',
  NUMBER_OF_AGENT_1: '1 agent',
  SELECTED_AGENT_ERROR_ALERT:
    'The selected agent has no available payment methods. Please try selecting another agent or channel.',

  TYPE_OF_APPLICATIONS: 'Application types:',
  APPLICATIONS_LIST: 'Applications list',

  //MERCHANT CATEGORY
  awnings: 'Awnings',
  elevators: 'Elevators',
  installations: 'Installations',
  education_and_trainings: 'Education',
  buildings: 'Building',
  car_dealerships: 'Car dealerships',
  moto_dealerships: 'Motorcycle dealerships',
  driving_courses: 'Driving courses',
  languages_courses: 'Language courses',
  bootcamp_courses: 'Bootcamp courses',
  fp_programs: 'Training courses',
  business_schools_programs: 'Business schools',
  postgraduate_and_masters: 'Postgraduate and masters',
  other_professional_courses: 'Other professional courses',
  school: 'Schools',
  fertility_treatment: 'Fertility treatments',
  orthopedic_equipment: 'Orthopedic equipment',
  other_surgery_interventions: 'Other surgical interventions',
  rehabilitation: 'Rehabilitation',
  optical_prosthesis: 'Optical prosthetics',
  cosmetic_surgery: 'Cosmetic surgery',
  dental_treatments: 'Dental treatments',
  cosmetic_treatments: 'Cosmetic treatments',
  auditory_prothesis: 'Auditory prosthetics',
  terrace_and_awnings: 'Terraces and awnings',
  structure_and_humidity: 'Structures and humidity',
  insulation: 'Insulation',
  warehouse: 'Material warehouse',
  kitchen: 'Kitchens',
  bathrooms: 'Showers and bathrooms',
  furniture: 'Furniture',
  windows: 'Windows and doors',
  pools: 'Pools',
  gardening: 'Gardens',
  home_automation: 'Home automation',
  prefabricated_houses: 'Prefabricated houses',
  decoration_and_design: 'Decoration and design',
  architecture: 'Architects',
  floors_and_ceilings: 'Parquet and ceilings',
  whole_house: 'Whole house renovations',
  painting: 'Painters',
  carpentry: 'Carpentry, wood, and aluminum',
  home_staging: 'Home staging',
  water_treatment: 'Water treatment',
  air_treatments: 'Air conditioning',
  eco_improvement_and_solar_panels: 'Eco-improvement and solar panels',
  electric_installations: 'Electrical installations',
  heating_installations: 'Heating installations',
  alarms_and_security: 'Alarm systems',
  car_tuning: 'Car tuning',
  car_service: 'Car workshops',
  moto_service: 'Motorcycle workshops',
  bike: 'Bicycles',
  other_mobility_and_accessories: 'Other mobility accessories',
  household_appliances: 'Household appliances',
  garden_machines: 'Garden machinery',
  perfumery_and_cosmetics: 'Perfumery and cosmetics',
  gym_accessories: 'Gym accessories',
  electronic: 'Electronics',
  antiques: 'Antiques',
  art: 'Art',
  jewellery: 'Jewelry',
  fashion: 'Fashion and accessories',
  lighting: 'Lighting',
  travels: 'Travel',
  relocation: 'Relocation',
  real_estate_and_rentals: 'Real estate and rentals',
  celebrations: 'Celebrations',
  funeral_services: 'Funeral services',
  pet_shops: 'Pet shops',
  charging_points: 'Charging points',

  //LOAN DETAIL WIDGET
  ADD_PARTICIPANT_TO_LOAN: 'Add co-borrower/guarantor',
  REMOVE_PARTICIPANT_FROM_LOAN: 'Remove co-borrower/guarantor',
  REMOVE_PARTICIPANT_DIALOG: 'Remove co-borrower/guarantor',
  REMOVE_PARTICIPANT_DIALOG_TEXT: 'Do you want to remove the following participant from the application?',
  REMOVE_PARTICIPANT_DIALOG_BTN: 'Remove participant',
  remove_co_borrower: 'Remove co-borrower',
  remove_guarantor: 'Remove guarantor',
  PARTICIPANT_ROLE: 'Participant role',
  ADD_PARTICIPANT_DIALOG: 'Add co-borrower/guarantor',
  PARTICIPANT_RELATION: 'Relationship',
  ADD_PARTICIPANT_DIALOG_BTN: 'Add participant',
  add_borrower: 'Add borrower',
  add_co_borrower: 'Add co-borrower',
  add_guarantor: 'Add guarantor',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  INVALID_DIAL_CODE: 'Invalid code',
  ADD_GUARANTOR_TO_LOAN: 'Add guarantor',
  REMOVE_GUARANTOR_FROM_LOAN: 'Remove guarantor',
  REMOVE_GUARANTOR_DIALOG: 'Remove guarantor',
  ADD_GUARANTOR_DIALOG: 'Add guarantor',
  ADD_PARTICIPANT_DIALOG_TEXT:
    'Fill in the details of the new co-borrower/guarantor for the application. We will send an email to complete their personal information.',

  REMOVE_GUARANTOR_DIALOG_TEXT: 'Do you want to remove the following guarantor from the application?',

  CHANGE_LOAN_CONDITIONS: 'Change conditions',
  PRINCIPAL_VALUE_SELECTOR: 'Amount (between $v1 and $v2)',
  TERM_VALUE_SELECTOR: 'Term (between $v1 and $v2 months)',
  INVALID_PRINCIPAL_VALUE: 'Invalid amount',
  AUTO_AMOUNT_OUT_OF_RANGE: 'Vehicle amount must be greater than $v1',
  INVALID_TERM_VALUE: 'Invalid term',
  THE_TERM_VALUE_DOES_NOT_EXIST_IN_PRICING: 'The term does not exist for the selected rate and amount',
  SELECT_PRICING: 'Select rate',
  SELECT_PRICING_DESCRIPTION:
    'Select one of the available rates for the agent and enter the new amount and term values.',
  EDIT_LOAN_CONDITIONS: 'Edit loan conditions',
  CURRENT_LOAN_CONDITIONS: 'Current conditions',
  NEW_LOAN_CONDITIONS: 'New conditions',
  COMPARE: 'Compare conditions',
  ADJUST_LOAN_CONDITION: 'Readjust conditions',
  NO_PRICINGS_AVAILABLE: 'No available rates found',
  PRICINGS_ARE_FILTERED_BY_LOAN_CONDITIONS: '*Rates are being filtered by the current loan program',
  LOAN_CALCULATOR_NOT_FOUND_FOR_THE_GIVEN_TERM: 'No conditions found for the selected term',
  SELECT_PRICING_PRINCIPAL_AND_TERM: 'Select an agent rate and enter a valid amount and term',
  INVALID_OPTIONS_FOR_THE_CONDITIONS: 'Invalid options for the selected program',
  [`all_${PricingFilterType.PRODUCT}`]: 'All products',
  [`all_${PricingFilterType.PROGRAM}`]: 'All programs',

  CHANGE_TO_ANOTHER_CHANNEL: 'Switch to Another Channel',
  CHANGE_TO_ANOTHER_CHANNEL_TEXT: 'Do you want to move the agent to another channel?',
  CHANGE_TO_ANOTHER_CHANNEL_BTN: 'Switch Channel',
  NEW_CHANNEL: 'New Channel',
  CURRENT_CHANNEL: 'Current Channel',

  CREATE_NEW_AGENTS: 'Create new agents',
  MODIFY_AGENTS: 'Modify agents',
  FROM_THIS_AGENT: 'You are copying from the data of this agent:',
  LIST_OF_NEW_AGENTS: 'List of new agents',
  LIST_OF_NEW_AGENTS_TEXT:
    'Enter the name, surname, and email of the multiple agents to generate from the selected agent:',
  LIST_OF_AGENTS_TO_UPDATE: 'List of agents to modify',
  LIST_OF_AGENTS_TO_UPDATE_TEXT: 'Select the agents to modify based on the selected agent:',
  BACK: 'Back',

  CLONE_AGENT_MENU: 'Copy and Create New Agents',
  UPDATE_AGENT_MENU: 'Copy and Modify Agents',

  CLONE_AGENT_WITH_NAME: 'Clone to $v1',
  CLONE_AGENT_BTN: 'Clone',
  AGENT_TO_CLONE: 'Copy data from',
  DESTINATION_CHANNEL: 'Destination channel',
  DESTINATION_CHANNEL_TOOLTIP: 'Choose the destination channel where the new cloned agents will be assigned',
  CONFIGURATION_OPTIONS: 'Configuration options',
  CONFIGURATION_OPTIONS_CLONE_TEXT: 'Choose which configuration options you want for the new agents:',
  CONFIGURATION_OPTIONS_UPDATE_TEXT:
    'Choose which configuration options you want to copy to modify the selected agents:',
  CLONE_CONFIGURATION: 'Configuration',
  CLONE_AGENT_IN_LENDER_CONTEXT: 'Credentials in financial entities',
  CLONE_PRICINGS: 'Pricings',
  CLONE_CREATE_USER: 'Create user',
  CLONE_SEND_PASSWORD_RECOVERY: 'Send email for password generation',
  CLONE_AGENT_EMAIL_TOOLTIP:
    'When creating or modifying an agent, an email is needed to validate that it does not already exist in the platform. However, if you do not want to create a user for the agent, you can check that option in the next step. In any case, the email is necessary for the creation or modification of the agent.',
  NEW_AGENTS: 'New agents',
  NEW_AGENTS_TEXT: 'Enter the name and email of the new agents to generate:',
  CREATE_NEW_AGENTS_NUMBER: 'Create $v1 agents',
  UPDATE_NEW_AGENTS_NUMBER: 'Modify $v1 agents',
  CREATING_NEW_AGENTS: 'Creating new agents',
  SEE_ERROR_DETAILS: 'View error message',
  CLONE_SUCCESS: 'Created',
  CLONE_UPDATED: 'Modified',
  CLONE_ERROR: 'Error',
  SELECT_DESIRED_AGENTS: 'Select agents to modify',

  // CHANNEL

  CHANNEL_ID: 'Channel ID:',
  CHANNEL_TYPE: 'Channel type',
  CHANNEL_DESCRIPTION: 'Channel description',
  CHANNEL_DETAILS: 'Channel details',
  CHANNEL_CONFIGURATION: 'Channel configuration',
  [ChannelType.APP]: 'App',
  [ChannelType.MARKETPLACE]: 'Marketplace',
  [ChannelType.PHONE]: 'Phone',
  [ChannelType.SOCIAL_MEDIA]: 'Social media',
  [ChannelType.STORE]: 'Physical store',
  [ChannelType.TPV]: 'TPV',
  [ChannelType.WEB]: 'Web',

  AGENT_DETAILS: 'Agent details',
  AGENT_ID: 'Agent ID:',
  AGENT_CONFIGURATION: 'Agent configuration',
  CONFIGURATION: 'Configuration',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  AGENT_NAME: 'Agent name',
  AGENT_EMAIL: 'Agent email',
  CUSTOM_THEME: 'Appearance',
  CUSTOM_REGISTRY: 'Registry',
  CUSTOM_LANGUAGE: 'Language',
  COMMUNICATIONS: 'Communications',
  BANK_READER_ENABLED: 'Bank aggregation',
  QUOTA_SELECTION_ALLOWED: 'Quota adjustment',
  DOCUMENT_REQUIRED_MANAGEMENT: 'Document manager',
  CERTIFICATIONS: 'Certifications',
  STATUS_ANALYSING_ENABLED: 'Risk analysis',
  BANK_READER_MAX_ATTEMPTS: 'Maximum bank reader attempts',
  ALLOWED_ASSET_TYPES: 'Allowed sectors',
  ALLOWED_PRODUCTS: 'Allowed products',
  ALLOWED_ARTICLE_TYPES: 'Allowed articles',
  ALLOWED_ONBOARDING_FULFILLED_BY_TYPES: 'Allowed application processes',
  [Product.CONSUMER_LOAN]: 'Consumer loan',
  [Product.AUTO]: 'Auto loan',
  [Product.CREDIT_LINE]: 'Credit line',
  [CustomLanguage.ENGLISH]: 'English',
  [CustomLanguage.SPANISH]: 'Spanish',
  FINANCIAL_ENTITIES: 'Financial entities',
  FINANCIAL_ENTITIES_CREDENTIALS: 'Financial entity credentials',
  FREE_PROGRAM: 'Standard program',
  ZERO_PROGRAM: 'Zero program',
  FREE_PROGRAM_SHORT: 'Standard',
  ZERO_PROGRAM_SHORT: 'Zero',
  SLIDE_TO_SEE_ALL_VALUES: 'Slide to see all values',
  CREATION: 'Creation',
  CREATED_AT_FOR_TABLE: 'Created at',
  PROGRAM: 'Program',
  PROGRAMS: 'Program(s)',
  MARKET: 'Market',
  OPTIONAL: 'optional',
  AGENT_IN_LENDER_CONTEXT_ID: 'Merchant ID',
  MERCHANT_ID_IN_LENDER_CONTEXT: 'Merchant ID',
  CHANNEL_ID_IN_LENDER_CONTEXT: 'Channel ID',
  AGENT_ID_IN_LENDER_CONTEXT: 'Agent ID',
  ALLOWED_PURCHASE_COUNTRIES: 'Allowed purchase countries',
  paymentMethodType: 'Payment method',
  PAYMENT_METHOD_TYPE: 'Payment method',
  ALLOWED_PAYMENT_METHODS: 'Allowed payment methods',
  ALL_PAYMENT_METHODS: 'All payment methods',
  FILTER_BY_PAYMENT_METHOD_AND_OTHERS: 'Filter rates by available filters',
  RELOAD_PRICINGS: 'Reload pricings',
  WITH: 'With',
  WITHOUT: 'Without',
  WITH_GRACE_PERIOD: 'With grace period',
  WITHOUT_GRACE_PERIOD: 'Without grace period',
  WITH_SETUP_FEE: 'With setup fee',
  WITHOUT_SETUP_FEE: 'Without setup fee',
  SEARCH_BY_PRICING_NAME: 'Search (pricing name)',
  LENDER_NOT_AVAILABLE_WARNING:
    'The financial entity $v1 is not available for this user. Contact Nemuru to configure the possibility of working with this financial entity.',

  USERNAME: 'Username',
  CLIENT_SECRET_OAUTH_2: 'Client secret (OAuth 2)',
  CLIENT_ID_OAUTH_2: 'Client ID (OAuth 2)',
  HAS_USERNAME_TOOLTIP: 'The current credentials stored on the platform contain a username',
  HAS_PASSWORD_TOOLTIP: 'The current credentials stored on the platform contain a password',
  HAS_CLIENT_ID_OAUTH_2_TOOLTIP: 'The current credentials stored on the platform contain a client_id',
  HAS_CLIENT_SECRET_OAUTH_2_TOOLTIP: 'The current credentials stored on the platform contain a client_secret',
  STORED_CREDENTIAL_FIELD_TOOLTIP: 'Already stored. Leave empty to keep unchanged.',
  STORED_VALUE_LABEL_SUFFIX: 'stored',

  ADD_CREDENTIALS: 'Add credentials',
  THE_FOLLOWING_CREDENTIALS_WILL_BE_DELETED: 'The following credentials will be deleted:',
  EDIT_CREDENTIALS: 'Edit credentials',
  DELETE_CREDENTIALS: 'Delete credentials',
  DELETE: 'Delete',
  NO_CREDENTIALS_SET: 'No credentials set yet',
  NO_AGENT_PRICINGS: 'No pricings assigned yet',
  MUST_BE_A_NUMERIC_VALUE: 'This value must be numeric',
  AGENT_CREATION_FOR_CHANNEL_X: 'You are creating a new agent for channel $v1',
  CREATE_AGENT: 'Create agent',
  UPDATE_AGENT: 'Update agent',
  ADD_AGENT: 'Add agent',
  IS_STATUS_ANALYSING_ENABLED: 'Risk analysis',
  SELECTED_PRICINGS: 'Selected pricings: $v1',
  REMOVE_PRICING_FROM_AGENT: 'Remove pricing from agent',
  REMOVE_PRICING_SPECS: 'Remove pricing codes',
  REMOVE_X_PRICING_SPECS: 'Remove $v1 pricing code(s)',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT: 'Add pricing code',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION: 'Enter details for the new pricing code you want to add',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION:
    'Select the pricing codes from financial entities you want to remove.',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT: 'Remove pricing code',
  PRICING_NAME_IN_LENDER_CONTEXT: 'Pricing code name',
  PRICING_VERSION: 'Version',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_PRICING_FROM_AGENT: 'Do you want to remove this pricing from the agent?',
  REMOVE_FROM: 'Remove',
  FILL_WITH_CHANNEL_AND_AGENT_DATA: 'Fill in with channel and agent data',
  THERE_ARE_NO_CHANNELS_FOUND_BY_SEARCH_PARAMS: 'No channels found matching the search parameters',
  NO_AGENTS_FOUND_BY_SEARCH_TERM: 'No agents found matching the search parameters',
  SET_ARTICLE_TYPE: 'Limit the article type',
  SET_ARTICLE_TYPE_EXPLANATION: 'Only use if you want to limit the article type for these credentials',

  // AGENT IN SINGLE PAYMENT PROVIDER CONTEXT
  SET_AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_CONFIGURATION: 'Add credential configuration',
  AGENT_IN_LENDER_CONTEXT_TAB_LABEL: 'Financed payments',
  AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_TAB_LABEL: 'Single payment',
  PROVIDER_ID_IN_PROVIDER_CONTEXT: 'Payment platform ID',
  AGENT_ID_IN_PROVIDER_CONTEXT: 'Agent ID',
  PROVIDER_ID: 'Payment platform',
  PROVIDERS_DETAILS: 'Configurations',
  [CredentialsType.AGENT_IN_LENDER_CONTEXT]: 'Credentials in financial entities',
  [CredentialsType.AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT]: 'Credentials in payment platforms',

  // AGENT PRICINGS

  PRICINGS: 'Pricings',
  ASSIGNED_PRICINGS: 'Assigned pricings',
  SEARCH_PRICING: 'Search pricing...',
  ASSIGN_PRICINGS_TO_AGENT: 'Modify assigned pricings',
  UPLOAD_PRICINGS_TO_CDN: 'Upload pricings to CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG: 'Upload pricings to CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_TEXT:
    'Do you want to upload the currently assigned pricings for this agent to the CDN?',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_BTN: 'Upload',

  PRICINGS_IN_CDN: 'Pricings uploaded to CDN',
  PRICINGS_IN_CDN_STATUS: 'Pricings status in CDN',
  NO_PRICINGS_UPLOADED_TO_CDN: 'No pricings uploaded to CDN',
  DOWNLOAD_PRICINGS_FROM_CDN: 'View pricings in CDN',

  UPLOADED_TO_CDN: 'Uploaded to CDN',
  NOT_UPLOADED_TO_CDN: 'Not uploaded to CDN',

  COPY_PRICING_ID: 'Copy Pricing ID',
  PRICING_NAME: 'Pricing name',
  RANGE_PRINCIPAL: 'Principal range',
  RANGE_PERIOD: 'Period range',
  LENDERS: 'Lenders',
  TAGS: 'Tags',

  SEE_PRICING_DETAIL: 'View pricing detail',

  [Program.FREE_PROGRAM]: 'Standard program',
  [Program.ZERO_PROGRAM]: 'Zero program',
  [Program.NO_PURCHASE]: 'No purchase',
  [Program.CAMPAIGN]: 'Campaign',
  NO_PURCHASE_SHORT: 'No purchase',

  [FeePaymentType.TYPE_UPFRONT]: 'Upfront',
  [FeePaymentType.TYPE_FINANCED]: 'Financed',
  [FeePaymentType.TYPE_FIXED_AMOUNT]: 'Fixed amount',

  RANGE_PRINCIPAL_MIN: 'Min principal',
  RANGE_PRINCIPAL_MAX: 'Max principal',
  RANGE_PERIOD_MIN: 'Min period',
  RANGE_PERIOD_MAX: 'Max period',
  ANNUAL_INTEREST: 'Annual interest',
  EXPENSES: 'Expenses',
  COST_MERCHANT: 'Merchant cost',
  MERCHANT_FEE: 'Merchant fee',
  GRACE_PERCENTAGE_PERIOD: 'Grace period (months)',
  LENDER_PRICING_NAME: 'Code',

  SEE_SELECTED_PRICINGS: 'View selected pricings',
  SET_PRICINGS_DIALOG: 'Modify assigned pricings',
  SET_PRICINGS_DIALOG_TEXT: 'Summary of changes to be made:',
  SET_PRICINGS_DIALOG_BTN: 'Modify',
  UNCHANGED_PRICINGS: 'Unchanged pricings',
  PRICINGS_TO_ADD: 'New pricings',
  PRICINGS_TO_REMOVE: 'Removed pricings',

  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_FULFILLED: 'Assigned pricings modified successfully',
  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_REJECTED: 'There was an issue while trying to modify assigned pricings',

  EDIT_AGENT_PRICINGS_RANGES: 'Edit pricing ranges',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG: 'Edit pricing ranges',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_TEXT: "Please select the new limits for agent's tariffs:",
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_BTN: 'Edit limits',
  MIN_PERIOD: 'Minimum period',
  MAX_PERIOD: 'Maximum period',
  MIN_PRINCIPAL: 'Minimum amount',
  MAX_PRINCIPAL: 'Maximum amount',
  [RangeType.PERIOD]: 'Period',
  [RangeType.PRINCIPAL]: 'Amount',

  MIN_PERIOD_CANNOT_BE_GREATER_THAN_MAX_PERIOD: 'Minimum period cannot be greater than maximum period',
  MIN_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_PRINCIPAL: 'Minimum amount cannot be greater than maximum amount',
  MIN_PERIOD_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PERIOD: 'Minimum period cannot be lower than $v1',
  MIN_PRINCIPAL_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PRINCIPAL: 'Minimum amount cannot be lower than $v1',
  MAX_PERIOD_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PERIOD: 'Maximum period cannot be greater than $v1',
  MAX_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PRINCIPAL: 'Maximum amount cannot be greater than $v1',
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_FULFILLED: "Agent's tariff ranges have been successfully modified.",
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_REJECTED: "There was a problem while trying to modify agent's tariff ranges",
  // Users
  ADD_USER: 'Add access credentials',
  BLOCK_ALL_USERS: 'Block all credentials',
  COPY_USER_ID: 'Copy user ID',
  BLOCK_STATUS: 'Status',
  BLOCKED: 'Blocked',
  UNBLOCKED: 'Unblocked',
  ROLES: 'Roles',
  SEND_FORGOT_PASSWORD_EMAIL: 'Send forgot password email',
  CHANGE_ROLES: 'Change roles',
  BLOCK_USER: 'Block credentials',
  UNBLOCK_USER: 'Unblock credentials',
  DO_YOU_WANT_TO_BLOCK_THE_FOLLOWING_USERS: 'Do you want to block the following credentials?',
  DO_YOU_WANT_TO_BLOCK_THE_USER: 'Do you want to block credentials for $v1?',
  DO_YOU_WANT_TO_UNBLOCK_THE_USER: 'Do you want to unblock credentials for $v1?',
  PASSWORD_RECOVERY_LIST: 'Password recovery emails sent',
  SEE_PASSWORD_RECOVERY_LIST: 'See password recovery emails sent',
  CAN_BE_USED_TO_CHANGE_PASSWORD: 'Can be used to change password',
  HAS_BEEN_USED: 'Has been used',
  COPY_EMAIL_ID: 'Copy password recovery ID',
  CHANGE_USER_BY_ID: 'Change user credentials by ID',
  CHANGE_USER_BY_ID_TEXT:
    'Enter the ID of the agent, channel, or merchant to which you want to move these credentials. Please make sure the ID is correct.',
  NEW_USER_ID: 'New user ID',
  BLOCK: 'Block',
  UNBLOCK: 'Unblock',
  BLOCK_USERS: 'Block credentials',
  OLD_PASSWORD: 'Current password',
  FORGOT_PASSWORD_EMAIL_RECOVERY_WILL_BE_SEND_TO_USER: 'Do you want to send a password recovery email to user $v1?',
  SEND_EMAIL: 'Send email',
  CHANGING_PASSWORD_FOR_USER: 'Changing password for $v1:',
  NO_ACTIONS_AVAILABLE: 'No actions available',
  USER_ROLE: 'User role',
  GENERATE_RANDOM_PASSWORD: 'Generate random password',
  TWO_FACTOR_AUTH: '2FA',
  [UserRowActionType.ADD_TWO_FACTOR_AUTH]: 'Enable 2-step verification (2FA)',
  [UserRowActionType.REMOVE_TWO_FACTOR_AUTH]: 'Disable 2-step verification (2FA)',
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    'Are you sure you want to enable 2-step verification for user $v1?',
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    'Are you sure you want to disable 2-step verification for user $v1?',
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_BUTTON`]: 'Enable',
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_BUTTON`]: 'Disable',

  SPY_USER: 'Spy user',
  [`SPY_USER_${UserType.AGENT}`]: 'Spy on this agent',
  [`SPY_USER_${UserType.CHANNEL}`]: 'Spy on this channel',
  [`SPY_USER_${UserType.MERCHANT}`]: 'Spy on this merchant',

  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.AGENT}`]:
    'Do you want to spy on this agent? Special credentials will be assigned to impersonate this agent. Use the email: spy@nemuru.com and the master password.',
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.CHANNEL}`]:
    'Do you want to spy on this channel? Special credentials will be assigned to impersonate this channel. Use the email: spy@nemuru.com and the master password.',
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.MERCHANT}`]:
    'Do you want to spy on this merchant? Special credentials will be assigned to impersonate this merchant. Use the email: spy@nemuru.com and the master password.',

  DO_YOU_WANT_TO_SPY_THIS_USER:
    'Do you want to spy on $v1? To impersonate this user, use the email: spy@nemuru.com and the master password.',

  CHANGE_USER: 'Change user credentials',
  CHANGE_USER_BTN: 'Change user credentials',
  NO_USERS_FOUND: 'No users found',
  SEARCH_FOR_MERCHANT_CHANNEL_AGENT_NAME: 'Search for Merchant, Channel, or Agent name or ID...',
  CONFIRM_CHANGE_TEXT: 'Are you sure you want to perform the following user change?',
  SELECTED_USER: 'Selected user',
  SELECT_WHERE_TO_MOVE: 'Select where you want to move it',
  CONFIRM_CHANGE: 'Confirm user change',
  CONFIRM_CHANGE_BTN: 'Confirm',
  YOU_WILL_CHANGE_THE_FOLLOWING_USER: 'You are going to change the following user:',

  //Loan detail view

  LOAN_ID: 'Loan ID:',
  LOAN_OVERVIEW: 'Loan Overview',
  PURCHASE_COUNTRY_TITLE: 'Purchase country:',
  [PurchaseCountry.ESP]: 'Spain',
  [PurchaseCountry.FRA]: 'France',
  [PurchaseCountry.MEX]: 'Mexico',
  [PurchaseCountry.BRA]: 'Brazil',
  [PurchaseCountry.ZAF]: 'South Africa',
  [PurchaseCountry.PRT]: 'Portugal',
  [PurchaseCountry.DEU]: 'Germany',
  APPLICATION: 'Application',
  CONSUMER_LOAN: 'Consumer Loan',
  PERSONAL_FINANCE: 'Personal Finance',
  CONTENTS: 'Contents',
  ALERTS: 'Alerts',
  USERS: 'Users',
  USERS_OF: 'Users of $v1',
  USER_CREDENTIALS: 'User Credentials',
  [`USER_CREDENTIALS_${UserType.AGENT}`]: 'Agent Credentials',
  [`USER_CREDENTIALS_${UserType.CHANNEL}`]: 'Channel Credentials',
  [`USER_CREDENTIALS_${UserType.MERCHANT}`]: 'Merchant Credentials',
  ACCOUNT: 'Account',
  FUNNEL: 'Funnel',
  MERCHANT_CHANNEL_AGENT_POS: 'Point of sale',
  PARTICIPANTS: 'Participants',
  ADD_PARTICIPANT: 'Add participant',
  BORROWER: 'Borrower',
  CO_BORROWER: 'Co-Borrower',
  GUARANTOR: 'Guarantor',
  [OnboardingDetailsRole.BORROWER]: 'Borrower',
  [OnboardingDetailsRole.CO_BORROWER]: 'Co-Borrower',
  [OnboardingDetailsRole.GUARANTOR]: 'Guarantor',
  PROGRESS: 'Progress',
  X_DAYS_LEFT: '$v1 days left',
  X_MONTHS: '$v1 months',
  MONTHS: 'months',
  SHOW_MORE: 'Show More',
  SHOW_LESS: 'Show Less',
  DESCRIPTION: 'Description',
  ADDRESS: 'Address',
  INTEREST: 'Interest',
  TOTAL_COST: 'Total cost',
  TOTAL_COST_WITH_UPFRONT_PERCENTAGE: 'Total Cost ($v1 setup fee)',
  TOTAL_COST_WITH_FINANCED_PERCENTAGE: 'Total Cost ($v1 financed)',
  TOTAL_COST_WITH_FIXED_AMOUNT_VALUE: 'Total Cost ($v1 per instalment)',
  INTERESTS_TO_PAY: 'Total Interests',
  TIN: 'TIN',
  TAE: 'TAE',
  PRODUCT: 'Product',
  TERM: 'Term',
  MONTHLY_QUOTA: 'Monthly Quota',
  DOWN_PAYMENT: 'Down payment',
  CASH_PRICE: 'Cash price',
  TOTAL_DISCOUNT: 'Discount',
  DISCOUNT: 'Discount ($v1)',
  MERCHANT_TOTAL_TO_COLLECT: 'Total to collect',
  PRINCIPAL_AMOUNT: 'Loan Amount',
  TOTAL_AMOUNT_TO_PAY: 'Total Amount to Pay',
  CREDIT_LINE_AMOUNT: 'Credit Line Amount',
  CREDIT_LINE: 'Credit Line',
  CREDIT_LINE_WITH_PURCHASE: 'Credit Line with Purchase',
  WITH_ANNUAL_INTERESTS: 'With Interests',
  NO_ANNUAL_INTERESTS: 'No Interests',
  SETUP_FEE: 'Setup Fee',
  SPLIT_PAY: 'Split pay',
  INSTALMENTS: 'Pay in instalments',
  COPY_LOAN_ID: 'Copy Loan ID',
  COPY_CONSUMER_LOAN_ID: 'Copy Consumer Loan ID',
  COPY_AUTO_ID: 'Copy Auto Loan ID',
  COPY_CREDIT_LINE_ID: 'Copy Credit Line ID',
  COPY_ORDER_ID: 'Copy Order ID',
  COPY_ARTICLE_ID: 'Copy Article ID',
  ID_COPIED_SUCCESSFULLY: 'ID copied successfully',
  COPY_SUCCESSFUL: 'Copied to clipboard',
  COPY_LENDER_REQUEST_ID: 'Copy Lender Request ID',
  FILE_NOT_FOUND: 'File not found',
  RESPONSE: 'Response',
  DESIST: 'Desist',
  DESIST_LOAN: 'Desist loan application',
  DESIST_LOAN_BTN: 'Desist',
  REFUND: 'Process refund',
  CANCEL_TEST: 'Cancel as test',
  CANCEL_TEST_BTN: 'Cancel as test',
  CANCEL_LOAN: 'Cancel loan application',
  CANCEL_LOAN_BTN: 'Cancel loan',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED: 'Do you wish to mark this application as cancelled?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED_TEST:
    'Do you wish to mark this application as test cancelled?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_DESISTED: 'Do you wish to mark this application as desisted?',
  PLEASE_SELECT_THE_REASON_WHY_YOU_ARE_DESISTING_THIS_LOAN: 'Please select the reason for desisting this loan.',
  DESIST_REASON: 'Desist reason',
  RESEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Resend contract signature to borrower',
  ARE_YOU_SURE_YOU_WANT_TO_RESEND_CONTRACT_SIGNATURE_TO_BORROWER:
    'Do you want to resend the contract signature to the borrower?',
  RESEND_CONTRACT: 'Resend contract',
  SEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Send contract for signature to borrower',
  ARE_YOU_SURE_YOU_WANT_TO_SEND_CONTRACT_SIGNATURE_TO_BORROWER:
    'Do you want to send the contract signature to the borrower?',
  SEND_CONTRACT: 'Send contract for signature',
  SET_CONTRACT_SIGNED: 'Mark contract as signed',
  ARE_YOU_SURE_YOU_WANT_TO_SET_LOAN_LENDER_BORROWER_CONTRACT_TO_SIGNED:
    'Are you sure you want to mark the contract for this request as signed?',
  SET_CONTRACT_SIGNED_BUTTON: 'Mark as signed',
  FORMALIZE_APPLICATION: 'Formalize application',
  DO_YOU_WISH_TO_FORMALIZED_THIS_APPLICATION: 'Do you wish to mark this application as formalized?',
  FORMALIZE_APPLICATION_BTN: 'Formalize application',
  MARK_LOAN_AS_PAID: 'Mark loan as paid',
  DO_YOU_WISH_TO_MARK_THIS_LOAN_AS_PAID: 'Do you wish to mark this loan as paid?',
  MARK_LOAN_AS_PAID_BTN: 'Mark as paid',
  GRACE_PERIOD: 'Grace period',
  OPT_OUT_NOTIFICATIONS: 'Opt out notifications',
  OPT_OUT_NOTIFICATIONS_DESCRIPTION: 'Do you wish to opt out notifications for $v1?',
  OPT_OUT_NOTIFICATIONS_BTN: 'Opt out',

  [LoanDesistReason.BANK_READER]: 'Bank reader',
  [LoanDesistReason.DO_NOT_TRUST_IN_NEMURU]: 'Do not trust in nemuru',
  [LoanDesistReason.NO_FINANCING_WANTED]: 'No financing wanted',
  [LoanDesistReason.MERCHANT_SERVICE_IS_EXPENSIVE]: 'Merchant service is expensive',
  [LoanDesistReason.NEMURU_IS_EXPENSIVE]: 'Nemuru is expensive',
  [LoanDesistReason.DO_NOT_WANT_THE_SERVICE]: 'Do not want the merchant service',
  [LoanDesistReason.NEMURU_APP_IS_NOT_WORKING]: 'Nemuru app is not working',
  [LoanDesistReason.NEMURU_PROCESS_IS_COMPLICATED]: 'Nemuru process is complicated',
  [LoanDesistReason.ALTERNATIVE_FINANCIAL_INSTITUTION]: 'Alternative financial institution',
  [LoanDesistReason.WILL_DO_IT_LATER]: 'Will do it later',
  [LoanDesistReason.WILL_DO_IT_WITH_ANOTHER_MERCHANT]: 'Will do it with another merchant',
  [LoanDesistReason.NOT_CONTACTABLE]: 'Not contactable',
  [LoanDesistReason.CANNOT_AFFORD]: 'Cannot afford',
  [LoanDesistReason.LOAN_CONTRACT_TERMS]: 'Loan contract terms',
  [LoanDesistReason.MERCHANT_BAD_SERVICE]: 'Merchant bad service',
  [LoanDesistReason.MERCHANT_CURN_BEHAVIOUR]: 'Merchant current behaviour',
  [LoanDesistReason.WRONG_BUDGET_MANAGEMENT]: 'Wrong budget management',
  [LoanDesistReason.LENDER_PROCEDURES]: 'Lender procedures',
  [LoanDesistReason.OTP_NOT_RECEIVED]: 'Otp not received',
  [LoanDesistReason.SCA_ERROR]: 'Sca error',
  [LoanDesistReason.ORDER_CONFIRMATION_NOT_COMPLETED]: 'Order confirmation not completed',
  [LoanDesistReason.DO_NOT_UNDERSTAND_FUTURE_PAYMENTS]: 'Do not understand future payments',
  [LoanDesistReason.UNKNOWN]: 'Unknown',

  ORDER_OVERVIEW: 'Order detail',
  MERCHANT_REFERENCE_1: 'Merchant reference #1',
  REFERENCE_1: 'Reference #1:',
  CREATED_AT: 'Created at:',
  CLIENT_CONTACT_EMAIL: 'Client email:',
  UNITS: 'Units',
  UNIT_PRICE_WITH_TAX: 'Unit price with tax',
  AMOUNT_WITH_TAX: 'Amount with tax',
  SEE_DETAIL: 'See detail',
  REFERENCE: 'Reference',
  ARTICLE: 'Article',
  FLIGHT: 'Flight',
  ONLINE_PRODUCT: 'Online product',
  SERVICE: 'Service',
  ACCOMMODATION: 'Accommodation',
  TRAVEL: 'Travel',
  TRAVEL_CATEGORY: 'Travel category',
  DESTINATION: 'Destination',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  TRAVELLERS: 'Number of travellers',
  CARRIER_CODE: 'Carrier code',
  FLIGHT_CODE: 'Flight number',
  CABIN_CLASS: 'Cabin class',
  FARE_BASIS: 'Fare basis',
  ORDER_LINES: 'Order lines',
  REFERENCES: 'References',
  MERCHANT_ORDER_REFERENCE_1: 'Merchant order reference 1',
  MERCHANT_ORDER_REFERENCE_2: 'Merchant order reference 2',
  SERVICE_END_DATE: 'Service end date',
  SUMMARY: 'Summary',
  CAPTURES_AND_REFUNDS: 'Captures and refunds',
  TRANSACTION_HISTORY: 'Transaction history',
  DETAILS: 'Details',
  PROCESSING: 'Processing',
  PROCESSING_WITH_DOTS: 'Processing...',
  CONTINUE: 'Continue',
  CONTINUE_BY: 'Continue by $v1',
  NO_CART_INFORMATION_AVAILABLE: 'No cart information available',
  NO_ACTIVITY_INFORMATION_AVAILABLE: 'No activity information available',
  CHECK_IN_DATE: 'Check-in date',
  CHECK_OUT_DATE: 'Check-out date',
  NUMBER_OF_GUESTS: 'Number of guests',
  LAST_CARTS: 'Last carts',
  LAST_THREE_DAYS: 'Last 3 days',
  LAST_TWO_WEEKS: 'Last 2 weeks',
  REMOVE_CART: 'Remove cart',
  REMOVE_CART_DESCRIPTION: 'Are you sure you want to delete the cart with the following items?',

  //PAY_BY_LINK
  PAY_BY_LINK_DETAIL: 'Order Details',

  //Payment method
  PAYMENT_METHOD: 'Payment Method',
  PAYMENT_ATTEMPTS: 'Card Payment Attempts',
  PAYMENT_ATTEMPT_STATUS: 'Event',
  PAYMENT_ATTEMPT_FAIL_REASON: 'Rejection Reason',
  PAYMENT_ATTEMPT_CREATED_AT: 'Date',
  [PaymentAttemptStatus.PAYMENT_SUCCESSFUL]: 'Payment accepted',
  [PaymentAttemptStatus.PAYMENT_FAILED]: 'Payment rejected',
  [PaymentAttemptStatus.SCA_LOADED]: 'SCA loaded',
  [PaymentAttemptStatus.SCA_CLOSED]: 'SCA closed',
  [PaymentAttemptStatus.PAYMENT_CANCELLED]: 'Payment cancelled',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.AUTHENTICATION}`]: 'There was an issue during SCA step',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE}`]: "Payment couldn't be processed",
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.GENERIC}`]: 'Other error occurred',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE_PROCESSING}`]:
    'Authorization or tokenization was not possible',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.USE_A_DIFFERENT_CARD}`]: "There's an issue with the card",
  CASH_IN_CASH_OUT_METHOD_TYPE: 'Payment Method Type',
  [CashInCashOutType.BANK_ACCOUNT]: 'Bank account',
  [CashInCashOutType.SAVING_BANK_ACCOUNT]: 'Savings bank account',
  [CashInCashOutType.FLYWIRE]: 'Flywire',
  HOLDER: 'Holder',

  //Payment plan
  PAYMENT_PLAN: 'Payment Plan',
  PAYMENT_PLAN_TABLE: 'Instalments',
  DUE_DATE: 'Due Date',
  PAYMENT_DATE: 'Payment Date',
  OVERDUE: 'Overdue',
  PAYMENT_PLAN_LINE_ID: 'Instalment ID',
  PAYMENT_PROVIDER: 'Payment Method',
  PAYMENT_PLAN_STATUS: 'Payment Plan Status',
  [PaymentProvider.DIRECT_DEBIT]: 'Direct debit',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PENDING}`]: 'Pending',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PROCESSING}`]: 'Payment initiated',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PAID}`]: 'Paid',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.CANCELLED}`]: 'Cancelled',
  [`PAYMENT_PLAN_LINE_${OverduePlanLineStatus.OVERDUE}`]: 'Overdue',
  NO_PAYMENT_PLAN_AVAILABLE: 'No payment plan available for this request',
  NO_PAYMENT_ATTEMPTS_REGISTERED: 'No payment attempts registered',
  ROWS_PER_PAGE: 'Rows per page',
  SENT_DATE: 'Payment Request Date',
  COPY_PAYMENT_LINE_ID: 'Copy instalment ID',
  SEND_PAYMENT_NOTIFICATION: 'Send Payment Request Email',
  PAYMENT_NOTIFICATION_TEXT: 'Would you like to send an email requesting payment for this instalment to the customer?',
  QUOTA_NUMBER: 'Instalment Number',
  SEE_PAYMENT_ATTEMPTS: 'View Payment Attempts',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE: 'Change Due Date',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE: 'Change Payment Date',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT: 'Change Amount',
  UPDATE_PAYMENT_PLAN_LINE_STATUS: 'Change Status',
  PAYMENT_LINE_STATUS: 'Instalment Status',
  PAYMENT_NOTIFICATION: 'Send payment request email',
  PAYMENT_NOTIFICATION_BTN: 'Send email',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_TEXT: 'Select the new instalment due date',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_BTN: 'Change date',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_TEXT: 'Select the new instalment payment date',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_BTN: 'Change date',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_TEXT: 'Enter the new instalment amount',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_BTN: 'Change amount',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_TEXT: 'Select the new instalment status',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_BTN: 'Change status',

  //Activity
  TOTAL_ORDER: 'Total order',
  PENDING_CAPTURE: 'Pending capture',
  PENDING_TO_CAPTURE: 'Pending capture',
  TOTAL_CAPTURED: 'Total captured',
  TOTAL_REFUNDED: 'Total refunded',
  BILLED: 'Billed',
  TOTAL_FEES: 'Total fees',
  TOTAL_PAID: 'Total paid',
  PENDING: 'Pending',
  PENDING_INFORMATION: 'Pending...',
  AMOUNT: 'Amount',
  TOTAL: 'Total',
  CAPTURED: 'Captured',
  CAPTURE: 'Capture',
  ORDER_APPROVED: 'Approved',
  APPROVED: 'Pre-approved',
  REFUNDED: 'Refunded',
  PRODUCTS: 'Products',
  SALE: 'Sale',
  ORDER_ACTIVITY: 'Activity',
  REFUNDED_AMOUNT: 'Refunded amount',
  CAPTURE_NUMBER: 'Capture no. $v1',
  REFUND_NUMBER: 'Refund no. $v1',
  PAYOUT_NUMBER: 'Payout no. $v1',
  ORDER_CREATED: 'Order created',
  REFERENCE_1_TOOLTIP_TEXT: "Merchant's main order reference",
  REFERENCE_2_TOOLTIP_TEXT: "Merchant's optional order reference",
  PASSENGERS: 'Passengers ($v1)',
  SEGMENTS: 'Segments ($v1)',
  IN_REFERENCE_TO: 'In reference to:',
  CANCEL_PAYMENT_PLAN: 'Cancel payment plan',
  CANCEL_PAYMENT_PLAN_TEXT: 'Are you sure you want to cancel the payment plan?',

  //PAYOUTS
  PAYMENTS: 'Payments',
  PAYOUT: 'Payout',
  PAYOUTS: 'Payouts',
  PAYER: 'Payer',
  issue_date: 'Issue date',
  VAT_ON_FEES: 'VAT on fees ($v1)',
  VAT_ON_ADJUSTMENTS: 'VAT on adjustments ($v1)',
  PAYOUTS_LIST: 'Payouts list',
  MERCHANT_ID: 'Merchant ID',
  ADJUSTMENTS_AMOUNT: 'Adjustments amount',
  DISBURSED_AMOUNT: 'Disbursed amount',
  PAYOUT_STATUS: 'Payout status',
  [PayoutStatus.DISBURSED]: 'Disbursed',
  [PayoutStatus.IN_REVIEW]: 'In review',
  [PayoutStatus.PUBLISHING]: 'Publishing',
  [PayoutStatus.PUBLISHED]: 'Published',
  PAYMENT: 'Payment',
  PAYOUT_DETAILS_OVERVIEW: 'Payout details overview',
  TRANSACTIONS: 'Transactions',
  TRANSACTIONS_VIEW: 'Transactions view',
  SALES: 'Sales',
  REFUNDS: 'Refunds',
  FIXED_FEES: 'Fixed fees',
  VARIABLE_FEES: 'Variable fees',
  ADJUSTMENTS: 'Adjustments',
  TOTAL_ADJUSTMENTS: 'Total adjustments',
  LENDER_NAME: 'Lender name',
  PAYOUT_REFERENCE: 'Payout reference',
  PAYOUT_DATE: 'Payout date',
  MERCHANT_NAME: 'Merchant name',
  VAT: 'VAT',
  COPY_PAYMENT_ID: 'Copy payment ID',
  PAYOUT_DETAILS_NOT_FOUND: 'Payout details not found',

  //REPORTS
  REPORTS: 'Reports',
  REPORTS_LIST: 'Reports list',
  REPORT: 'Report',
  REPORT_DATE: 'Report date',
  REPORT_DETAILS_OVERVIEW: 'Summary',
  ENTITY: 'Entity',
  BATCH_NUMBER: 'Batch Number',
  DOWNLOAD: 'Download',
  TOTAL_DISBURSED_AMOUNT: 'Total Disbursed Amount',

  // TRANSACTIONS
  TRANSACTIONS_LIST: 'Transactions list',
  TRANSACTION_TYPE: 'Transaction type',
  VAT_RATE: 'VAT rate',
  VAT_AMOUNT: 'VAT amount',
  COPY_TRANSACTION_ID: 'Copy transaction ID',
  ORDER_ID: 'Order ID',
  [TransactionType.REFUND]: 'Refund',
  [TransactionType.DEBT_BALANCE]: 'Debt balance',
  [TransactionType.FIXED_FEE]: 'Fixed fee',
  [TransactionType.VARIABLE_FEE]: 'Variable fee',
  [TransactionType.COST_OF_CREDIT]: 'Cost of credit',
  [TransactionType.FEE_CORRECTION]: 'Fee correction',

  //LENDER LOAN APPLICATIONS
  LENDER_APPLICATIONS: 'Lender responses',
  LENDER_X_APPLICATION: 'Lender response for $v1',
  LENDER_STATE: 'Lender state',
  LENDER_CONTRACT_SENT: 'Contract sent by lender',
  LENDER_CONTRACT_SIGNED: 'Contract signed by lender',
  SENT_AT: 'Sent date',
  SIGNED_AT: 'Signed date',
  LENDER_REQUEST_ID: 'Lender request ID',
  LENDER_REQUEST_ID_2: 'Lender request ID',
  LAST_UPDATED_AT: 'Last updated date',
  PROCESSING_SUCCESSFUL: 'Processed successfully',
  PROCESSING_DID_NOT_ALTER_APPLICATION: 'The result did not alter this application',
  PROCESSING_DID_UPDATE_THE_APPLICATION_SUCCESSFULLY: 'The application was updated successfully',
  PROCESS: 'Process',
  SELECTED_LENDER: 'Selected lender',
  NO_RESPONSE_FROM_LENDER: 'No response from the lender',
  LENDER_IS_PROCESSING_THE_APPLICATION: 'The entity is processing the application',
  LENDER_IS_PROCESSING_THE_APPLICATION_TRY_AGAIN_LATER:
    'The entity is processing the application at the moment. Refresh this page in a few moments to see the updated status.',
  SELECTED_LENDER_APPLICATION: 'Selected',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.NOT_PROCESSED}`]: 'Not processed',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.PROCESSED}`]: 'Processed',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.SELECTED}`]: 'Selected',
  PENDING_TO_COMPLETE_PAYMENT: 'Pending to complete',
  PENDING_TO_SELECT_PAYMENT_METHOD: 'Pending payment method selection',
  NO_RESPONSE: 'No response',
  ANSWERED_YES: 'Accepted',
  ANSWERED_NO: 'Denied',
  IN_STUDY: 'In study',
  SELECT_A_LOAN_APPLICATION: 'Select a lender',
  SELECT_A_LOAN_APPLICATION_TEXT: 'Click the button to select the lender and complete the application process.',
  LENDER_X_ANSWERED_X_TO_APPLICATION: 'Lender $v1 responded with "$v2" to the application',
  PROCESS_TOOLTIP: 'Manually process the application with the lender',
  loan_application_error: 'Lender error',
  UN_SIGN: 'Unsign',
  MODIFY: 'Modify',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT: 'Unsign borrower contract',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_DESCRIPTION:
    'Do you want to unsign the existing contract? The application will return to the previous state and contract signing data will be removed.',
  OPEN_PROCESS_RESPONSE_FOLDER: 'Open response files',
  SET_LENDER_REQUEST_ID: 'Modify request ID',
  SET_LENDER_REQUEST_ID_DESCRIPTION:
    'Do you want to modify the request ID with the lender? Modifying the ID will reprocess the application data for this new ID',
  CHANGE_LENDER_APPROVAL_STATUS: 'Modify approval status',
  CHANGE_LENDER_APPROVAL_STATUS_DESCRIPTION: 'Select the new approval status with the lender',
  LENDER_APPROVAL_STATUS: 'Lender approval status',
  [LenderApprovalStatus.MAYBE]: 'In study',
  UPDATE_LOAN_APPLICATION: 'Update',
  UPDATE_LOAN_APPLICATION_IN_LENDER: 'Update co-borrower in lender',
  UPDATE_LOAN_APPLICATION_IN_LENDER_DESCRIPTION:
    'Do you want to update the data of the co-borrower(s) of the application in lender?',
  SELECTED_LOAN_APPLICATION: 'Selected loan application',
  ERROR_FETCHING_ERROR_RESPONSE: 'Error fetching error response. Please try again later.',
  ANALYSING_ERROR_RESPONSE: 'Analysing error in $v1...',

  [LenderName.ABANCA]: 'Abanca',
  [LenderName.APLAZAME]: 'Aplazame',
  [LenderName.ATRATO]: 'Atrato',
  [LenderName.BBVA]: 'BBVA Consumer Finance',
  [LenderName.BS]: 'Sabadell Consumer Finance',
  [LenderName.CAIXABANK]: 'CaixaBank P&C',
  [LenderName.CETELEM]: 'Cetelem',
  [LenderName.CETELEM_PF_CONNECT]: 'Cetelem PF Connect',
  [LenderName.COFIDIS]: 'Cofidis',
  [LenderName.FINONLINE]: 'Finonline',
  [LenderName.FLOA]: 'FLOA',
  [LenderName.KOIN]: 'Koin',
  [LenderName.KUESKI]: 'Kueski',
  [LenderName.NEMURU]: 'Nemuru finance',
  [LenderName.PEPPER]: 'Pepper',
  [LenderName.SANTANDER_CONSUMER]: 'Santander Consumer Finance',
  [LenderName.SEQURA]: 'SeQura',
  [LenderName.SEQURA_QUIX]: 'Quix',
  [LenderName.SOYOU]: 'Sofinco',

  RISK_ANALYSIS: 'Risk Analysis',
  ASSESSMENT_RESULT: 'Recommendation',
  UNPAID_OPERATIONS: 'Unpaid operations',
  NO_RISK_SCORING_AVAILABLE: 'No risk analysis available',
  WHAT_IS_RECOMMENDATION: (
    <>
      <p>Result of the customer's risk assessment based on established rules. It can take the following values:</p>
      <li>Green: Favorable analysis, customer with a good risk profile.</li>
      <li>Yellow: To review, customer with a poor risk profile but no defaults.</li>
      <li>Red: Unfavorable analysis, customer with a poor risk profile and defaults.</li>
    </>
  ),
  WHAT_IS_SCORING: (
    <>
      <p>Indicates the level of default risk of the customer. It can take the following values:</p>
      <ul>
        <li>Very High Risk (1)</li>
        <li>High Risk (2)</li>
        <li>Medium Risk (3)</li>
        <li>Medium/Low Risk (4)</li>
        <li>Low Risk (5)</li>
        <li>Very Low Risk (6)</li>
      </ul>
    </>
  ),

  RISK_ASSESSMENT_FAILED_DUE_TO_THE_FOLLOWING_REASONS: ' risk assessment failed due to the following reasons:',
  RESULTS: 'Results',
  NO_RISK_INFORMATION: 'No risk information found',
  NO_REASONS_GIVEN: 'No reasons given',
  RISK_SCORE: 'Risk Analysis',
  PASSED: 'Passed',
  RISK_SCORE_FAILED: 'Failed',
  AML_RISK: 'AML',
  BANK_READER_RISK: 'Bank Reader',
  CHECK_FAILED_REASONS: 'See rejection reasons',
  ASSESSMENT_FAILURE_REASONS: 'Risk analysis rejection reasons',
  aml_reject_FoundInLists: 'The borrower is listed in AML lists',
  br_reject_lifestyle_indebtedness: 'Lifestyle indebtedness',
  br_reject_lowPositiveBalanceLastMonth: 'Low score due to low positive balance last month',
  br_reject_lowPositiveBalanceAntiquity: 'Low score due to low positive balance antiquity',
  br_reject_lastMontsIncomingStatementLessThan3: 'Less than 3 inoming statements',

  // STATUS back
  status_initial: 'Started',
  status_analysing: 'Requested',
  status_lender_has_been_selected: 'Pre-approved',
  status_contract_signed: 'Contract Signed (to be formalized)',
  status_docs_approved: 'Confirmed',
  status_active_trial: 'Paid',
  status_active: 'Paid',
  status_denied: 'Denied',
  status_desisted: 'Desisted',
  status_ended: 'Ended',
  status_expired: 'Expired',
  status_unpaid: 'Unpaid',
  status_cancelled: 'Cancelled',
  status_cancelled_test: 'Test Cancelled',

  //FUNNEL
  TOTAL_AMOUNT: 'Total amount',
  TOTAL_NUMBER: 'Total number',
  SEARCH_BY_LENDER: 'Lender',
  MINIMUM_AMOUNT: 'Minimum amount',
  MAXIMUM_AMOUNT: 'Maximum amount',
  ALL_PRODUCTS: 'All products',
  MORE_THAN_24_H: 'More than 24h',
  MORE_THAN_3_DAYS: 'More than 3 days',
  MORE_THAN_A_WEEK: 'More than 1 week',
  MORE_THAN_A_MONTH: 'More than 1 month',
  LOAN_APPLICATION_ERRORS: 'Lender response errors',
  DOCUMENTATION_INCIDENCES: 'Documentation incidences',
  FILTER_LOANS_WITH: 'Filter loans with:',
  NO_FUNNEL_DATA: 'No funnel data to display',
  WITH_INCIDENCE: 'With incidence',
  WITH_ERROR: 'With error',
  SCHEDULED_DELIVERY_DATE: 'Delivery date',
  SCROLL_TO_SELECTION_RESULTS_SHORT: 'Show results',
  SCROLL_TO_SELECTION_RESULTS: 'Scroll to selection results',

  // Table filters
  WITH_DOCUMENTARY_INCIDENCE: 'With documentary incidence',
  VIN_INFORMED: 'VIN informed',
  DELIVERY_DATE_INFORMED: 'Delivery date informed',
  STATE: 'State',
  OTHER_FILTERS: 'Other filters',
  RESET_FILTERS: 'Reset filters',

  // STEPS
  NO_RESULTS_TO_SHOW: 'No results',
  CUSTOM_GROUP: 'Custom group',

  // STEPS
  UNOPENED: 'Unopened',
  OPENED: 'SMS opened',
  FINANCIAL_INFORMATION: 'Financial information',
  PROFESSIONAL_INFORMATION: 'Professional information',
  RISK_INFORMATION: 'Risk information',
  CONTRACT_NOT_SENT: 'Contract not sent',
  CONTRACT_SENT: 'Contract sent',
  VALIDATING_DOCUMENTATION: 'To be formalized',

  // STATUS front
  status_opened: 'SMS opened',
  status_KYC_set: 'Personal information',
  status_income_set: 'Financial information',
  status_professional_details_set: 'Professional information',
  status_risk_set: 'Risk information',
  status_contract_sent: 'Contract sent',

  //STATUS Order
  started: 'Started',
  initial: 'Started',
  approved: 'Pre-approved',
  confirmed: 'Confirmed',
  captured: 'Captured',
  on_hold: 'On Hold',
  denied: 'Denied',
  cancelled: 'Cancelled',
  cancelled_test: 'Cancelled',
  desisted: 'Desisted',
  expired: 'Expired',
  paid: 'Paid',

  LOAN_STATUS_EXTERNAL: 'Status',
  DEFAULT_STATUSES: 'Default Statuses',

  //ORDER

  ORDER: 'Order',
  ORDER_STATUS_INITIAL: 'Personal information',
  ORDER_STATUS_ANALYSING: 'Pending otp',
  ORDER_STATUS_LENDER_HAS_BEEN_SELECTED: 'Pending card payment',
  TOTAL_ORDER_AMOUNT: 'Total order amount',
  TOTAL_CAPTURED_AMOUNT: 'Total captured amount',
  TOTAL_REFUNDED_AMOUNT: 'Total refunded amount',
  FROM_X_CAPTURES_AND_X_REFUNDS: 'From $v1 capture(s) and $v2 refund(s)',
  CATEGORY: 'Category',
  FROM: 'From',
  NO_ASSOCIATED_ITEMS: 'No associated items',
  OTP: 'SMS Code',
  MOBILE_VERIFICATION: 'Phone verification',
  OTP_PENDING: 'Pending OTP',
  DOWNPAYMENT: 'Downpayment',
  requested: 'Requested',

  PERSONAL_INFO_PENDING: 'Pending to fill in personal info',
  RESPONSE_PENDING: 'Pending lender response',
  CONFIRMATION_PENDING: 'Pending confirmation',
  CAPTURE_PENDING: 'Pending capture',
  PAYMENT_PENDING: 'Pending payment',
  APPLICATION_COMPLETED: 'Application completed',

  BRAND: 'Brand',
  MODEL: 'Model',
  version: 'Version',
  LICENSE_PLATE_NUMBER: 'License plate',
  IDENTIFICATION_NUMBER: 'Identification Number',
  IDENTIFICATION_NUMBER_MUST_BE_17_CHARACTERS: 'The identification number must be 17 characters',
  INVALID_SPANISH_LICENSE_PLATE: 'The license plate introduced is invalid.',
  REGISTRATION_DATE: 'Registration Date',
  VEHICLE_TYPE: 'Vehicle Type',
  ODOMETER: 'Odometer',
  MAX_POWER: 'Max Power',
  ENGINE: 'Engine',
  BODY_TYPE: 'Body Type',
  KM: 'Km',
  CM_3: 'cm3',
  CV: 'Cv',
  FUEL_TYPE: 'Fuel Type',
  GEAR_TYPE: 'Gear Type',
  IS_NEW_VEHICLE: 'New Vehicle',
  IMPORTED: 'Imported',
  manual: 'Manual',
  automatic: 'Automatic',
  gasoline: 'Gasoline',
  diesel: 'Diesel',
  electric: 'Electric',
  hybrid: 'Hybrid',
  compressed_natural_gas: 'CNG',
  ethanol: 'Ethanol',
  others: 'Others',
  electric_hybrid: 'Electric Hybrid',
  type_of_vehicle: 'Type of Vehicle',
  calculate_loan: 'Calculate Loan',
  hatchback: 'Hatchback',
  sedan: 'Sedan',
  suv: 'SUV',
  coupe: 'Coupe',
  convertible: 'Convertible',
  wagon: 'Wagon',
  station_wagon: 'Station Wagon',
  minivan: 'Minivan',
  four_by_four: '4x4',
  cabrio: 'Cabrio',
  pick_up: 'Pick-up',
  camper_van: 'Camper Van',
  car: 'Car',
  off_road: 'Off-Road',
  industrial: 'Industrial',

  ASSET_DETAILS: 'Product information',
  AUTO_ASSET_DETAILS: 'Vehicle information',
  AUTO_DETAILS: 'Vehicle details',
  VEHICLE_AMOUNT: 'Vehicle amount',
  DOWN_PAYMENT_DOCUMENT: 'Downpayment proof',
  TOTAL_COURSE_AMOUNT: 'Course amount',
  SCHOLARSHIP: 'Scholarship',
  COURSE_DOWNPAYMENT: 'Course downpayment',
  COURSE_START_DATE: 'Course start date',
  COURSE_END_DATE: 'Course end date',
  WORKSITE_ADDRESS: 'Reform address',
  [AssetType.EDUCATION]: 'Education',
  [AssetType.HOME_IMPROVEMENT]: 'Home',
  [AssetType.UTILITIES_SUPPLY]: 'Utilities Supply',
  [AssetType.HEALTH]: 'Health',
  [AssetType.TRAVEL]: 'Travel',

  BORROWER_INVITATION: 'Contact Data',
  EDIT_BORROWER_INVITATION: 'Edit contact data',
  NO_INFORMATION_PROVIDED: 'No information provided',
  PENDING_INFORMATION_FROM_BORROWER_ONBOARDING: 'No client information provided yet',
  PENDING_DOCUMENTATION_FROM_BORROWER_ONBOARDING: 'No client documentation provided yet',
  PENDING_FOR_FINANCIAL_INFORMATION_FROM_BORROWER_ONBOARDING: 'No client financial information provided yet',
  PENDING_FOR_ADDRESS_INFORMATION: 'No address information provided yet',

  DOCUMENT_NUMBER: 'Document number',
  EXPIRES_ON: 'Expires on',
  RELATION: 'Relation',
  [Relation.SPOUSE]: 'Spouse',
  [Relation.SIBLING]: 'Sibling',
  [Relation.PARENT]: 'Parent',
  [Relation.SON]: 'Son',
  [Relation.REST_OF_FAMILY]: 'Other family',
  [Relation.OTHER]: 'Other',

  PHONE_VERIFICATION: 'Phone verification',
  PHONE_VERIFICATION_SHORT: 'Phone verification',

  OTP_STATUS: 'Verification status',
  RECEIVED_CODE: 'Entered code',
  RECEIVED_CODE_DATE: 'Date',
  [OtpStatus.ACCEPTED]: 'Accepted',
  [OtpStatus.NOT_PROCESSED]: 'Not processed',
  [OtpStatus.REJECTED]: 'Rejected',

  SENT_CODES: 'Sent codes',
  SENT_CODE_CODE: 'Code',
  SENT_CODE_STATUS: 'Sms status',
  SENT_CODE_STATUS_SHORT: 'Status',
  SENT_CODE_PROVIDER_NAME: 'Sms provider',
  SENT_CODE_DATE: 'Date',
  [SentCodeStatus.PENDING]: 'Pending',
  [SentCodeStatus.DELIVERED]: 'Delivered',
  [SentCodeStatus.FAILED]: 'Failed',

  FIRST_INSTALMENT_PAID: 'First instalment paid',

  //DOCUMENT ID DETAILS
  NO_IMAGE: 'No image',
  LOADING_IMAGE: 'Fetching image ...',
  NO_DOCUMENT: 'No document',
  LOADING_DOCUMENT: 'Fetching document ...',
  ONBOARDING_DETAILS: 'Customer information',
  FULFILLED_BY_MERCHANT_POS_DESCRIPTION: "Customer's personal information has been provided by the authorized merchant",
  DOCUMENT_ID: 'Identity document',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  FULL_NAME: 'Full name',
  DOCUMENT_TYPE: 'Document type',
  DOCUMENT_ID_NUMBER: 'Document number',
  DOCUMENT_ID_NUMBER_SHORT: 'Document',
  GENDER: 'Gender',
  [Gender.M]: 'Male',
  [Gender.F]: 'Female',
  NATIONALITY: 'Nationality',
  BIRTH_DATE: 'Date of birth',
  EXPIRATION_DATE: 'Expiration date',
  NIE_DATA: 'NIE data',
  NATIONALITY_PERIOD: 'Nationality period',
  RESIDENCE_CARD_TYPE: 'Residence card type',
  RESIDENCE_CARD_EXPIRATION_DATE: 'Residence card expiration date',
  SOCIAL_SECURITY_REGISTRATION_DATE: 'Social security registration date',
  NUMBER_OF_WORK: 'Number of jobs since naturalization',
  NATIONALITY_PERIOD_unknown: 'Unknown',
  NATIONALITY_PERIOD_less_than_3_months: 'Less than 3 months',
  NATIONALITY_PERIOD_between_3_and_11_months: 'Between 3 and 11 months',
  NATIONALITY_PERIOD_between_12_and_35_months: 'Between 12 and 35 months',
  NATIONALITY_PERIOD_between_36_and_59_months: 'Between 36 and 59 months',
  NATIONALITY_PERIOD_sixty_or_more_months: '60 months or more',
  CARD_ID_initial: 'Initial',
  CARD_ID_first_renewal: 'First renewal',
  CARD_ID_second_renewal: 'Second renewal',
  CARD_ID_permanent: 'Permanent',
  DOCUMENT_ADDRESS: 'Document address',
  STREET_NAME: 'Street name',
  STREET_NUMBER: 'Street number',
  CITY: 'City',
  COUNTRY: 'Country',
  FLOOR_AND_DOOR: 'Floor and door',
  DOOR_NUMBER: 'Door number',
  FLOOR_NUMBER: 'Floor number',
  BIRTH_PLACE: 'Place of birth',
  INVALID_DATE: 'Invalid date',
  DATE_SHOULD_NOT_BE_BEFORE_MINIMAL_DATE: 'Date should not be before minimal date',
  DATE_SHOULD_NOT_BE_AFTER_MAXIMAL_DATE: 'Date should not be after maximal date',
  INVALID_DOCUMENT_NUMBER: 'Invalid document number',
  ID_FRONT: 'Front side of document',
  ID_BACK: 'Back side of document',
  NIF: 'Tax ID (NIF)',
  NIE: 'Foreigner ID (NIE)',
  NIE_EU: 'Foreigner ID (NIE) within EU',
  NIE_NON_EU: 'Foreigner ID (NIE) outside EU',
  nif: 'Tax ID (NIF)',
  nie: 'Foreigner ID (NIE)',
  nie_eu: 'Foreigner ID (NIE) within EU',
  nie_non_eu: 'Foreigner ID (NIE) outside EU',
  passport: 'Passport',
  CART: 'Cart',
  DIAL_CODE: 'Dial code',
  PHONE_NUMBER: 'Phone number',
  DOCUMENT_EXPIRATION_DATE: 'Document expiration date',
  PERSONAL_INFORMATION: 'Personal information',
  CONTACT_DATA: 'Contact data',
  SHIPPING_AND_BILLING: 'Shipping and billing',
  SHIPPING_ADDRESS: 'Shipping address',
  BILLING_ADDRESS: 'Billing address',
  SHIPPING_METHOD: 'Shipping method',
  SHIPPING_NAME: 'Shipping method name',
  STREET_ADDRESS: 'Street address',
  STREET_ADDRESS_2: 'Additional address',
  COMPANY_VAT: 'Company VAT',
  COMPANY_VAT_DESCRIPTION: 'Required by Sabadell Consumer, one of the selected entities for the operation',
  SELECT_KYC: 'Select VideoID',
  SHOW_KYC_DATA: 'View VideoID Data',
  SIMILARITY_LEVEL: 'Similarity Level',
  [SimilarityLevel.HIGH]: 'High',
  [SimilarityLevel.MEDIUM]: 'Medium',
  [SimilarityLevel.LOW]: 'Low',
  [SimilarityLevel.VERY_LOW]: 'Very low',
  AUTOMATIC_SECURITY_CHECKS: 'Automatic security checks',
  MANUAL_CHECK: 'Manual check',
  VIDEO_ID: 'VideoID',
  KYC_DATA: 'VideoID data',
  PENDING_FOR_KYC_VERIFICATION: 'Pending manual verification',
  VERIFIER: 'Verifier',
  VERIFICATION_DATE: 'Verification date',
  DURATION: 'Duration',
  SEND_REPEAT_KYC_EMAIL: 'Send new VideoID request',
  SEND_REPEAT_KYC_EMAIL_TEXT: 'Do you want to send a new VideoID request to $v1 ($v2)?',
  SEND_REPEAT_KYC_EMAIL_BTN: 'Send',
  [SecurityCheckName.DATA_INTEGRITY]: 'Data integrity',
  [SecurityCheckName.LIVENESS]: 'Liveness check',
  [SecurityCheckName.NON_EXPIRED]: 'Document not expired',
  [SecurityCheckName.NOT_BW_COPY]: 'Color document',
  [SecurityCheckName.NOT_UNDERAGE]: 'Adult',
  [SecurityCheckName.SIDES_MATCH]: 'Front and back compatibility',
  [SecurityCheckName.UNTAMPERED_DOCUMENT]: 'Untampered document',
  [SecurityCheckName.UNTAMPERED_VIDEO]: 'Untampered video',
  [SecurityCheckName.REFLECTIVE_SURFACE]: 'Document without glare',
  [SecurityCheckName.NOT_FACE_SPOOFING]: 'Face not spoofed',

  //DIGITAL FOOTPRINT
  BROWSER: 'Browser',
  DEVICE: 'Device',
  OPERATING_SYSTEM: 'Operating system',
  LOCALE: 'Locale',
  SAVE: 'Save',

  //DOCUMENTATION

  OWNER_NUM_X: 'Owner #$v1',
  LOAN_DOCUMENTATION: 'Loan documentation',
  FILE_DOCUMENT_STATUS: 'Status',
  DOCUMENTATION: 'Documentation',
  DOCUMENTATION_MANAGER: 'Documentation manager',
  DOCUMENTS: 'Documents',
  UPLOADED: 'Uploaded',
  INCIDENCE: 'Incidence',
  SENT: 'Sent',
  UPLOAD_PENDING: 'Upload pending',
  DOCUMENTATION_SENT_ON: 'Sent on $v1',
  ALL_DOCUMENTS_UPLOADED: 'All documentation uploaded',
  INCIDENCE_IN_DOCUMENTS: 'Incidence in documentation',
  ALL_DOCUMENTS_SENT: 'All documentation sent',
  NO_REQUIRED_DOCUMENTS: 'No required documents',
  documentation_incidence: 'Documentation incidence',
  SEND_ALL_DOCUMENTS: 'Send all documents',
  SEND_ALL_DOCUMENTS_DESCRIPTION: 'Do you want to send all uploaded documents to the selected financial entity?',
  SYNCHRONIZE_DOCUMENTS: 'Synchronize documents',
  SYNCHRONIZE_DOCUMENTS_DESCRIPTION: 'Do you want to synchronize the documentation with the selected financial entity?',
  SYNCHRONIZE: 'Synchronize',
  SET_ARE_DOCUMENTS_CONFIRMED: 'Confirm all documents',
  SET_ARE_DOCUMENTS_CONFIRMED_DESCRIPTION: 'Do you want to confirm all the documentation for the owner?',
  SEND_INCIDENCE_NOTIFICATION: 'Send incidence notification',
  SEND_INCIDENCE_NOTIFICATION_DESCRIPTION:
    'Do you want to send a notification email of the documentation incident to the corresponding participant?',
  ADD_REQUIRED_FILE_TYPE: 'Request new document',
  ADD_REQUIRED_FILE_TYPE_DESCRIPTION: 'Select the new document to be requested',
  REQUIRED_DOCUMENT_TYPE: 'Document type',
  UPLOADED_DOCUMENTS: 'Uploaded documents',
  REQUEST: 'Request',
  CONFIRM: 'Confirm',
  LOADING_FILE_TYPES: 'Loading document types...',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED: 'Remove requested document',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED_DESCRIPTION:
    'Do you want to remove the requested document from the owner?',
  REMOVE: 'Remove',
  COMMENT: 'Comment',
  SET_DOCUMENT_STATUS: 'Change document status',
  SET_DOCUMENT_STATUS_REQUIRED_DESCRIPTION: 'Select the new status for the document.',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT: 'Mark document as not sent',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT_DESCRIPTION:
    'Do you want to mark the document as not sent to the financial institution?',
  SET_NOT_SENT: 'Mark as not sent',
  DOCUMENT_VALIDATED: 'Document validated',
  CHANGE_STATUS: 'Change status',
  UPLOAD_FILE: 'Upload document',
  DOWNLOAD_FILE: 'Download document',
  DOWNLOAD_INSURANCE_OFFER: 'Download insurance offer',
  INSURANCE_OFFER_NOT_AVAILABLE_YET: 'The insurance offer is not available yet for the current conditions',
  VALIDATED: 'Validated',
  UPLOAD_FILE_TEXT: 'Upload document(s) of type:',
  ADD_FILE_ACTION: 'Select document',
  UPLOADED_DOCUMENTATION: 'Uploaded Documentation',
  DOCUMENTS_TO_UPLOAD: 'Documentation pending upload',
  UPLOAD_FILES: 'Upload Documentation',
  FILE_WILL_BE_OVERWRITTEN: 'Pending upload documents will replace uploaded documents with the same name',
  THIS_MIME_FILE_TYPE_IS_NOT_POSSIBLE_TO_DOWNLOAD: 'It is not possible to download a document of this type',
  PROFORMA_INVOICE: 'Proforma Invoice',
  BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION: 'Bank Account Ownership Certificate',
  PAYROLL: 'Payroll',
  PERSONAL_INCOME_TAX: 'Annual Personal Income Tax',
  BIOMETRICS_DOCUMENT: 'Biometric Document from KYC Process',
  DOCUMENT_ID_FRONT: 'Front Part of ID / NIE',
  DOCUMENT_ID_BACK: 'Back Part of ID / NIE',
  PASSPORT: 'Passport',
  PENSION_DOCUMENT: 'Pension Document',
  DOCUMENT_ID_FACE: 'Facial Image Extracted from ID Document',
  KYC_VIDEO: 'Video Extracted during KYC Process',
  DOCUMENT_ID_SIGNATURE: 'Signature Extracted from ID Document',
  BIOMETRICS_FACE: 'Facial Image Extracted during KYC Process',
  LOAN_LENDER_BORROWER_CONTRACT: 'Loan Agreement between Final Customer and Financial Institution',
  [IncomeType.BORROWER_BANK_READER]: 'Bank Aggregation',
  [IncomeType.DECLARED_INCOME]: 'Declared Income',
  [NetIncomeType.SALARY]: 'Salary',
  [NetIncomeType.PENSION]: 'Pension',
  [NetIncomeType.UNEMPLOYMENT_BENEFIT]: 'Unemployment Benefit',
  [NetIncomeType.OTHER_PAYMENT]: 'Other',
  [BorrowerFileType.BORROWER_AML]: 'AML/PEP Search Results',
  [BorrowerFileType.BORROWER_ASNEF]: 'ASNEF Morosity List Search Result for ID',
  [LoanFileType.VEHICLE_INSPECTION_DOCUMENT]: 'Vehicle Technical Inspection Card',
  [LoanFileType.INE_NEMURU_DOCUMENT]: 'INE (European Standardized Information) for Intermediation Loan',
  [LoanFileType.INE_LENDER_NEMURU_DOCUMENT]: 'INE (European Standardized Information) for Nemuru Finance Loan',
  [LoanFileType.DRIVING_PERMIT]: 'Driving Permit',
  [LoanFileType.CARFAX]: 'Vehicle Carfax Document',
  [LoanFileType.DEED_OF_SALE]: 'Deed of Sale',
  [LoanFileType.OWNERSHIP_DOCUMENTATION]:
    'Ownership documentation (IBI or deed or simple note or last mortgage payment)',
  [LoanFileType.IBI]: 'Real Estate Tax',
  [LoanFileType.PROOF_OF_INCOME]:
    'Proof of income (payroll or pension revaluation or pre-retirement agreement or bank certificate of pension payment or last year IRPF)',
  [LoanFileType.PROPERTY_REGISTRY_EXTRACT]: 'Simple property registry extract',
  [LoanFileType.LAST_MORTGAGE_PAYMENT]: 'Last mortgage payment',
  [LoanFileType.TRAFFIC_REPORT]: 'Traffic report / Property registry report / Charges report',
  [MerchantFileType.F_036]: 'Model 036 Self-Employment Registration',
  [BorrowerFileType.UNEMPLOYMENT_INCOME_DOC]: 'Unemployment Benefit Income Documentation',
  [MerchantFileType.MERCHANT_DOCUMENT]: 'Merchant Document',
  [MerchantFileType.MERCHANT_CONTRACT_AUDIT_TRAIL]: 'Digital Contract Audit Trail for Merchant Contract',
  [BorrowerFileType.SEPE_DOCUMENT]: 'SEPE Document, ERTE Confirmation',
  [BorrowerFileType.LAST_FULL_PAYROLL]: 'Last Full Payroll Received before ERTE',
  [BorrowerFileType.PENSION_REVALUATION_LETTER]: 'Social Security Pension Revaluation Letter',
  [BorrowerFileType.LAST_PENSION_INCOME]: 'Last Pension Income (Receipt)',
  [BorrowerFileType.WORK_LEAVE]: 'Sick Leave Certificate',
  [BorrowerFileType.WORKING_LIFE_REPORT]: 'Employment History Certificate',
  [BorrowerFileType.CALLING_LETTER]: 'Calling Letter (for Temporary Work)',
  [BorrowerFileType.CONTRIBUTION_BASE]: 'Contribution Base',
  [BorrowerFileType.TAX_DATA]: 'Tax Data',
  [BorrowerFileType.OTHER_1]: 'Other 1',
  [BorrowerFileType.OTHER_2]: 'Other 2',
  [BorrowerFileType.OTHER_3]: 'Other 3',
  [BorrowerFileType.OTHER_4]: 'Other 4',
  [BorrowerFileType.OTHER_5]: 'Other 5',
  [BorrowerFileType.DRIVING_LICENCE]: "Driver's License",
  [BorrowerFileType.ADDRESS_EVIDENCE]: 'Address Evidence',
  [BorrowerFileType.SELF_EMPLOYMENT_FEE_VERIFIER]: 'Self-Employment Fee Verification',
  [BorrowerFileType.MODEL_130_1T]: 'Model 130 1T',
  [BorrowerFileType.MODEL_130_2T]: 'Model 130 2T',
  [BorrowerFileType.MODEL_130_3T]: 'Model 130 3T',
  [BorrowerFileType.MODEL_130_4T]: 'Model 130 4T',
  [BorrowerFileType.MODELO_300_1T]: 'Model 300 1T',
  [BorrowerFileType.MODELO_300_2T]: 'Model 300 2T',
  [BorrowerFileType.MODELO_300_3T]: 'Model 300 3T',
  [BorrowerFileType.MODELO_300_4T]: 'Model 300 4T',
  [BorrowerFileType.MODEL_390_LAST_YEAR]: "Last Year's VAT Declaration (Model 390)",
  [BorrowerFileType.PAYROLL_TWO_PREVIOUS_MONTHS]: 'Payroll from Two Months Ago',
  [BorrowerFileType.PAYROLL_THREE_MONTHS_EARLIER]: 'Payroll from Three Months Ago',
  [LoanFileType.SALES_INVOICE]: 'Sales Invoice',
  [LoanFileType.BILL_SERVICES]: 'Services Invoice',
  [BorrowerFileType.BANK_READER_INCOME]: 'Income Detected through Bank Aggregation',
  [BorrowerFileType.CAIXABANK_INCIDENCE_DOCUMENT]: 'Additional Documentation for CaixaBank',
  [BorrowerFileType.INSURANCE_BORROWER_CONTRACT]: 'Original Signed Insurance Policy by the Policyholder',
  [BorrowerFileType.PHONE_OR_ENERGY_INVOICE]: 'Phone or Energy Invoice in the Name of the Holder',
  [BorrowerFileType.CREDIT_CARD_FRONT]: 'Credit Card (Not Debit) Front Face',
  [BorrowerFileType.CREDIT_CARD_BACK]: 'Credit Card (Not Debit) Back Face',
  [BorrowerFileType.ENROLLMENT_OF_THE_STUDENT]: 'Enrollment for the Current Year Student',
  [BorrowerFileType.TAXI_LICENCE]: 'Valid Taxi licence',
  [BorrowerFileType.PROPERTY_CERTIFICATE]: 'Proof of ownership',
  [BorrowerFileType.TAX_VAT_LAST_QUARTER]: 'Tax VAT from last quarter',
  [BorrowerFileType.TAX_VAT_PREVIOUS_QUARTER]: 'Tax VAT from previous quarter',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_BACK]: 'Back side of attorney 1 document',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_BACK]: 'Back side of attorney 2 document',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_FRONT]: 'Front side of attorney 1 document',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_FRONT]: 'Front side of attorney 2 document',
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_CURRENT_YEAR]: 'Profit and loss statement for the current year',
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_LAST_YEAR]: 'Profit and loss statement for the last year',
  [BorrowerFileType.CORPORATE_IDENTIFICATION_NUMBER]: 'Company CIF',
  [BorrowerFileType.POWERS_OF_ATTORNEY]: 'Powers of attorney documents',
  [BorrowerFileType.MODEL_200_LAST_YEAR]: 'Corporate Tax - Model 200 (last year)',
  [BorrowerFileType.MODELO_303_CURRENT_YEAR]: 'Quarterly VAT return - Model 303 (current year)',
  [BorrowerFileType.ABANCA_ADHESION_BULLETIN]: 'Abanca adhesion bulletin',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_BS]: 'Payslip and ownership certificate BS',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_COFIDIS]: 'Payslip and ownership certificate Cofidis',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_NEMURU]: 'Payslip and ownership certificate Nemuru',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_SOYOU]: 'Payslip and ownership certificate Sofinco',
  [BorrowerFileType.NIE_EU_DOCUMENT_ID]: 'NIE (European) identity document',

  MAIN_RESIDENCE: 'Main residence',
  OWNERSHIP_TYPE: 'Ownership type',
  CONTRACT_TYPE: 'Contract type',
  HOME_EXPENSES: 'Monthly expenses',
  ENTRANCE_DATE: 'Date of entry to residence',
  MORTGAGE: 'Mortgage',
  public_deed: 'Public deed',
  private_contract: 'Private contract',
  social_housing: 'Social housing',
  ownership: 'Owned',
  rent: 'Rented',
  leasing: 'Company property/lease',
  usufruct: 'Usufruct',
  partner: "Partner's property",
  parents: "Parents' property",
  FORMATTED_ADDRESS_WILL_BE_GEOLOCATED_WARNING:
    'The provided address will be automatically geolocated through Google and may be adjusted for greater accuracy. Please review the final result after saving it.',
  BUILDING_LABEL: 'Staircase / Block',
  AUTOCOMPLETE_ADDRESS: 'Autocomplete address',
  COMPLETE_ADDRESS_MANUALLY: 'Complete adress manually',
  AUTOCOMPLETE_HINT: 'Start writing your address and select an option from the list',
  SELECTED_ADDRESS: 'Selected address',
  SEARCH_AGAIN: 'Search again',
  UPDATING_ADDRESS: 'Updating address',
  EDIT_ADDRESS: 'Edit address',
  ADDITIONAL_DETAILS: 'Additional details',
  CONFIRM_CHANGES: 'Confirm changes',
  HOME_EXPENSES_MUST_BE_GREATER_THAN_0: 'Monthly expenses must be greater than 0',

  //FAMILIAR SITUATION DETAILS

  FAMILIAR_SITUATION: 'Family situation',
  MARITAL_STATUS: 'Marital status',
  MARITAL_REGIME: 'Marital regime',
  CHILD_SUPPORT_NUMBER: 'Number of dependent children',
  married: 'Married',
  separated: 'Separated',
  single: 'Single',
  widowed: 'Widowed',
  divorced: 'Divorced',
  separated_in_fact: 'Separated in fact',
  similar_situation_to_married: 'Similar situation to married',
  matrimonial_assets: 'With community of property regime',
  separate_property: 'With separate property regime',

  PROFESSIONAL_DETAILS: 'Professional details',
  EMPLOYMENT_STATUS: 'Employment status',
  PROFESSIONAL_POSITION: 'Profession',
  COMPANY: 'Company',
  COMPANY_NAME: 'Company name',
  COMPANY_ACTIVITY: 'Company activity',
  COMPANY_CITY: 'City',
  INDIVIDUAL_FINANCIAL_DATA_PRICE: 'Net amount from the previous fiscal year',
  INDIVIDUAL_FINANCIAL_DATA_DATE: 'Previous fiscal year',
  SENIORITY_YEARS: 'Years in the company',
  SENIORITY_MONTHS: 'Months in the company',
  SENIORITY: 'Seniority',
  SELF_EMPLOYMENT_NET_INCOME: 'Net income from the previous fiscal year',
  SELF_EMPLOYMENT_NET_INCOME_DATE: 'Previous fiscal date',
  DATE_CONTRACT_END: 'End of contract date',
  TIME_IN_THE_COMPANY: 'Time in the company',
  MIN_NUMBER_ERROR: 'Value needs to reach minimum value',
  MAX_NUMBER_EXCEEDED: 'Maximum number exceeded',
  INVALID_POSTAL_CODE: 'Invalid postal code',
  [EmploymentStatus.INDEFINITE_EMPLOYED]: 'Indefinite employment',
  [EmploymentStatus.TEMPORARY_EMPLOYED]: 'Temporary employment',
  [EmploymentStatus.FIXED_DISCONTINUOUS_EMPLOYED]: 'Fixed discontinuous employment',
  [EmploymentStatus.CIVIL_SERVANT]: 'Civil servant',
  [EmploymentStatus.TRAINEE]: 'Trainee',
  [EmploymentStatus.CASUALTY_WORKER]: 'Casual worker',
  [EmploymentStatus.UNEMPLOYED]: 'Unemployed',
  [EmploymentStatus.RETIRED]: 'Retired',
  [EmploymentStatus.PENSIONER]: 'Pensioner',
  [EmploymentStatus.STUDENT]: 'Student',
  [EmploymentStatus.RENTIER]: 'Rentier',
  [EmploymentStatus.WITHOUT_WORK]: 'Without work',
  [EmploymentStatus.WIDOWS_INCOME]: "Widow's Income",
  [ProfessionalPosition.ADMINISTRATIVE]: 'Administrative',
  [ProfessionalPosition.MANAGING_DIRECTOR]: 'Managing director',
  [ProfessionalPosition.MANAGER]: 'Manager',
  [ProfessionalPosition.COMPANY_OWNER]: 'Company owner / manager',
  [ProfessionalPosition.TECHNICIANS_AND_PROFESSIONAL]: 'Technician / professional',
  [ProfessionalPosition.SHOP_ASSISTANT]: 'Shop assistant / waiter',
  [ProfessionalPosition.COMMERCIAL_AND_SALES_PERSON]: 'Commercial / salesperson',
  [ProfessionalPosition.LABOR_WORKER]: 'Labor worker',
  [ProfessionalPosition.ENGINEER]: 'Engineer',
  [ProfessionalPosition.ARCHITECT]: 'Architect',
  [ProfessionalPosition.LAWYER_OR_NOTARY_ATTORNEY]: 'Lawyer or notary',
  [ProfessionalPosition.DOCTOR_OR_DENTIST]: 'Healthcare professional',
  [ProfessionalPosition.PHARMACEUTICAL]: 'Pharmacist',
  [ProfessionalPosition.VETERINARY]: 'Veterinarian',
  [ProfessionalPosition.TEACHER]: 'Teacher',
  [ProfessionalPosition.JOURNALIST]: 'Journalist',
  [ProfessionalPosition.FARMER_OR_RANCHER]: 'Farmer or rancher',
  [ProfessionalPosition.TRANSPORTER]: 'Transporter',
  [ProfessionalPosition.PROFESSIONAL_ATHLETE]: 'Professional athlete',
  [ProfessionalPosition.ARTIST]: 'Artist',
  [ProfessionalPosition.WRITER]: 'Writer',
  [ProfessionalPosition.RELIGIOUS]: 'Religious',
  [ProfessionalPosition.POLICE_AND_MILITARY]: 'Police / military',
  [ProfessionalPosition.DIPLOMATIC]: 'Diplomat',
  [ProfessionalPosition.CIVIL_SERVANT_A1]: 'Public Administration - Civil Servant A1',
  [ProfessionalPosition.CIVIL_SERVANT_A2]: 'Public Administration - Civil Servant A2',
  [ProfessionalPosition.CIVIL_SERVANT_B]: 'Public Administration - Civil Servant B',
  [ProfessionalPosition.CIVIL_SERVANT_C1]: 'Public Administration - Civil Servant C1',
  [ProfessionalPosition.CIVIL_SERVANT_C2]: 'Public Administration - Civil Servant C2',
  [ProfessionalPosition.CIVIL_SERVANT_E]: 'Public Administration - Civil Servant E',
  [ProfessionalPosition.LABOR_STAFF_G1]: 'Public Administration - Civil Servant G1',
  [ProfessionalPosition.LABOR_STAFF_G2]: 'Public Administration - Civil Servant G2',
  [ProfessionalPosition.LABOR_STAFF_G3]: 'Public Administration - Civil Servant G3',
  [ProfessionalPosition.LABOR_STAFF_G4]: 'Public Administration - Civil Servant G4',
  [ProfessionalPosition.LABOR_STAFF_G5]: 'Public Administration - Civil Servant G5',
  [IberiaEmploymentStatus.EMPLOYEE_PERMANENT]: 'Indefinite employment',
  [IberiaEmploymentStatus.EMPLOYEE_CIVIL_SERVANT]: 'Public Administration',
  [IberiaEmploymentStatus.EMPLOYEE_INTERN]: 'Intern',
  [IberiaEmploymentStatus.EMPLOYEE_TEMPORARY]: 'Temporary employment',
  [IberiaEmploymentStatus.EXECUTIVE_DIRECTOR]: 'Executive director',
  [IberiaEmploymentStatus.INACTIVE]: 'Unemployed',
  [IberiaEmploymentStatus.INVESTOR_SHAREHOLDER]: 'Investor',
  [IberiaEmploymentStatus.PENSIONER_RETIRED_WIDOW]: 'Pensioner / Retired / Widow',
  [IberiaEmploymentStatus.SELF_EMPLOYED_BUSINESS_OWNER]: 'Business owner',
  [IberiaEmploymentStatus.SELF_EMPLOYED_FREELANCER]: 'Freelancer',
  [CompanyActivity.AGRICULTURE_LIVESTOCK_FISHERIES]: 'Agriculture / Livestock / Fisheries',
  [CompanyActivity.MINING_METALLURGY]: 'Mining / Metallurgy',
  [CompanyActivity.GROCERY]: 'Grocery',
  [CompanyActivity.TEXTILE_MANUFACTURE]: 'Textile Manufacture',
  [CompanyActivity.WOOD]: 'Wood',
  [CompanyActivity.GRAPHICS_ARTS_EDITION]: 'Graphics / Arts / Edition',
  [CompanyActivity.CHEMISTRY]: 'Chemistry',
  [CompanyActivity.MECHANICAL_MACHINERY]: 'Mechanical Machinery',
  [CompanyActivity.ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY]: 'Energy / Electrical Supply',
  [CompanyActivity.OTHER_UNQUALIFIED_SERVICES]: 'Other Unqualified Services',
  [CompanyActivity.OTHER_QUALIFIED_SERVICES]: 'Other Qualified Services',
  [CompanyActivity.BUILDING]: 'Construction',
  [CompanyActivity.COMMERCE]: 'Commerce',
  [CompanyActivity.PEDDLING]: 'Peddling',
  [CompanyActivity.TRANSPORT_TERRESTRIAL_MESSAGING]: 'Terrestrial Messaging',
  [CompanyActivity.OTHER_TRANSPORTS]: 'Other Transports',
  [CompanyActivity.TAXI_DRIVER]: 'Taxi Driver',
  [CompanyActivity.TELECOMMUNICATIONS_MAIL]: 'Telecommunications / Mail',
  [CompanyActivity.BARS_SERVICES]: 'Bars / Services',
  [CompanyActivity.I_PLUS_D]: 'Research and Development',
  [CompanyActivity.ADVOCACY_JOURNALISM]: 'Advocacy / Journalism',
  [CompanyActivity.SECURE_FINANCIAL_SERVICES]: 'Secure Financial Services',
  [CompanyActivity.FINANCIAL_SERVICES_INSURANCE]: 'Insurance',
  [CompanyActivity.IT_CONSULTANT_AUDITOR]: 'IT Consultant / Auditor',
  [CompanyActivity.ARCHITECTURE_ENGINEERING]: 'Architecture / Engineering',
  [CompanyActivity.VETERINARY_MEDICINE]: 'Veterinary Medicine',
  [CompanyActivity.PUBLIC_ADMINISTRATIONS]: 'Public Administrations',
  [CompanyActivity.ARMED_FORCES]: 'Armed Forces',
  [CompanyActivity.HOLIDAY_SHOWS_SHOWS]: 'Holiday / Shows / Entertainment',
  [CompanyActivity.SPORTS]: 'Sports',
  [IberiaCompanyActivity.AERONAUTICS_TRANSPORT_NAUTICAL]: 'Aeronautics, Transport and Nautical',
  [IberiaCompanyActivity.AGRICULTURE_GARDENING_MINERALOGY_GEOLOGY]: 'Agriculture, Gardening, Mineralogy and Geology',
  [IberiaCompanyActivity.BANKING_FINANCIAL_INSTITUTIONS]: 'Banking and Financial Institutions',
  [IberiaCompanyActivity.EXPERIMENTAL_SCIENCES_MATHEMATICS_PHYSICS]: 'Experimental Sciences, Mathematics and Physics',
  [IberiaCompanyActivity.COMMUNICATION_ADVERTISING_PUBLIC_RELATIONS]: 'Communication, Advertising and Public Relations',
  [IberiaCompanyActivity.CONSTRUCTION_BUILDING]: 'Construction and Building',
  [IberiaCompanyActivity.SECURITY_FORCES_CRIMINOLOGY]: 'Security Forces and Criminology',
  [IberiaCompanyActivity.SPORTS_PHYSICAL_EDUCATION]: 'Sports and Physical Education',
  [IberiaCompanyActivity.LAW_POLITICS]: 'Law and Politics',
  [IberiaCompanyActivity.DESIGN_GRAPHIC_TEXTILE_INDUSTRIAL_INTERIOR]:
    'Design: Graphic Textile, Industrial and Interior',
  [IberiaCompanyActivity.ECONOMICS_BUSINESS_ADMINISTRATION]: 'Economics and Business Administration',
  [IberiaCompanyActivity.EDUCATION_TRAINING]: 'Education and Training',
  [IberiaCompanyActivity.HOSPITALITY_TOURISM_CATERING]: 'Hospitality, Tourism and Catering',
  [IberiaCompanyActivity.HUMANITIES_PSYCHOLOGY]: 'Humanities and Psychology',
  [IberiaCompanyActivity.LANGUAGES_PHILOLOGY_TRANSLATION]: 'Languages, Philology and Translation',
  [IberiaCompanyActivity.PERSONAL_IMAGE]: 'Personal Image',
  [IberiaCompanyActivity.IMAGE_SOUND]: 'Image and Sound',
  [IberiaCompanyActivity.INDUSTRY_MECHANICS_ELECTRICITY_ELECTRONICS]:
    'Industry, Mechanics, Electricity and Electronics',
  [IberiaCompanyActivity.IT_TELECOMMUNICATIONS]: 'Information Technology and Telecommunications',
  [IberiaCompanyActivity.ENVIRONMENT_VETERINARY_SCIENCE]: 'Environment and Veterinary Science',
  [IberiaCompanyActivity.MUSIC_FILM_DANCE_THEATRE]: 'Music, Film, Dance and Theatre',
  [IberiaCompanyActivity.HEALTHCARE_HEALTH]: 'Healthcare and Health',
  [IberiaCompanyActivity.CRAFT_ARTISTIC_TECHNIQUES]: 'Craft and Artistic Techniques',

  //BUSINESS DETAILS

  BUSINESS_IDENTIFICATION: 'Business details',
  NATIONAL_ID_TYPE: 'Type of national identification document',
  NATIONAL_ID_NUMBER: 'National identification number',
  BUSINESS_FINANCIAL_DETAILS: 'Financial details',
  CAPITAL_STOCK: 'Capital stock',
  OWN_FUNDS: 'Own funds',
  TAX_BASE: 'Profit before taxes',
  INDIVIDUAL_FINANCIAL_NET_AMOUNT: 'Revenue',
  BIRTH_COUNTRY: 'Country of birth',
  HOLDER_TYPES: 'Holder types',
  GRANTING_POWERS_DATE: 'Granting powers date',
  HOLDER_PERCENTAGE: 'Percentage of ownership',
  RELATIONSHIP_WITH_OWNER: 'Relationship with owner',
  [HolderType.ATTORNEY]: 'Attorney',
  [HolderType.ADMINISTRATOR]: 'Administrator',
  [HolderType.SHAREHOLDER]: 'Shareholder',
  attorneys: 'Attorneys',
  shareholders: 'Shareholders',
  administrators: 'Administrators',
  EDIT_BUSINESS_IDENTIFICATION: 'Edit business details',
  EDIT_BUSINESS_FINANCIAL_DETAILS: 'Edit financial details',
  EDIT_BUSINESS_ADDRESS: 'Edit business address',
  edit_attorney_details: 'Edit attorney details',
  edit_shareholder_details: 'Edit shareholder details',
  edit_administrator_details: 'Edit administrator details',

  //BUSINESS TYPE
  [BusinessType.AEI]: 'European Economic Interest Grouping',
  [BusinessType.AIE]: 'Economic Interest Grouping',
  [BusinessType.CB]: 'Community of Goods',
  [BusinessType.CP]: 'Community of Property Owners',
  [BusinessType.ECR]: 'Venture Capital Entities',
  [BusinessType.ESJ]: 'Legal Entity Without Legal Personality',
  [BusinessType.MUT]: 'Mutuality',
  [BusinessType.OTR]: 'Others',
  [BusinessType.PRI]: 'Private Association/Organization',
  [BusinessType.PUB]: 'Public Administration',
  [BusinessType.SA]: 'Public Limited Company',
  [BusinessType.SAL]: 'Labour Public Limited Company',
  [BusinessType.SAT]: 'Agricultural Transformation Company',
  [BusinessType.SAU]: 'Single-member Public Limited Company',
  [BusinessType.SCA]: 'Partnership Limited by Shares',
  [BusinessType.SCE]: 'European Cooperative Society',
  [BusinessType.SCL]: 'General Partnership',
  [BusinessType.SCO]: 'Cooperative Society',
  [BusinessType.SCP]: 'Private Civil Society',
  [BusinessType.SCS]: 'Simple Limited Partnership',
  [BusinessType.SE]: 'European Public Limited Company',
  [BusinessType.SGR]: 'Mutual Guarantee Company',
  [BusinessType.SL]: 'Limited Company',
  [BusinessType.SLL]: 'Labour Limited Company',
  [BusinessType.SLN]: 'Newly Established Limited Company',
  [BusinessType.SLU]: 'Single-member Limited Company',
  [BusinessType.SPD]: 'Branches in Different Countries',
  [BusinessType.SRL]: 'Limited Liability Company',

  //NET INCOME

  NET_INCOME: 'Income',
  BANK_NAME: 'Financial institution',
  ACCOUNT_NUMBER: 'Bank account number',
  IBAN: 'Iban',
  DETECTED_INCOMES: 'Detected incomes',
  LAST_12_MONTHS: 'Last 12 months',
  MONTHLY: 'Monthly',
  ANNUAL: 'Annual',
  INCOME_TYPE: 'Income type',
  ORIGIN: 'Origin',
  LOADING_INCOME: 'Fetching detected incomes...',
  ANNUAL_NET_INCOME: 'Annual net income',
  MONTHLY_NET_INCOME: 'Monthly net income',
  EDIT_DECLARED_INCOME: 'Edit declared income',
  INVALID_IBAN: 'Invalid account number',
  NUMBER_OF_YEARLY_PAYMENTS: 'Number of yearly payments',

  [APP_ROLES.SUPER_ADMIN]: 'Super Admin',
  [APP_ROLES.ADMIN]: 'Admin',
  [APP_ROLES.LENDER]: 'Lender',
  [APP_ROLES.MERCHANT]: 'Merchant',
  [APP_ROLES.CHANNEL]: 'Channel',
  [APP_ROLES.AGENT]: 'Agent',
  [APP_ROLES.PARTNER]: 'Partner',
  [APP_ROLES.THIRD_PARTY_VALIDATION]: '3rd party validation agent',

  //USER TYPE
  [`user_${UserType.SUPER_ADMIN}`]: 'Super Admin',
  [`user_${UserType.ADMIN}`]: 'Admin',
  [`user_${UserType.LENDER}`]: 'Lender',
  [`user_${UserType.MERCHANT}`]: 'Merchant',
  [`user_${UserType.CHANNEL}`]: 'Channel',
  [`user_${UserType.AGENT}`]: 'Agent',
  [`user_${UserType.MERCHANT_GROUP}`]: 'Group',
  [`user_${UserType.PARTNER}`]: 'Partner',
  [`user_${UserType.THIRD_PARTY_VALIDATION}`]: 'Validation agent',
  [`user_${UserType.CPC_BACK_OFFICE}`]: 'Customer Support CPC',

  //ACCOUNT
  USER_NAME: 'User name',
  USER_TYPE: 'User type',
  PROFILE: 'Profile',
  USER_INFO: 'User information',
  ACCOUNT_TYPE: 'Account type',
  APPLICATION_LANGUAGE: 'Application language',
  CHANNEL_AGENTS_NUMBER: 'Number of agents in channel',
  BUSINESS_PHONE: 'Phone',
  BUSINESS_ADDRESS: 'Address',
  THEME: 'Theme',
  DARK_MODE_TOGGLE: 'Dark mode',

  //PRICINGS
  PRICINGS_LIST: 'Pricings list',
  LOADING_PRICINGS: 'Loading pricings...',
  LOADING_PRICINGS_DETAILS: 'Loading pricing...',
  FILTERS: 'Filters',
  AVAILABLE_PRICINGS: 'Available pricings',
  SELECT_THE_PAYMENT_METHOD: 'Select the desired payment method.',
  WITH_GRACE_PERIOD_FILTER: 'With grace period',
  WITHOUT_GRACE_PERIOD_FILTER: 'Without grace period',
  GRACE_PERIOD_NO_FILTER: 'Unfiltered grace period',
  NO_FILTER: 'No filter',
  WITH_SETUP_FEE_FILTER: 'With setup fee',
  WITHOUT_SETUP_FEE_FILTER: 'Without setup fee',
  SETUP_FEE_NO_FILTER: 'Unfiltered setup fee',
  [`INSURANCE_TYPE_${InsuranceType.EXTENSION_GARANTIA}`]: 'Warranty extension',
  [`INSURANCE_TYPE_${InsuranceType.NO}`]: 'No insurance',
  [`INSURANCE_TYPE_${InsuranceType.RETIRADA_CARNET}`]: 'License withdrawal',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_AUTO}`]: 'Car insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_DESEMPLEO}`]: 'Unemployment insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_PPP}`]: 'PPP insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA}`]: 'Life insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA}`]: 'Life IPA insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA_PPP}`]: 'Life IPA PPP insurance',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_PLUS}`]: 'Life+ insurance',
  [`INSURANCE_TYPE_${InsuranceType.SINIESTRO_TOTAL}`]: 'Total loss',
  [`INSURANCE_TYPE_${InsuranceType.VEHICULO_SUSTITUCION}`]: 'Replacement vehicle',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_SENIOR}`]: 'Senior life insurance',
  NO_INSURANCE: 'No insurance',

  INSURANCE_PROVIDER: 'Provider',
  INSURANCE_TYPE_NONE: 'No insurance',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BBVA}`]: 'BBVA',
  [`INSURANCE_PROVIDER_${InsuranceProvider.CAIXABANK}`]: 'CaixaBank',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SANTANDER_CONSUMER}`]: 'Santander Consumer',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BS}`]: 'BS',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SOYOU}`]: 'SoYou',
  [`INSURANCE_PROVIDER_${InsuranceProvider.ABANCA}`]: 'Abanca',
  [`INSURANCE_PROVIDER_${InsuranceProvider.COFIDIS}`]: 'Cofidis',
  [`INSURANCE_PROVIDER_${InsuranceProvider.WEE_COVER}`]: 'Wee Cover',
  INSURANCE_COST: 'Insurance cost',
  INSURANCE_PERCENTAGE: 'Insurance percentage',

  MERCHANT_FEE_COMMISSION: 'Merchant fee',
  SETUP_FEE_COST: 'Customer cost',
  INSURANCE: 'Insurance',
  INSURANCES: 'Insurance(s)',
  AVAILABLE_INSURANCES: 'Available insurances',
  NO_AVAILABLE_INSURANCES: 'No insurances available',
  REGISTRATION: 'Registration',
  YEARS_SINCE_REGISTRATION: 'Years since registration',
  ANNUAL_INTEREST_AND_DISCOUNT: 'APR and discount',

  [`FEE_TYPE_${FeeType.FIX_AMOUNT}`]: 'Fixed amount',
  [`FEE_TYPE_${FeeType.PERCENTAGE}`]: 'Percentage',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FINANCED}`]: 'Financed commission',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Fixed fee per installment',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_UPFRONT}`]: 'Upfront fee',

  LESS_OPTIONS: 'Less options',
  MORE_OPTIONS: 'More options',
  REQUIRED: 'required',

  ACTION_GENERIC_ERROR: 'Oops! an error has occurred.',
  ACTION_GENERIC_INFO: 'The action has been completed successfully.',
  ACTION_GENERIC_SUCCESS: 'The action has been completed successfully.',
  ACTION_GENERIC_ERROR_TITLE: 'Action failed',
  REQUEST_GET_LOAN_BY_ID_REJECTED: 'Unable to load requested loan data.',
  LOADING: 'Loading',
  STILL_LOADING: 'Still Loading...',
  IT_SEEMS_THAT_SOME_FEATURES_ARE_TAKING_LONGER_THAN_USUAL_TO_LOAD:
    'It seems that some features are taking longer than usual to load. You can either wait or **LINK**show the page partially**LINK** while they load.',

  //CUSTOMER SUPPORT

  CUSTOMER_SUPPORT: 'Customer Support',
  DAY: 'day',
  DAYS: 'days',
  HOUR: 'hour',
  HOURS: 'hours',
  MINUTE: 'minute',
  MINUTES: 'minutes',
  SECOND: 'second',
  SECONDS: 'seconds',
  AFTER: 'after',
  DONE: 'Done',
  LOADING_TICKETS: 'Loading management history...',
  TIME_PASSED_SINCE_LAST_ACTION: 'Time since last action',
  TOTAL_ACTIONS_TIME: 'Total management time',
  UPDATED_AT: 'Last Updated:',
  TICKET_STATUS: 'Status:',
  PRIORITY: 'Priority:',
  SELECT_TICKET: 'Select ticket',
  TICKET_SOLVED: 'Solved',
  TICKET_OPENED: 'Opened',
  TICKET_PENDING: 'Pending',
  TICKET_CLOSED: 'Closed',
  NO_TICKETS_AVAILABLE: 'No information available for customer service incidents',
  SINCE_LOAN_RESOLUTION: 'Since ticket resolution',
  [Priority.URGENT]: 'Urgent',
  [Priority.NORMAL]: 'Normal',
  ACTIVITY_LOG: 'Activity',
  TOTAL_ACTIONS: 'Total actions',
  SELECTED_CHANNELS: 'Selected channels',
  [PendingDataType.NO_CHANNELS_SELECTED]: 'No channels selected',
  [PendingDataType.PASSWORD_RECOVERY_NOT_FOUND]: 'No password recovery emails sent',

  // New Application general
  NEW_APPLICATION: 'New checkout',
  RESTART: 'Restart',
  RESTART_NOTICE: 'All data will be lost if you restart the checkout.',
  BACK_NOTICE: 'All cart data will be lost if you go back.',
  RESTART_APPLICATION: 'Restart checkout',
  LEAVE: 'Leave',
  LEAVE_NOTICE: 'All data will be lost if you leave the checkout.',
  LEAVE_APPLICATION: 'Leave checkout',
  ORDER_DATA: 'Order data',
  SHOW_SUMMARY: 'Show summary',
  NOT_POSSIBLE_CREATING_NEW_APPLICATION: 'It is not possible to create a new checkout',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_AMOUNT: 'No payment methods available for the checkout amount',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_USER: 'Your user does not have any activated payment methods.',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_SELECTED_AGENT: 'The selected agent does not have any activated payment methods.',
  CONTACT_NEMURU_FOR_SERVICE_ACTIVATION_OR_ERROR: (
    <>
      {'If you want to activate this service or believe this is an error, please contact us by writing to '}
      <a href="mailto:hola@nemuru.com">{'hola@nemuru.com'}</a>
      {'.'}
    </>
  ),

  // AGENT SELECTION
  SALES_PROFILE: 'Sales profile',
  SALES_PROFILE_SELECT: 'Select an agent for this order',
  SEARCH_BY_NAME: 'Search by name...',
  SELECT_AN_AGENT: 'Select an agent',
  SELECT_A_CHANNEL: 'Select a channel',
  SELECT_A_MERCHANT: 'Select a merchant',
  SELECT_NEW_AGENT: 'Select new agent',
  SELECT_NEW_AGENT_NOTICE:
    '¿Do you want to select a new agent? All data introduced so far in the application will be lost.',
  // -- ALREADY EXISTS -- CHANNEL: 'Channel',
  NO_AGENTS_AVAILABLE: 'No agents available',

  // CUSTOMER CONTACT DATA:
  CUSTOMER_CONTACT_DATA: 'Customer Data',
  FILL_CUSTOMER_CONTACT_DATA: 'Fill out the form with customer details',
  CUSTOMER_NAME: 'Customer Name',
  REFERENCES_SUBTITLE:
    'Introduce the order reference in your system. You cannot use a reference that has already been used.',

  //AUTO DETAILS
  LAST_VEHICLES: 'Last vehicles',
  AUTO_DETAILS_DESCRIPTION: 'Enter the vehicle details to finance',
  VEHICLE_CONDITION: 'Vehicle type',
  NEW_VEHICLE_CONDITION: 'New',
  USED_VEHICLE_CONDITION: 'Used',
  VEHICLE_MODEL_SECTION: 'Model',
  VEHICLE_USAGE_AND_IDENTIFICATION_SECTION: 'Usage and identification',
  VEHICLE_IDENTIFICATION_SECTION: 'Identification',
  EUROTAX_CODE_HINT: 'Eurotax code $v1',
  NEW_VEHICLE_PLATE_NUMBER_HINT: 'If it is already registered',
  NEW_VEHICLE_IDENTIFICATION_NUMBER_HINT: "If you don't have it yet, it can be added later",
  IDENTIFICATION_NUMBER_ALREADY_USED_HINT: 'There is already an application with this VIN',
  MODEL_DATE_SUFFIX_TOOLTIP:
    "The final number shows the model's year and month (YYYYMM). For example, 201607 is the July 2016 model.",
  VERSION_DATE_SUFFIX_TOOLTIP:
    "The final number shows the version's year and month (YYYYMM). For example, 201607 is the July 2016 version.",
  PREVIOUS_VALUE: 'Before: $v1',
  VEHICLE_CONDITION_NOT_EDITABLE: 'It cannot be changed in an application already created',
  FINANCING_RESELECTION_REQUIRED: 'It has to be chosen again',
  FINANCING_RESELECTION_REQUIRED_DESCRIPTION:
    'Changing the amount or the registration date invalidates the current instalment ($v1, $v2 months).',
  LOADING_AUTO_DETAILS: 'Loading vehicle details...',

  // Cart
  // -- ALREADY EXISTS -- ORDER_LINES: 'Order Items',
  CART_TEXT: 'Complete the cart items',
  CART_TEXT_KTUIN: 'Select the product and the amount to finance',
  ORDER_REFERENCE_1_TOOLTIP:
    'Reference in your system for this order. You cannot use a reference that has already been used in a confirmed payment session.',
  ORDER_REFERENCE: 'References',
  ORDER_REFERENCE_DETAILS: 'Order reference in your system for this order',
  REFERENCE_NOT_VALID: 'This reference has already been used',
  ORDER_REFERENCE_1: 'Order reference',
  ORDER_REFERENCE_2: 'Order reference 2',
  ORDER_REFERENCE_LABEL: 'Order reference',
  DISABLED_TOOLTIP_CART_ERROR: 'To continue, check the cart. It is incomplete or contains errors.',
  DISABLED_TOOLTIP_REFERENCE_ERROR: 'To continue, check the reference for order 1.',
  DISABLED_TOOLTIP_REFERENCE_AND_CART_ERROR: 'To continue, check the reference for order 1 and the cart.',

  // -- ALREADY EXISTS -- UNITS: 'Units',
  UNITS_SHORT: 'Units',
  UNIT_PRICE: 'Unit price',
  // -- ALREADY EXISTS -- UNIT_PRICE_WITH_TAX: 'Unit price including VAT',
  VAT_TOOLTIP: 'If operating in the Canary Islands, it would be considered IGIC',
  ADD_NEW_ITEM: 'Add item',
  NEW_ITEM: 'New item',
  EDIT_ITEM: 'Edit item',
  DELETE_ITEM: 'Delete item',
  SUBTOTAL: 'Subtotal',
  // -- ALREADY EXISTS -- TOTAL: 'Total',
  // -- ALREADY EXISTS -- VAT_AMOUNT: 'VAT Amount',
  TOTAL_PRICE: 'Total amount',
  TOTAL_PRICE_WITH_TAX: 'Total amount (unit price x units) including VAT',
  TOTAL_PRICE_WITH_INFO: 'Incl. taxes and discounts',
  ACCEPT: 'Accept',
  IN: 'at',
  OR: 'or',

  // Cart Dialog
  ARTICLE_INFORMATION: 'Article information',
  ARTICLE_TYPE: 'Article type',
  SAVE_AND_NEW_ITEM: 'Save and add new item',
  CART_DIALOG_CANCEL_CONFIRM: 'Are you sure you want to close the window?',
  CART_DIALOG_CANCEL_CONFIRM_TEXT: 'The changes made will be lost',
  CART_DIALOG_SUCCESS: 'Item successfully updated',
  // -- ALREADY EXISTS -- SAVE: 'Save',
  [ArticleType.FLIGHT]: 'Flight',
  [ArticleType.ACCOMMODATION]: 'Accommodation',
  [ArticleType.SERVICE]: 'Service',
  [ArticleType.ONLINE_PRODUCT]: 'Product',
  [ArticleType.AUTOMOBILE]: 'Automobile',
  [ArticleTypeExternal.PRODUCT]: 'Product',

  // Product
  PRODUCT_DETAILS: 'Product details',
  ARTICLE_DESCRIPTION: 'Product description',
  ARTICLE_CATEGORY: 'Category',
  [`ARTICLE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'Physical',
  [`ARTICLE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_CATEGORY_${ArticleCategory.DISCOUNT}`]: 'Discount',
  [`ARTICLE_CATEGORY_${ArticleCategory.SHIPPING_FEE}`]: 'Shipping cost',
  [`ARTICLE_CATEGORY_${ArticleCategory.GIFT_CARD}`]: 'Gift card',

  // Service
  SERVICE_DETAILS: 'Service details',
  SERVICE_DESCRIPTION: 'Service description',
  SERVICE_ENDS_ON: 'Service end date',
  ARTICLE_SERVICE_CATEGORY: 'Category',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'In-person',

  // Accommodation
  // -- ALREADY EXISTS -- ACCOMMODATION: 'Accommodation',
  ACCOMMODATION_NAME: 'Accommodation name',
  ACCOMMODATION_NAME_PLACEHOLDER: 'Hotel Boutique Chaplin',
  ACCOMMODATION_DETAILS: 'Accommodation details',
  CHECKIN_DATE: 'Check-in date',
  CHECKOUT_DATE: 'Check-out date',

  // Flight
  FLIGHT_DETAILS: 'Flight details',
  FLIGHT_ONE_WAY: 'One way',
  FLIGHT_OUTBOUND: 'Outbound date',
  FLIGHT_INBOUND: 'Inbound date',
  FLIGHT_REFERENCE: 'Flight reference',
  FLIGHT_REFERENCE_PLACEHOLDER: 'VY6760',
  DEPARTURE_AIRPORT: 'Departure airport (IATA)',
  DESTINATION_AIRPORT: 'Destination airport (IATA)',
  DATE: 'Date',
  IS_ROUND_TRIP: 'Round trip',
  PASSENGERS_DETAILS: 'Passengers details',
  PASSENGER_DOCUMENT_NUMBER: 'Passenger document number #$v1',
  ADD_ANOTHER_PASSENGER: 'Add another passenger',

  // Travel
  TRAVEL_DETAILS: 'Travel details',
  TRAVEL_DESTINATION: 'Destination',
  TRAVEL_DESTINATION_PLACEHOLDER: 'Egypt',
  TRAVEL_DESCRIPTION: 'Description',
  TRAVEL_DESCRIPTION_PLACEHOLDER: 'Tour of the Pyramids of Giza',
  [`TRAVEL_CATEGORY_${TravelCategory.SENIOR_TRAVEL_PROGRAMS}`]: 'Senior programs',
  [`TRAVEL_CATEGORY_${TravelCategory.BUS}`]: 'Bus',
  [`TRAVEL_CATEGORY_${TravelCategory.CIRCUITS}`]: 'Circuits',
  [`TRAVEL_CATEGORY_${TravelCategory.CARS}`]: 'Cars',
  [`TRAVEL_CATEGORY_${TravelCategory.CRUISE}`]: 'Cruise',
  [`TRAVEL_CATEGORY_${TravelCategory.DISNEY}`]: 'Disney',
  [`TRAVEL_CATEGORY_${TravelCategory.TICKETS}`]: 'Tickets',
  [`TRAVEL_CATEGORY_${TravelCategory.EXCURSIONS}`]: 'Excursions',
  [`TRAVEL_CATEGORY_${TravelCategory.FERRY}`]: 'Ferries',
  [`TRAVEL_CATEGORY_${TravelCategory.GRAND_TOURS}`]: 'Grand Tours',
  [`TRAVEL_CATEGORY_${TravelCategory.PACKAGE}`]: 'Package',
  [`TRAVEL_CATEGORY_${TravelCategory.INSURANCE}`]: 'Insurance',
  [`TRAVEL_CATEGORY_${TravelCategory.THEMATIC}`]: 'Thematic',
  [`TRAVEL_CATEGORY_${TravelCategory.TRANSFERS}`]: 'Transfers',
  [`TRAVEL_CATEGORY_${TravelCategory.TRAINS}`]: 'Trains',
  [`TRAVEL_CATEGORY_${TravelCategory.OTHER}`]: 'Other',
  TRAVEL_TRAVELLERS: 'Number of travelers',

  // Cart Validation
  REFERENCE_CHARACTER_NOT_ALLOWED: 'The only special characters allowed are /, \\, -, _, + and @.',
  AMOUNT_MUST_BE_NEGATIVE: 'The amount must be negative',
  AMOUNT_MUST_BE_POSITIVE: 'The amount must be positive',
  VALUE_MUST_BE_POSITIVE: 'The value must be positive',
  DOWN_PAYMENT_AMOUNT_MUST_BE_LESS_THAN_CART_AMOUNT:
    'The down payment amount must be less than the total amount of the cart',
  AMOUNT_NOT_ZERO: 'The amount must be different from 0',
  MORE_THAN_ONE_UNIT_ERROR: 'Item limited to 1 unit',
  AT_LEAST_ONE_UNIT_ERROR: 'At least 1 unit required',
  INVALID_PERCENTAGE: 'Invalid percentage',
  INVALID_NEGATIVE_PERCENTAGE: 'Negative percentage is not valid',
  PAST_DATE_NOT_ALLOWED: 'Past date not allowed',
  FUTURE_DATE_NOT_ALLOWED: 'Future date not allowed',
  CHECKOUT_DATE_CANNOT_BE_PRIOR_TO_CHECKIN_DATE: 'The checkout date cannot be prior or equal to the check-in date',
  RETURN_DATE_CANNOT_BE_PRIOR_TO_DEPARTURE_DATE:
    'The return flight date cannot be prior or equal to the departure flight date',
  END_DATE_CANNOT_BE_PRIOR_TO_START_DATE: 'The start date cannot be prior to or equal to the end date',
  FLIGHT_REFERENCE_SHOULD_HAVE_AT_LEAST_3_CHARACTERS: 'The flight reference code must have at least 3 characters',
  FLIGHT_REFERENCE_SHOULD_HAVE_MAX_8_CHARACTERS: 'The flight reference code cannot have more than 8 characters',
  DOCUMENT_NUMBER_SHOULD_HAVE_AT_LEAST_4_CHARACTERS: 'The document number should have at least 4 characters',
  DOCUMENT_NUMBER_SHOULD_HAVE_MAX_15_CHARACTERS: 'The document number cannot have more than 15 characters',
  AT_LEAST_ONE_TRAVELLER_ERROR: 'Minimum 1 traveler',

  // Cart Alerts
  CART_ALERT_ARTICLE_TOTAL: (
    <>
      The cart total must be <strong>positive</strong>. Check the amount of your products and discounts.
    </>
  ),
  CART_ALERT_ARTICLE_INCOMPLETE: (
    <>
      Some of the items in the cart are <strong>incomplete</strong>. Check the details of each line in the cart.
    </>
  ),
  CART_ALERT_ITEM_ERROR: (
    <>
      The cart or some of its items have a <strong>error</strong>. Check it to continue.
    </>
  ),
  CART_ALERT_ARTICLE_CATEGORY: (
    <>
      There are no products with a <strong>physical</strong> or <strong>digital</strong> category. Please check the
      categories of the entered products.
    </>
  ),
  CART_ALERT_ARTICLE_TYPE_START: 'At least one item of type is needed',
  CART_ALERT_ARTICLE_TYPE_END: 'to continue',
  CART_ALERT_ARTICLE_TYPE_SERVICE_ADDITIONAL: 'Only 1 service per order is allowed.',
  CART_ALERT_ARTICLE_TYPE_AUTO_ADDITIONAL: 'Only 1 vehicle per order is allowed.',
  CART_ALERT_PAYMENT_METHODS: 'There are no available payment methods for the current amount of the shopping cart.',
  CART_ALERT_AGENT_CONFIGURATION: (
    <>
      It seems that the agent needs to <strong>sync their payment methods configuration</strong>. Please contact{' '}
      <a href="mailto:hola@nemuru.com">hola@nemuru.com</a> to report this issue.
    </>
  ),

  // Application Payment method
  // -- ALREADY EXISTS -- PAYMENT_METHOD: 'Payment method'
  PAYMENT_METHOD_INSTRUCTIONS: "Enable payment methods for your customer's purchase",
  PAYMENT_PROPOSAL_DETAILS: 'Checkout details',

  //CHECKOUT SESSION CREATION
  CHECKOUT_SESSION_CREATION: 'Complete the payment process',
  CHECKOUT_SESSION_CREATION_DESCRIPTION: 'Select how you want to complete the payment process',
  COMPLETE_PAYMENT_PROCESS: 'Complete the payment process',
  SELECT_HOW_TO_COMPLETE_PAYMENT_PROCESS: 'Select how you want to complete the payment process',
  SEND_TO_MY_CLIENT: 'Send to my client',
  SHARE_PAYMENT_LINK: 'Share request link',
  SHARE_PAYMENT_LINK_WITH_YOUR_CLIENT:
    'Share the payment link with your client. Your client will complete the payment process from their device.',
  START_MERCHANT_POS_PROCESS: 'Start the process',
  MERCHANT_POS_PROCESS_DESCRIPTION:
    'Complete the payment process on behalf of your client. By clicking continue, you consent and affirm that your client is at the point of sale and that their identity has been validated.',
  START_NOW: 'Start now',
  LOADING_CHECKOUT_SESSION_CREATION: 'Creating checkout...',
  LOADING_CHECKOUT_SESSION_RESTORING: 'Restoring data from checkout...',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_PAYMENT_METHODS_DESCRIPTION:
    'The selected payment methods do not allow completing the payment process on behalf of your customer.',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_AGENT_DESCRIPTION:
    'The configuration of the selected agent for the checkout does not allow completing the payment process on behalf of your customer.',
  FILL_IN_INTERVENERS_DATA: 'Fill in the information of the holder (and other interveners)',
  FILL_IN_INTERVENER_DATA: 'Fill in the information of $v1',
  INTERVENERS: 'Participants',
  DOCUMENT_ID_FORM_INFO:
    "Later, you will need to upload a photo of the customer's identity document. Make sure the data entered below matches the information on that document.",
  NET_INCOME_FORM_INFO:
    'Please declare the real income of $v1. A proof of income, such as a payslip, pension, or other valid document, will be required to confirm this information.',
  BANK_ACCOUNT_FORM_INFO:
    'Remember that the holder must appear as the account holder of the bank account. Proof of ownership will be requested later to confirm the accuracy of the information.',
  RECENT_BORROWERS: 'Recent participants',

  //CHECKOUT SESSION DETAILS (MERCHANT)
  [`${PaymentMethodType.A2A_PAYMENT}_tab_label`]: 'Instant transfer',
  [`${PaymentMethodType.B2B_LOAN}_tab_label`]: 'B2B Loan',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_tab_label`]: 'Installment payment',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_tab_label`]: 'Split payment',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_tab_label`]: 'Financing',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_tab_label`]: 'Interest-free financing',
  [`${PaymentMethodType.CARD_PAYMENT}_tab_label`]: 'Card payment',
  [`${PaymentMethodType.SUBSCRIPTION}_tab_label`]: 'Subscription',
  [`${PaymentMethodType.CREDIT_LINE}_tab_label`]: 'Credit line',
  [`${PaymentMethodType.AUTO_LOAN}_tab_label`]: 'Auto loan',
  [`${PaymentMethodType.CREDIT_CARD}_tab_label`]: 'Credit card',
  [`${PaymentMethodType.CARD_ONBOARDING}_tab_label`]: 'Credit card',
  NEXT_STEPS: 'Next steps',
  EDIT_BORROWER: 'Edit borrower',
  EDIT_CO_BORROWER: 'Edit co-borrower',
  EDIT_DATA: 'Edit data',
  [`ADD_${OnboardingDetailsRole.CO_BORROWER}`]: 'Add Co-borrower',
  [`ADD_${OnboardingDetailsRole.GUARANTOR}`]: 'Add guarantor',
  INVALID_PROGRESS: 'Progress not available',
  ALL_ACTIONS_COMPLETED: 'All actions completed',
  SEE_PROGRESS_HISTORY: 'See complete history',
  SEE_PROGRESS_HISTORY_MOBILE: 'History',
  UPLOAD: 'Upload',
  SEE_CLIENT_HISTORY: 'See history',
  CLIENT_HISTORY: '$v1 history',
  SIGNATURE_LENDER_CONTRACT: '$v1 contract',
  SIGNATURE_LENDER_CONTRACT_SANTANDER: 'Redirect to Santander',
  SIGN_CONTRACT: 'Sign',
  SIGN_BORROWER_CONTRACT: 'Sign borrower',
  SIGN_CO_BORROWER_CONTRACT: 'Sign co-borrower',
  CONTRACT_SIGNED_SUCCESSFULLY: 'Contract signed successfully',
  CONTRACT_SIGNED_SUCCESSFULLY_DESCRIPTION:
    'The contract with the financial entity has been digitally signed correctly. You can close this window safely.',

  SIGNATURE_GENERIC_MESSAGE: 'Click on sign to start the signature process. ',
  REDIRECT_SIGNATURE_BS:
    'Before you can sign the contract, your client must download the credit information that will be received via SMS. Once this step is completed, you can sign the contract digitally.',
  REDIRECT_SIGNATURE_SANTANDER:
    "Click on complete to be redirected to the Santander Consumer Finance platform, where you can complete your customer's financing application.",
  REDIRECT_SIGNATURE:
    'Click on sign to be redirected to the digital signature process. Your client will receive an SMS with the code you should enter to complete the signature.',
  EMBEDDED_REDIRECT_SIGNATURE:
    'Click on sign to open the digital signature process. Your client will receive an SMS with the code you should enter to complete the signature.',
  SAML_SIGNATURE:
    'Click on sign to start the signature process. Your client will receive an SMS with the code you should enter to complete the signature.',
  ASYNC_SIGNATURE_EMAIL:
    'Your client will receive an email with the instructions to sign the contract shortly. You can remind them to check their inbox and also the spam or promotions folder.',
  ASYNC_SIGNATURE_SMS:
    'Your client will receive an SMS with a link to sign the contract. You can remind them to check their phone to complete the process.',
  SIGNATURE_FROM_CAIXABANK_APP_MESSAGE:
    'This contract must be signed using the CaixaBank P&C signing app. Access the app from your device and assist the customer with the signing process.',
  RESIGNATURE_MESSAGE: 'The contract requires a new signature. Click re-sign to start the digital signature process.',
  RESIGNATURE_CONTRACT: 'Re-sign',
  LOAN_RETENTION_INTERNAL_REVIEW: 'Application under internal review by the financial institution',
  LOAN_RETENTION_CONTRACT_RESIGNATURE: 'The contract needs to be signed again',
  LOAN_RETENTION_DOCS_INCIDENCE: 'There are document incidences that need to be resolved',

  NO_CONDITIONS_AVAILABLE: 'Oops! No conditions available',
  NO_CONDITIONS_AVAILABLE_DESCRIPTION:
    'It seems that this payment method does not have conditions available for this purchase. Please select another payment method or contact your agent to help you.',
  IN_ONE_CARD_PAYMENT: 'in one full payment with card',
  IN_ONE_A2A_PAYMENT: 'in one full payment with bank transfer',

  MORE_ACTIONS: 'More actions',
  AVAILABLE: 'Available',
  NOT_AVAILABLE: 'Not available',
  NOT_STARTED: 'Not started',

  // MERCHANT POS FORM
  ID_ALREADY_USED: 'Document number already used',
  FULL_NAME_ALREADY_USED: 'Full name already used',
  EMAIL_ALREADY_USED: 'Email already used',
  PHONE_NUMBER_ALREADY_USED: 'Phone number already used',

  // Application Distribution
  APPLICATION_DISTRIBUTION_TITLE: 'Payment link distribution',
  APPLICATION_DISTRIBUTION_INSTRUCTIONS: 'Share the payment link with your customer',
  APPLICATION_DISTRIBUTION_DETAILS:
    'Send the link via email or SMS, show a QR code, or copy and distribute the link through your channels.',

  SMS: 'SMS',
  SEND_LINK: 'Send link',
  // FIXME habría que ponerlo en algún lado del proceso
  APPLICATION_SUCCESS_MESSAGE: (
    <>
      The checkout has been sent to your client via the selected distribution method(s). Remember that they have{' '}
      <strong>30&nbsp;days</strong> to access the link and complete the payment process. After that time, the link will
      expire.
    </>
  ),
  APPLICATION_DISTRIBUTION_ALERT:
    'Your client has 30 days to access and complete the payment of the first installment.',

  // NEW CHECKOUT SESSION APPLICATION :
  SELECTED: 'Selected',
  FOR: 'For',
  AND: 'And',
  LOWERCASE_AND: 'and',
  FROM_AMOUNT: 'From',
  CONFIGURE: 'Configure',
  PAYMENT_METHODS_TITLE: 'Payment methods',
  PAYMENT_METHODS_TEXT: 'Set up the available payment methods for your customer',
  SEE_FILTERS: 'See filters',
  QUOTA: 'Quota',
  SETUP_FEE_SHORT: 'Setup fee',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: 'Setup fee (financed)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Setup fee (fixed/instalment)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: 'Setup fee (upfront)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: '(financed)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: '(fixed/cuota)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: '(upfront)',
  MERCHANT_COST: 'Merchant cost',
  MERCHANT_COST_SHORT: 'Cost',
  FREE: 'Free',
  CONDITIONS_GROUP_NOT_FOUND_START:
    'There are no options available for the selected term. For the selected filters, the available terms range between',
  [FilterType.WITH_GRACE_PERIOD]: 'With grace period',
  [FilterType.WITH_MERCHANT_DISCOUNT_PERCENTAGE]: 'With merchant discount',
  [FilterType.WITH_SETUP_FEE]: 'With setup fee',
  VALUE_MUST_BE_BETWEEN: 'Value must be between',
  START_PAYMENT_METHOD: 'Start payment method',
  START_PAYMENT_METHOD_DESCRIPTION: 'Click on the button to start this payment method.',
  CREDIT_CARD_START_PAYMENT_METHOD: 'Start credit card application',
  CREDIT_CARD_START_PAYMENT_METHOD_DESCRIPTION:
    'Click on the button to start the application process for Iberia Cards credit card.',

  // DISTRIBUTION DIALOG
  SHARE_PAYMENT_LINK_DESCRIPTION: 'Choose how you want to share the request link with your client:',
  [DistributionMethod.COPY_LINK]: 'Copy link',
  [DistributionMethod.SEND_LINK]: 'Send link',
  [DistributionMethod.SHOW_QR]: 'Show QR code',
  [`${DistributionMethod.COPY_LINK}_SHORT`]: 'Copy',
  [`${DistributionMethod.SEND_LINK}_SHORT`]: 'Send',
  [`${DistributionMethod.SHOW_QR}_SHORT`]: 'QR',
  SHARE: 'Share',
  SHARE_WITH_CUSTOMER: 'Share link',
  SENT_TO: 'Sent to',
  SENT_AT_TIME: 'Sent date',
  VIEWED_AT: 'Opened at',
  SENDING: 'Sending...',
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION:
    'The maximum limit of available payment link distributions has been reached. You can copy the link and send it through other channels, or show the QR code to your client.',
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION_CREDIT_CARD: 'The maximum number of payment link sends has been reached.',
  AN_ERROR_OCURRED: 'An error occurred',
  SEE_DISTRIBUTIONS: 'View distributions',
  DISTRIBUTIONS_HISTORY: 'Distributions history',
  DISTRIBUTIONS_HISTORY_DESCRIPTION:
    'Here you can see the history of distributions of the payment link to this checkout session.',

  // CHECKOUT SESSION DETAILS
  CHECKOUT_SESSIONS: 'Checkouts',
  CHECKOUT_SESSION: 'Checkout',
  SESSIONS: 'Sessions',
  CHECKOUT_SESSION_DETAIL: 'Checkout session details',
  CHECKOUT_SESSIONS_OVERVIEW: 'Checkout sessions overview',
  CHECKOUT_SESSION_DETAILS: 'Checkout session details',
  CHECKOUT_SESSION_OVERVIEW: 'Overview',
  CHECKOUT_SESSION_ID: 'Checkout Id:',
  CANCEL_CHECKOUT_SESSION: 'Cancel checkout',
  CANCEL_CHECKOUT_SESSION_SHORT: 'Cancel payment',
  CANCEL_CHECKOUT_SESSION_DESCRIPTION: "Do you want to cancel your client's checkout?",
  [DownPaymentCollection.NONE]: 'None',
  [DownPaymentCollection.BEFORE_CONFIRM]: 'Before confirm',
  [DownPaymentCollection.UPFRONT]: 'Upfront',
  PURCHASE_COUNTRY: 'Purchase country:',
  EXPIRES_IN: 'Expires in:',
  OWNER: 'Owner',
  ACTIVE_PAYMENT_METHODS: 'Enabled payment methods',
  PAYMENT_INTENTS: 'Payment requests',
  PAYMENT_INTENTS_LIST_TITLE: 'Payment intents',
  NO_PAYMENT_INTENTS: 'No payment requests have been generated yet',
  ARTICLE_IN_CART: '$v1 x $v2',
  TOTAL_TO_FINANCE: 'Total to finance',
  TOTAL_TO_PAY: 'Total to pay',
  [HppStatus.COMPLETED]: 'Completed',
  [HppStatus.CHALLENGE]: 'Challenge',

  // CHECKOUT SESSION DETAIL (MERCHANT EDITION)
  PROPOSAL_FOR: 'Checkout for',
  EVALUATE_AND_CONFIRM: 'Payment methods',
  EVALUATE_AND_CONFIRM_TEXT: 'Process and confirm the desired payment method for your client',
  NOT_PROCESSED: 'Not processed',
  PROCESSED: 'Processed',
  PAY: 'Pay',
  EVALUATE: 'Evaluate',
  REEVALUATE: 'Evaluate again',
  COMPLETE: 'Complete',
  PENDING_ACTIONS: 'Pending actions',
  [Action.COMPLETE_ONBOARDING]: 'Complete the application process',
  [Action.NO_LENDER_REQUEST_ID]: 'Waiting for entity response',
  [Action.PAY]: 'Complete the payment',
  [Action.UPLOAD_DOCUMENTS]: 'Upload the required documents',
  [Action.REVIEW_DOCUMENTS]: 'Revise uploaded documents',
  [Action.SIGN_CONTRACT]: 'Sign the contract digitally',
  [Action.COMPLETE_PROCESS_SANTANDER]: 'Complete the process in Santander',
  [Action.PAY_FIRST_INSTALMENT]: 'Pay the first installment by card',
  [Action.CAPTURE_ORDER]: 'Capture order',
  [Action.COMPLETE_KYC]: 'Complete identity verification',
  [Action.VALIDATE_CARD_DATA]: 'Validate card data with the agent',
  [Action.PRINT_CARD]: 'Card expedition',
  VALIDATE_CARD_DATA_DESCRIPTION:
    'Open the validation flow so an agent can review and validate the client data.',
  VALIDATE_CARD_DATA_CTA: 'Open validation',
  PRINT_CARD_DESCRIPTION:
    'Resend the card expedition QR to the client by email so the merchant can print the card.',
  PRINT_CARD_CTA: 'Resend QR by email',
  PRINT_CARD_QR_STUB: 'The card expedition QR is sent by email.',
  PRINT_CARD_SENT_SUCCESS: 'The card expedition QR has been sent by email.',
  PAYMENT_INTENT_APPROVED_BY: 'Approved by',
  PAYMENT_INTENT_ON_HOLD_IN: 'On hold in',
  PAYMENT_INTENT_TO_BE_COMPLETED: 'You can complete the process or share the link for your client to finish.',
  PAYMENT_INTENT_CANCELLED: 'The request has been denied by the financial entities.',
  PAYMENT_INTENT_PROCESSING: 'Please wait, your request is being processed by the financial entities.',
  NO_LENDER_REQUEST_ID_TITLE: 'No response from $v1',
  NO_LENDER_REQUEST_ID_TITLE_TEXT:
    'It has not been possible to obtain a response from the financial entity at the moment. Once the request has been processed correctly, the process will continue automatically.',
  NO_SIGNATURE_AVAILABLE_TITLE: 'Signature not available',
  NO_SIGNATURE_PROCESS_AVAILABLE_AT_THE_MOMENT:
    'The digital signature process in $v1 is not available at the moment. When it becomes available, you will be able to sign the contract digitally.',
  PAY_TITLE: 'Pending card payment',
  PAY_DESCRIPTION:
    'You must share the payment link with your client so they can access the process and complete the payment. Once the payment is made, the process will be completed automatically.',

  // PROCESSING STRATEGY
  PROCESSING_STRATEGY: 'Financial entities response',
  PROCESSING_STRATEGY_MOBILE: 'Responses',
  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE: 'Choose entity',
  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE_TEXT:
    'Select the financial entity manually to continue with the application process.',

  PROCESSING_SUMMARY_SINGLE: 'A single entity available',
  PROCESSING_SUMMARY_SINGLE_AUTOMATIC_TEXT:
    "The application is sent automatically to the only available entity. You don't have to do anything.",
  PROCESSING_SUMMARY_SINGLE_MANUAL_TEXT: 'Send the application to the only available entity from its row.',

  PROCESSING_SUMMARY_PARALLEL: 'All entities are consulted at once',
  PROCESSING_SUMMARY_PARALLEL_TEXT:
    "The application is sent at the same time to every entity on the list. When they respond, the platform keeps the best offer. You don't have to do anything.",

  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC: 'The platform consults the entities one by one',
  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC_TEXT:
    "It is sent to the first on the list and waits for a response before moving to the next. The platform advances on its own in the order you see below. You don't have to do anything.",

  PROCESSING_SUMMARY_WATERFALL_MANUAL: 'You decide which entity to send to',
  PROCESSING_SUMMARY_WATERFALL_MANUAL_TEXT:
    "Nothing is sent automatically. The order below is the platform's recommendation, but you can start with whichever you prefer. Send the application from each row and its response will appear here.",

  [`PROCESSING_SUMMARY_STOP_${StopCondition.YES}`]:
    'It stops when an entity approves. If one declines or fails, it continues with the next.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.MAYBE}`]:
    'It stops when an entity approves or leaves the application under review. If one declines or fails, it continues with the next.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.NO}`]:
    'It stops with the first entity that replies, even if it declines. There will be no automatic second attempt.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.ERROR}`]:
    'It stops with the first entity that replies, whatever the response. In practice only one entity is consulted.',

  DOCUMENTATION_SYNC_IN_PROGRESS: 'Just a moment...',
  DOCUMENTATION_SYNC_IN_PROGRESS_TEXT:
    'We are obtaining the documents required by the selected entity. Please wait a few seconds.',
  DOCUMENTATION_SYNC_COMPLETED: 'Documents synchronized',
  DOCUMENTATION_SYNC_COMPLETED_TEXT:
    'The documents required by the selected entity have been synchronized correctly. You can close this window and upload the documents to complete the application.',

  SELECTED_PAYMENT_METHOD: 'Selected payment method',
  OTHER_PAYMENT_METHODS: 'Other payment methods',

  // CHECKOUT SESSION DETAIL - EDIT
  EDIT_CHECKOUT_SESSION_ACTION_CART: 'Edit cart',
  EDIT_CHECKOUT_SESSION_ACTION_CART_AUTO: 'Edit vehicle',
  EDIT_CHECKOUT_SESSION_ACTION_DOWN_PAYMENT: 'Edit downpayment',
  EDIT_LEAVE_ALERT_TITLE: 'Leave edit dialog',
  EDIT_LEAVE_ALERT_DESCRIPTION: 'Attention, if you close the dialog, all your changes will be lost.',
  EDIT_PAYMENT_METHOD_CONDITIONS: 'Edit payment method configuration',
  EDIT_PAYMENT_METHOD_CONDITIONS_INSTRUCTIONS: "Select a new configuration for your client's payment method:",
  CART_EDIT: 'Edit cart',
  CART_EDIT_INSTRUCTIONS: 'Edit the details of the cart of the checkout:',
  CART_EDIT_AUTO: 'Edit vehicle',
  EDIT_VEHICLE_DATA: 'Edit vehicle',
  SPECS_TAB: 'Vehicle',
  FINANCING_TAB: 'Financing',
  VEHICLE_AMOUNT_REQUIRES_FINANCING_RESELECTION_DESCRIPTION:
    'The vehicle amount and/or registration date has changed. Select new conditions in the simulator before continuing.',
  LIVE_SUMMARY: 'Summary',
  BORROWER_SUMMARY: 'Borrower details',
  FINANCING_SUMMARY: 'Financing',
  EDIT_VEHICLE_DATA_IN_LENDER_PLATFORM:
    'The financial institution does not allow modifying vehicle data from our platform. Please access the $v1 platform to make the changes. Sorry for the inconvenience.',
  MISSING_VEHICLE_DATA_WARNING: 'Vehicle data required to sign the contract is missing',
  SIGNATURE_MISSING_VEHICLE_DATA_EDITABLE:
    'To sign the contract, complete the vehicle data. You must **LINK**edit the vehicle data**LINK**.',
  SIGNATURE_MISSING_VEHICLE_DATA_NOT_EDITABLE: 'Vehicle data cannot be modified from our platform.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_PLATFORM:
    'Remember that when signing the contract, the vehicle identification number (VIN) and license plate must be reported. You can do this from the "Edit" menu in the top right.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_LENDER:
    "Remember that when signing the contract, the vehicle identification number (VIN) and license plate must be reported. You must make the change in the financial institution's application",
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_PLATFORM:
    'Remember that when signing the contract, the vehicle identification number (VIN) must be reported. You can do this from the "Edit" menu in the top right.',
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_LENDER:
    "Remember that when signing the contract, the vehicle identification number (VIN) must be reported. You must make the change in the financial institution's application.",
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_PLATFORM:
    'Remember that when signing the contract, the license plate must be reported. You can do this from the "Edit" menu in the top right.',
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_LENDER:
    "Remember that when signing the contract, the license plate must be reported. You must make the change in the financial institution's application",
  CHANGE_DATA: 'Modify data',
  REQUEST_TO_LENDER_DELAY_WARNING:
    'This operation may take a few seconds to complete. Please wait while we communicate the changes to the financial institution...',
  AUTO_MODIFICATION_PREVIEW_ERROR: 'Could not preview vehicle data changes',
  AUTO_MODIFICATION_SAME_LENDER_INVALID: 'The current lender is no longer valid',
  AUTO_MODIFICATION_SAME_LENDER_INVALID_DESCRIPTION:
    'With the new conditions, the current lender is no longer valid. Conditions cannot be modified.',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE: 'Non-optimal conditions',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_DESCRIPTION:
    'The conditions will be updated with the current financial institution. With this change, the application will no longer have the best offer based on the available rates.',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_OPTIMAL_LENDER: 'The optimal offer would be achieved with $v1.',
  CART_EDIT_INSTRUCTIONS_AUTO: 'Edit the details of the vehicle of the checkout:',
  EDIT_AUTO_PAYMENT_METHOD: 'Edit application data',
  ALERT_CART_NO_CHANGES: 'To continue, you need to make changes to the cart.',
  ALERT_VEHICLE_NO_CHANGES: 'To continue, you need to make changes to the vehicle.',
  REVIEW_CHANGES: 'Review changes',
  CHANGES_REVIEW: 'Review changes',
  CHANGES_REVIEW_DESCRIPTION:
    'These are the modifications made to your application. Please review the changes before continuing.',
  NEW_FINANCING_CONDITIONS: 'New financing conditions',
  NEW_VEHICLE_DETAILS: 'New vehicle details',
  EDIT_APPLICATION: 'Edit application',
  EDIT_APPLICATION_TOOLTIP: 'Edit the application conditions and vehicle data',
  EDIT_FINANCING_DETAILS: 'Edit financing',
  EDIT_FINANCING_DETAILS_TOOLTIP: 'Select the new financing conditions of your application.',
  EDIT_VEHICLE_TOOLTIP: 'Edit the vehicle data',
  ORIGINAL_CART: 'Original purchase',
  ORIGINAL_VEHICLE: 'Original vehicle',
  NEW_CART: 'New purchase',
  NEW_VEHICLE: 'New vehicle',
  NEW_PAYMENT_METHODS_CONFIRMATION: 'Confirm new available payment methods',
  NOTE: 'Note',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOTE: (
    <>
      {'There has been a variation in the '}
      <b>{'total amount of the checkout'}</b>
      {'that would affect the available payment methods of your client:'}
    </>
  ),
  ORIGINAL_CONDITIONS: 'Original configuration',
  NEW_CONDITIONS: 'New configuration',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_ALERT: 'Some of the payment methods are not compatible with your changes.',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_DESCRIPTION:
    'Are you sure yow want to proceed?. This will disable the indicated payment methods.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_ALERT:
    'None of the available payment methods is compatible with your changes.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_DESCRIPTION:
    'Please, for the checkout to be maintained, you need to go back and review the total amount of the checkout.',
  WARNING: 'Warning',
  EDIT_CONFIRM_ALERT_DESCRIPTION:
    'Are you sure you want to send the changes request?. This operation cannot be undone.',
  EDIT_CONFIRM_ALERT_BUTTON: 'Confirm and send',
  PAYMENT_METHOD_RESTORE_ERROR_TITLE: 'Modification not available',
  PAYMENT_METHOD_RESTORE_ERROR_DESCRIPTION: (
    <>
      {'It is not possible to recover the conditions of this payment method.'}
      <p>
        {'It is possible that it is not available for the agent and the financed amount associated with the checkout.'}
      </p>
    </>
  ),
  DOWN_PAYMENT_EDIT: 'Edit down payment',
  DOWN_PAYMENT_EDIT_DESCRIPTION: 'Modify the amount of the down payment of the checkout:',
  OLD_VALUES: 'Old values',
  ALERT_DISABLED_DOWN_PAYMENT_EDIT: 'To continue, change the value of the down payment.',

  //SINGLE PAYMENT DETAIL
  SINGLE_PAYMENT: 'Single payment',
  PROVIDER: 'Provider',
  CARD_PAYMENT_DETAIL: 'Card payment detail',
  SINGLE_PAYMENT_OVERVIEW: 'Overview',
  A2A_PAYMENT_OVERVIEW: 'Transfer payment overview',
  A2A_PAYMENT_DETAIL: 'Transfer payment detail',
  PRODUCT_ID: 'Product ID',
  MERCHANT_KEY: 'Merchant key',
  MERCHANT_PASSWORD: 'Merchant password',
  EXPIRED_AT: 'Expires at:',

  //CARD LIST
  CARD: 'Card',
  CREDIT_CARD: 'Credit card',
  CREDIT_CARD_LIST: 'Credit cards',
  CARD_LIST: 'Cards',
  CARD_DETAIL: 'Card detail',
  CARD_SUBSECTION_TITLE: 'List of cards',
  CARD_OVERVIEW: 'Card overview',
  [PetitionType.BORROWER]: 'Individual',
  [PetitionType.BUSINESS]: 'Company',
  [PaymentMode.END_OF_MONTH]: 'End of month',
  [PaymentMode.FIXED_INSTALLMENT]: 'Fixed instalment',
  [PaymentMode.PERCENTAGE_CONTRACT_LIMIT]: 'Percentage contract limit',
  [PaymentMode.PERCENTAGE_USED_LIMIT]: 'Percentage used limit',
  [PaymentMode.ROUND_INSTALLMENT]: 'Rounded instalment',
  PAYMENT_MODE: 'Payment mode',
  MONTHLY_STATEMENT_DAY: 'Statement day',
  CARD_REQUESTED_LIMIT: 'Credit limit',
  FIXED_INSTALMENT_AMOUNT: 'Fixed instalment',
  PRE_CARD_REQUESTED: 'Pre-requested card',

  //IBERIA CREDIT CARD
  CREDIT_CARD_ID: 'Credit card ID',
  CREDIT_CARD_OVERVIEW: 'Summary',
  CREDIT_CARD_DETAILS: 'Credit card details',
  CREDIT_CARD_CONFIGURATION: 'Credit card configuration',
  CARD_TYPE: 'Card type',
  BRAND_TYPE_AND_PRODUCT: 'Brand/Type/Product',
  MARKETING_CAMPAIGN: 'Marketing campaign',
  APPLICATION_ORIGIN: 'Origin',
  CORPORATE_GROUP: 'Corporate group',
  CUSTOMER_TYPE: 'Customer type',
  PROVIDER_NAME: 'Provider',
  HOLDER_NAME: 'Full name on card',
  CONTRACT: 'Contract',
  CONTRACT_DETAILS: 'Contract details',
  CONTRACT_SIGNATURE: 'Contract signature',
  CONTRACT_SIGNATURE_PENDING: 'Contract signature pending',
  CONTRACT_SIGNED: 'Contract signed',
  CONTRACT_SENT_ON: 'Sent on $v1',
  CONTRACT_SIGNED_ON: 'Signed on $v1',
  CONTRACT_SEND: 'Contract send',
  PENDING_CONTRACT_SEND: 'Pending contract send',
  SIGNATURE_PENDING: 'Signature pending',
  CREDIT_CARD_CONDITIONS: 'Credit card conditions',
  [CreditCardName.ZENIT]: 'Iberia Zenit',
  [CreditCardName.AIRE]: 'Iberia Aire',
  [CreditCardName.ICON]: 'Iberia Icon',
  APPLICATION_PROCESS: 'Application process',
  PERSONAL_DATA: 'Personal data',
  BIRTH_NATIONALITY: 'Birth nationality',
  ADDITIONAL_INFORMATION: 'Additional information',
  PROFESSIONAL_DATA: 'Professional data',
  BANK_ACCOUNT_DATA: 'Bank account data',
  STEP: 'Step',
  USER_AGENT: 'Agent',
  IP: 'IP',
  WORKFLOW_TYPE: 'Workflow type',
  WORKFLOW_PROGRESS: 'Workflow progress',
  CREDIT_CARD_PROGRESS: 'Credit card progress',
  CURRENT_STEP_PROGRESS: 'Current step progress',
  COMPLETED_STEPS: 'Completed steps',
  SPOUSE_EMPLOYED: 'Does your partner work?',
  MONTHLY_EXPENSES: 'Monthly expenses',
  GROSS_INCOME: 'Gross income',
  IBERIA_CLUB: 'Iberia Club',
  IBERIA_CARD_ID: 'Iberia Cards request ID',
  IBERIA_CLUB_NUMBER: 'Iberia Club number',
  [WorkflowPlace.INVITATION]: 'Invitation',
  [WorkflowPlace.KYC_OCR]: 'OCR',
  [WorkflowPlace.PERSONAL_INFO]: 'Personal data',
  [WorkflowPlace.ADDITIONAL_INFO]: 'Additional information',
  [WorkflowPlace.ADDRESS]: 'Address',
  [WorkflowPlace.PROFESSIONAL_DETAILS]: 'Professional data',
  [WorkflowPlace.BANK_ACCOUNT]: 'Bank account data',
  [WorkflowPlace.SUMMARY]: 'Summary',
  [WorkflowPlace.LOW_LIMIT]: 'Credit limit',
  [WorkflowPlace.GDPR]: 'GDPR',
  [WorkflowPlace.INE]: 'INE',
  [WorkflowPlace.CONTRACT_SIGNATURE]: 'Contract signature',
  [WorkflowPlace.KYC_ADDITIONAL_DOCUMENTATION]: 'KYC photo NIE',
  [WorkflowPlace.KYC_VIDEO]: 'Video identification',
  [WorkflowPlace.DOCUMENTATION]: 'Documentation',
  [WorkflowPlace.IBERIA_CLUB]: 'Iberia Club',
  CREDIT_CARD_STATUS_INITIAL: 'Started',
  CREDIT_CARD_STATUS_ON_HOLD: 'Under review',
  CREDIT_CARD_STATUS_REQUESTED: 'Requested',
  CREDIT_CARD_STATUS_APPROVED: 'Pre-approved',
  CREDIT_CARD_STATUS_CONFIRMED: 'Confirmed',
  CREDIT_CARD_STATUS_CAPTURED: 'Captured',
  CREDIT_CARD_STATUS_SIGNED: 'Signed',
  CREDIT_CARD_STATUS_PAID: 'Completed',
  CREDIT_CARD_STATUS_DESISTED: 'The customer has withdrawn',
  CREDIT_CARD_STATUS_EXPIRED: 'Expired',
  CREDIT_CARD_STATUS_CANCELLED: 'Cancelled',
  CREDIT_CARD_STATUS_DENIED: 'Denied',

  // SINGLE PAYMENT LIST
  A2A_PAYMENTS_LIST: 'Immediate transfers',
  A2A_PAYMENT_SUBSECTION_TITLE: 'List of immediate transfers',

  CARD_PAYMENTS_LIST: 'Card payments',
  CARD_PAYMENT_SUBSECTION_TITLE: 'List of card payments',

  // LOADING FEATURES
  MERCHANT_CONFIGURATION: 'Merchant configuration',
  AGENT_IN_LENDER_CONTEXT: 'Credentials in financial institutions',
  MERCHANT_TO_DO_LIST: 'Pending actions',
  MERCHANT: 'Merchant',
  AGENT_PRICINGS: 'Agent pricings',
  LOAN_DETAILS_OVERVIEW: 'Loan details overview',
  BORROWER_CASH_IN_CASH_OUT_DETAILS: 'Borrower cash in cash out details',
  LOAN_ASSET_DETAILS: 'Loan asset details',
  KYC_LOAN: 'KYC loan',
  BORROWER_KYC: 'Borrower KYC',
  LOAN_APPLICATIONS: 'Loan applications',
  PAYOUT_SUMMARY: 'Payout summary',
  COMPLETE_CLIENT_DATA: "Choose a method to send the payment link and fill your customer's data:",
  COPY_LINK_AND_SHARE: 'Copy the link and share it with your client:',
  PAYMENT_LINK_HAS_BEEN_CREATED: 'The payment link has been created!',
  ENABLE_DISTRIBUTION_METHODS: 'Enable the shipping methods to share it with your customer:',
  OR_SHARE_IT_DIRECTLY: 'or share it directly:',
  SHOW_QR: 'Show QR',
  SHOW_QR_TO_SHARE: 'Ask your client to scan the QR to complete the payment:',
  OPEN_LINK: 'Visit',
  NO_DATA_TO_DISPLAY: 'No data to display',

  INVALID_UUID: 'Invalid UUID',

  // INTEGRATIONS
  INTEGRATIONS: 'Integrations',
  WEBHOOKS: 'Webhooks',
  WEBHOOKS_MERCHANT_TEXT: (
    <>
      <p>
        {
          'Your application can subscribe to receive event notifications from Nemuru at a URL of your choice. You will receive notifications for the following events:'
        }
      </p>
      <ul>
        <li>
          <code>{'checkout_session_status_changed'}</code>
          {': The status of the checkout session has changed.'}
        </li>
        <li>
          <code>{'payment_intent_status_changed'}</code>
          {': The status of the payment intent has changed.'}
        </li>
        <li>
          <code>{'conditions_changed'}</code>
          {': When the payment method conditions change.'}
        </li>
        <li>
          <code>{'capture_approved'}</code>
          {': Notification that the capture has been approved.'}
        </li>
        <li>
          <code>{'refund_approved'}</code>
          {': Notification that the refund has been approved.'}
        </li>
      </ul>
      <p>
        {'Check our '}
        <a className="underline" href="https://docs.nemuru.com/webhook-api" target="_blank">
          {'technical documentation'}
        </a>
        {' for more information about the data we send in the notifications (password: '}
        <code>{'Nemuru2024!'}</code>
        {').'}
      </p>
    </>
  ),
  WEBHOOKS_LIST: 'Webhook list',
  CREATE_NEW_WEBHOOK: 'Create new webhook',
  NO_WEBHOOK_CONFIGURED: 'There are no webhooks configured',
  ADD_WEBHOOK: 'Add webhook',
  EDIT_WEBHOOK: 'Edit webhook',
  DELETE_WEBHOOK: 'Delete webhook',
  THE_FOLLOWING_WEBHOOK_WILL_BE_DELETED: 'The following webhook will be deleted:',
  WEBHOOK_URL: 'Webhook URL',
  WEBHOOK_URL_HINT:
    'We will send HTTP POST requests to this URL when events occur. We expect a positive response with a 2XX status; otherwise, we will retry the callback up to 5 times.',
  AUTHORIZATION_TYPE: 'Authorization type',
  AUTHORIZATION_HEADER: 'Authorization header',
  ADDITIONAL_PAYLOAD: 'Additional payload',
  REQUIRED_SELECT_FIELD: 'Please, select an option',
  [`AuthorizationType_${AuthorizationType.NO_AUTH}`]: 'No authorization',
  [`AuthorizationType_${AuthorizationType.BASIC}`]: 'Basic authorization',
  [`AuthorizationType_${AuthorizationType.OAUTH_2}`]: 'OAuth 2.0 authorization',

  // USERS CREDENTIALS
  LOADING_INFORMATION_NEEDED: 'Loading information',
  ADMINS_CREDENTIALS: "Administrators' credentials",
  [`${UserCredentialsType.AGENT}_TAB_LABEL`]: 'Agents',
  [`${UserCredentialsType.ADMIN}_TAB_LABEL`]: 'Administrators',
  CREATE_NEW_AGENT: 'Create new agent',
  CREATE_NEW_CHANNEL: 'Create new channel',
  CREATE_NEW_ADMIN: 'Create new administrator',
  [`${UserCredentialsType.CHANNEL}_BTN`]: 'Create channel',
  [`${UserCredentialsType.AGENT}_BTN`]: 'Create agent',
  [`${UserCredentialsType.ADMIN}_BTN`]: 'Create administrator',
  [`${UserCredentialsType.CHANNEL}_TITLE`]: 'Create new channel',
  [`${UserCredentialsType.AGENT}_TITLE`]: 'Create new agent',
  [`${UserCredentialsType.AGENT}_PASSWORD`]: "Agent's password",
  [`${UserCredentialsType.ADMIN}_TITLE`]: 'Create new administrator',
  [`${UserCredentialsType.ADMIN}_PASSWORD`]: "Administrator's password",
  [`${UserCredentialsType.ADMIN}_EMAIL`]: "Administrator's email",
  CHANNEL_USERS: 'Channel users',
  NO_AGENTS_IN_CHANNEL: 'No agents in channel yet',
  USER_CREDENTIALS_AGENTS: 'Agents credentials',
  LOADING_AGENTS: 'Loading agents...',

  // SIMULATOR
  SIMULATOR: 'Simulator',
  SELECT_CONDITION_FROM_SIMULATOR: 'Select a condition from the simulator',
  SIMULATOR_DISABLED: "The simulator is not yet available for this agent's payment methods.",
  SIMULATOR_DISABLED_AGENT_ACCOUNT:
    'The simulator is not yet available for the payment methods enabled by your administrator.',
  MAXIMIZE: 'Expand',

  // DOCUMENTS VALIDATION
  DECLARED_DATA: 'Declared data',
  STEP_X_OF_Y: 'Step $v1 of $v2',
  DOCUMENT: 'Document',
  VALIDATE: 'Validate',
  DO_NOT_VALIDATE: 'Mark as invalid',
  DOCUMENTS_VALIDATION_ERROR_DESCRIPTION:
    'Please try again later. If the problem persists, contact our support team at: support@nemuru.com',
  DOCUMENTS_VALIDATION_INITIAL_TITLE: 'Documents validation',
  DOCUMENTS_VALIDATION_INITIAL_DESCRIPTION: 'Welcome to the validation process for the issuance of a new card.',
  ENTER_CLIENT_DATA: 'Enter your client document number',
  CLIENT_DOCUMENT_ID: 'Client DNI/NIE number',
  CLIENT_DOCUMENT_ID_MISMATCH: 'The client DNI/NIE number does not match the number entered',
  CLIENT_DOCUMENT_ID_ERROR: 'Unable to fetch document ID data',
  CLOSE_VALIDATION_TITLE: 'Do you want to reset the validation?',
  CLOSE_VALIDATION_DESCRIPTION:
    "If you reset the validation process, you will have to start over, introducing the document number of the checkout's holder.",
  ID_VALIDATION_CHECKBOX:
    'I have validated the identity document provided with the one presented and with the person. I confirm that all three match.',
  ID_VALIDATION_ERROR: 'Unable to fetch document ID validation data.',
  DOCUMENT_ID_FACE_PICTURE: 'Document ID face picture',
  BIOMETRICS_FACE_PICTURE: 'Video ID face picture',
  VIDEO_ID_VALIDATION_CHECKBOX:
    'I have validated the quality of the video identification and its automatic checks. I confirm the two faces provided match',
  VIDEO_ID_VALIDATION_ERROR: 'Unable to fetch video ID validation data.',
  BANK_ACCOUNT_VALIDATION_CHECKBOX:
    'I have validated that the account number and ownership match this document. I confirm the validity of this document.',
  BANK_ACCOUNT_VALIDATION_ERROR: 'Unable to fetch account validation data.',
  INCOME_VALIDATION_CHECKBOX:
    'I have validated that the data provided matches the one presented in the document. I confirm the validity of this document.',
  INCOME_VALIDATION_ERROR: 'Unable to fetch income validation data.',
  DOCUMENTS_VALIDATION_CONFIRMATION: 'Data validated successfully',
  DOCUMENTS_VALIDATION_CONFIRMATION_SUCCESS: 'Congratulations! You have completed the validation of the data.',
  DOCUMENTS_VALIDATION_CONFIRMATION_DESCRIPTION:
    'Congratulations! You have completed the validation of the data. The client will receive a QR code in their email to proceed with the issuance of the credit card. If the client has not received any email, click the button below to resend it.',
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_1: 'If the client has not received any email, click ',
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_2: ' to resend it.',
  SEND_EMAIL_AGAIN: 'Send email again',
  SEND_EMAIL_AGAIN_DIALOG: 'Do you want to resend the email to the address $v1?',
  NO_DOCUMENT_FOUND: 'No document found',
  WE_WERE_NOT_ABLE_TO_FIND_THE_DOCUMENT:
    'We were not able to find the necessary document to proceed with the validation. Confirm with the client that the document has been uploaded correctly and try again to download it.',
  HERE: 'here',
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR_TITLE: 'Unable to validate the documentation',
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR:
    'Since not all documentation has been validated, it is not possible to proceed with the issuance of the credit card. To be able to advance in the process, communicate to the client that he must upload the following documents:',
  CONFIRMATION_NEXT_STEP_1: 'We have sent an email to $v1 with the QR code.',
  CONFIRMATION_NEXT_STEP_2: 'Scan the QR code from the capture app.',
  CONFIRMATION_NEXT_STEP_3: 'Complete the card issuance process in the capture app.',
  RESET_VALIDATION: 'Reset validation',
  RESET: 'Reset',
  NO_LOAN_FOUND: 'Loan not found',
  NO_DOCUMENTATION_FOUND: 'No documentation found associated with this request',
  CANCELLED_CARD: 'This card request has been cancelled',
  CANCEL_CARD: 'Cancel request',
  CANCEL_CARD_DESCRIPTION: 'Do you want to cancel this credit card request?',

  // COMPLETE KYC ACTION STEP
  KYC_STEP_FAILED_TITLE: 'Identity verification rejected',
  KYC_STEP_PENDING_TITLE: 'Identity verification pending',
  KYC_STEP_INITIAL_TITLE: 'Identity verification required',

  KYC_STEP_HARD_FAILED_DESCRIPTION_P1:
    'The maximum number of allowed attempts for identity verification has been reached.',
  KYC_STEP_HARD_FAILED_DESCRIPTION_P2: (
    <>
      If you believe there has been an error, you can call us at <strong>+34 932 200 612</strong> so we can review the
      case.
    </>
  ),

  KYC_STEP_PENDING_DESCRIPTION_P1_NO_EMAIL:
    'The $v1 will receive an email shortly with instructions to complete the identity verification.',
  KYC_STEP_PENDING_DESCRIPTION_P1:
    'The $v2 will receive an email to $v1 shortly with instructions to complete the identity verification.',
  KYC_STEP_PENDING_DESCRIPTION_P2:
    'You may ask them to check their inbox and also review their spam or promotions folder.',

  KYC_STEP_PENDING_BUTTON_TEXT: 'Resend email',
  KYC_STEP_SOFT_FAILED_BUTTON_TEXT: 'Retry verification',

  KYC_STEP_DISCLAIMER: 'Please remember that you can always verify the $v1’s identity in person.',

  KYC_STEP_SOFT_FAILED_DESCRIPTION_P1: 'The identity verification was rejected.',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P2: 'Some common reasons include:',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P3: (
    <>
      <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 32 }}>
        <li>Expired or damaged document</li>
        <li>Unclear images</li>
        <li>Mismatched data</li>
      </ul>
    </>
  ),
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P4: 'You can resend the email to try again.',

  KYC_STEP_INITIAL_DESCRIPTION_P1:
    'To continue with the application, it is necessary to send the $v1 an email with instructions to complete the identity verification.',
  KYC_STEP_INITIAL_BUTTON_TEXT: 'Send email',

  KYC_STEP_PRESENTIAL_VERIFICATION_TEXT: 'Verify in person',

  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_1:
    'By continuing, you confirm that you have verified the $v1’s identity in person and that their details are correct.',
  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_2: (
    <>
      <ul
        style={{
          marginTop: 0,
          marginBottom: 0,
          paddingInlineStart: 32,
          display: 'flex',
          gap: '4px',
          flexDirection: 'column',
        }}
      >
        <li>The person present is the one applying for the financing</li>
        <li>The identity document has been checked</li>
      </ul>
    </>
  ),
  KYC_ERROR_SENDING_VERIFICATION_EMAIL:
    'We were unable to send the email at this time. Please try again in a few minutes.',
  KYC_ERROR_PERFORMING_MANUAL_VERIFICATION:
    'We were unable to confirm the in-person verification at this time. Please try again in a few minutes.',
  KYC_TITULAR: 'Borrower',
  KYC_COTITULAR: 'Co-Borrower',
  KYC_COMPLETED_VERIFICATION_TEXT: 'Identity verification completed',
  KYC_COMPLETED_VERIFICATION_TEXT_SECTION: 'Verifications completed',
  KYC_STEP_PRESENTIAL_VERIFICATION_BUTTON_TEXT: 'Confirm',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.BORROWER}`]: 'borrower',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.COWORROWER}`]: 'co-borrower',

  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_NUMBER_VALIDATION}`]: 'Document number',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_ID_VALIDATION}`]: 'Document ID',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.VIDEO_ID_VALIDATION}`]: 'Video ID',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.BANK_ACCOUNT_VALIDATION}`]: 'Bank account',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.INCOME_VALIDATION}`]: 'Income',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.CONFIRMATION}`]: 'Confirmation',

  // CREDIT CARD CHECKOUT SESSION
  CREDIT_CARD_PURCHASE_TITLE: 'Continue with the application',
  CREDIT_CARD_PURCHASE_FIRST_INSTRUCTIONS:
    'There is an ongoing credit card application. Click continue to resume the process with the customer.',
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_1: (
    <>
      To continue with the application, click <strong>"Share link"</strong> and send it to the customer by email or SMS.
    </>
  ),
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_2: (
    <>
      Make sure the <strong>customer completes the process only through that link and from their own device.</strong>
    </>
  ),
  CREDIT_CARD_PURCHASE_STANDS_SUPERVISOR_PRE_SCORING_INSTRUCTIONS:
    'The application has not completed the summary yet. The stands agent must complete it with the customer up to that step; from then on you can continue it or share the link.',
  CREDIT_CARD_PURCHASE_CONTINUE: 'Continue',
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SALE_POINT_AND_PRODUCT}`]: 'New card application',
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SHORT_CONTACT_FORM}`]: 'Cardholder contact details',
  [`${postCreditCardIberiaCards.name}_rejected`]: 'The application could not be created. Please try again.',
  [`${postCreatePaymentIntent.name}_rejected`]: 'The application could not be started. Please try again.',
  CARD_AND_CAMPAIGN: 'Card / Campaign',
  IBERIA_CARDS_CAMPAIGN_GROUP_INDIVIDUALS: 'Individuals',
  IBERIA_CARDS_CAMPAIGN_GROUP_IBERIA_EMPLOYEES: 'Iberia employees',
  IBERIA_CARDS_CAMPAIGN_GROUP_CORPORATE_GROUPS: 'Corporate groups',
  MOBILE_PHONE_NUMBER: 'Mobile phone number',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED: 'Your user is not set up to operate at stands.',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED_DESCRIPTION: 'Contact your supervisor to enable your sale points.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE: 'Creating applications is not available for your user.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE_DESCRIPTION:
    'Only stands agents can create card applications. If you think you should have access, contact your supervisor.',
  IBERIA_CARDS_STANDS_SALE_POINT_AND_PRODUCT_INTRO: 'Confirm the sale point and the product to apply for.',
  IBERIA_CARDS_STANDS_SHORT_CONTACT_FORM_INTRO:
    "Enter the cardholder's personal details exactly as they appear on their identity document.",
  IBERIA_CARDS_STANDS_DOCUMENT_MATCH_HINT: 'same as on the DNI/NIE',
  IBERIA_CARDS_STANDS_DOCUMENT_NUMBER: 'DNI/NIE',
  IBERIA_CARDS_DATA_PROTECTION_OPT_IN: (
    <>
      {'I confirm that Iberia Cards has provided me with the basic information on '}
      <Link
        href="https://www.iberiacards.es/proteccion-datos/"
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="always"
      >
        <strong>{'Data Protection'}</strong>
      </Link>
      {' and, in particular, on the processing of my data that will take place during the application process.'}
    </>
  ),
  CREDIT_CARD_FETCH_ERROR_TITLE: 'Card information unavailable',
  CREDIT_CARD_FETCH_ERROR_DESCRIPTION: "We couldn't access the card information at this time. Please try again.",
  CREDIT_CARD_FETCH_ERROR_BTN_LABEL: 'Try again',
  CREDIT_CARD_SMS_SENT_TOAST: 'SMS sent',

  // ERROR BOUNDARY
  ERROR_GENERIC: 'An error occurred while processing your request.',
  ERROR_BOUNDARY_TEXT: 'An error occurred while loading the page. Please try again later. ',
  ERROR_BOUNDARY_TEXT_ASYNC: 'An error occurred while processing your request. Please try again later.',
  ERROR_BOUNDARY_TEXT_CONTACT: 'If the problem persists, contact our support team at:',
  ERROR_MESSAGE_ZOD_SCHEMA: 'Error in data scheme validation',
  RELOAD_PAGE: 'Reload page',

  APPLICATION_HISTORY: 'Application History',
  APPLICATION_PROGRESS: 'Request Progress',

  //REQUEST NOTIFICATION MESSAGES
  [`${patchSetAgentConfiguration.name}_fulfilled`]: 'Agent configuration updated.',
  [`${patchSetAgentConfiguration.name}_rejected`]: 'Failed to update agent configuration.',
  [`${patchSetPricingIdsToAgent.name}_fulfilled`]: 'Assigned pricings modified successfully',
  [`${patchSetPricingIdsToAgent.name}_rejected`]: 'There was an issue while trying to modify assigned pricings',
  [`${postCreateAgent.name}_fulfilled`]: 'New agent created successfully.',
  [`${postCreateAgent.name}_rejected`]: 'There was an issue while trying to create the agent.',
  [`${postSyncPricingsToCdnByAgentId.name}_fulfilled`]: 'Pricings successfully uploaded to CDN',
  [`${postSyncPricingsToCdnByAgentId.name}_rejected`]: 'There was an issue while trying to upload pricings to CDN',
  [`${postCreateChannel.name}_fulfilled`]: 'New channel created successfully.',
  [`${postCreateChannel.name}_rejected`]: 'There was an issue while trying to create the channel.',
  [`${patchChangeUserId.name}_fulfilled`]: 'User credentials changed successfully',
  [`${patchChangeUserId.name}_rejected`]: 'There was a problem when trying to change the user credentials',
  [`${patchChangeAgentIdChannel.name}_fulfilled`]: 'The agent has been successfully switched to another channel.',
  [`${patchChangeAgentIdChannel.name}_rejected`]:
    'There was an issue while trying to switch the agent to another channel.',
  [`${patchChangeApprovalStatusByMerchantId.name}_fulfilled`]: 'Change successfully applied.',
  [`${patchChangeApprovalStatusByMerchantId.name}_rejected`]: 'An issue occurred while trying to make the change.',
  [`${patchChangeMerchantStatusByMerchantId.name}_fulfilled`]: 'Change successfully applied.',
  [`${patchChangeMerchantStatusByMerchantId.name}_rejected`]: 'An issue occurred while trying to make the change.',
  [`${postCreateMerchant.name}_fulfilled`]: 'New merchant created successfully.',
  [`${postCreateMerchant.name}_rejected`]: 'An issue occurred while trying to create the new merchant.',
  [`${postCreateMerchantData.name}_fulfilled`]: 'New merchant created successfully.',
  [`${postCreateMerchantData.name}_rejected`]: 'An issue occurred while trying to create the new merchant.',
  [`${patchSetLegalAddress.name}_fulfilled`]: 'Legal address successfully set.',
  [`${patchSetLegalAddress.name}_rejected`]: 'An issue occurred while trying to set legal address.',
  [`${patchSetNieData.name}_fulfilled`]: 'Data successfully updated.',
  [`${patchSetNieData.name}_rejected`]: 'An issue occurred while trying to update NIE data.',
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_fulfilled`]:
    'Banking information has been updated successfully.',
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_rejected`]: 'There was an issue updating the information.',
  [`${patchUpdateCashInCashOutMethod.name}_fulfilled`]: 'Banking information has been updated successfully.',
  [`${patchUpdateCashInCashOutMethod.name}_rejected`]: 'There was an issue updating the information.',
  [`${patchAddCashInCashOutMethodByMerchantId.name}_fulfilled`]: 'Banking information added successfully.',
  [`${patchAddCashInCashOutMethodByMerchantId.name}_rejected`]:
    'An issue occurred while trying to add banking information.',
  [`${patchChangeAcquisitionChannelByMerchantId.name}_fulfilled`]: 'Merchant acquisition channel modified successfully',
  [`${patchChangeAcquisitionChannelByMerchantId.name}_rejected`]:
    'An issue occurred while modifying the acquisition channel',
  [`${patchChangeRegistrationFieldsByMerchantId.name}_fulfilled`]: 'Merchant registration data modified successfully',
  [`${patchChangeRegistrationFieldsByMerchantId.name}_rejected`]:
    'An issue occurred while modifying the registration data.',
  [`${patchBlockUser.name}_fulfilled`]: 'Credentials blocked successfully',
  [`${patchBlockUser.name}_rejected`]: 'There was an issue while trying to block credentials',
  [`${patchUnblockUser.name}_fulfilled`]: 'Credentials unblocked successfully',
  [`${patchUnblockUser.name}_rejected`]: 'There was an issue while trying to unblock credentials',
  [`${postAgentInLenderContext.name}_fulfilled`]: 'New credentials created successfully',
  [`${postAgentInLenderContext.name}_rejected`]: 'Failed to create new credentials',
  [`${patchSetAgentIdInLenderContextById.name}_fulfilled`]: 'Credentials updated successfully',
  [`${patchSetAgentIdInLenderContextById.name}_rejected`]: 'Failed to update credentials',
  [`${deleteAgentInLenderContextById.name}_fulfilled`]: 'Credentials deleted successfully',
  [`${deleteAgentInLenderContextById.name}_rejected`]: 'Credentials could not be deleted',
  [`${patchChangeType.name}_fulfilled`]: 'Channel type modified successfully',
  [`${patchChangeType.name}_rejected`]: 'There was an issue while trying to modify the channel type',
  [`${patchChangeDescription.name}_fulfilled`]: 'Channel description modified successfully',
  [`${patchChangeDescription.name}_rejected`]: 'There was an issue while trying to modify the channel description',
  [`${patchUpdateDeclaredIncome.name}_fulfilled`]: 'Declared income updated successfully',
  [`${patchUpdateDeclaredIncome.name}_rejected`]: 'Failed to update declared income',
  [`${patchUpdateInvitationByType.name}_fulfilled`]: 'Invitation data updated successfully',
  [`${patchUpdateInvitationByType.name}_rejected`]: 'There was a problem updating invitation data',
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_fulfilled`]: 'Business details successfully updated',
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_rejected`]:
    'There was an issue while trying to update business details',
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_fulfilled`]: 'Company holders updated successfully',
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_rejected`]: 'Failed to update company holders.',
  [`${postSendEmailForNewVideoId.name}_fulfilled`]: 'Email for new video identification request successfully sent',
  [`${postSendEmailForNewVideoId.name}_rejected`]: 'An error occurred while sending email for new video identification',
  [`${patchUnSignLoanLenderBorrowerContract.name}_fulfilled`]: 'Contract signing has been unsigned successfully',
  [`${patchUnSignLoanLenderBorrowerContract.name}_rejected`]: 'There was a problem during contract unsigning',
  [`${patchSetLenderRequestId.name}_fulfilled`]: 'Request ID modified successfully',
  [`${patchSetLenderRequestId.name}_rejected`]: 'There was a problem modifying the request ID',
  [`${patchUpdateBorrowerContractLoan.name}_fulfilled`]: 'Contract data updated successfully',
  [`${patchUpdateBorrowerContractLoan.name}_rejected`]: 'An error ocurred while updating contract data',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_fulfilled`]: 'Payment date updated successfully',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_rejected`]: 'There was a problem updating the payment date',
  [`${patchUpdatePaymentPlanLineStatus.name}_fulfilled`]: 'Payment status changed successfully',
  [`${patchUpdatePaymentPlanLineStatus.name}_rejected`]: 'There was a problem changing the payment status',
  [`${patchSignLoanLenderBorrowerContract.name}_fulfilled`]: 'The contract for this request has been marked as signed',
  [`${patchSignLoanLenderBorrowerContract.name}_rejected`]:
    'There was a problem marking the contract for this request as signed',
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_fulfilled`]: 'Participant successfully added to the request',
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_rejected`]:
    'There was a problem adding the participant to the request',
  [`${patchSendDocumentationIncidenceNotification.name}_fulfilled`]:
    'The incident notification has been successfully sent',
  [`${patchSendDocumentationIncidenceNotification.name}_rejected`]:
    'An error occurred while sending the incident notification',
  [`${patchUpdatePaymentPlanLineSentDate.name}_fulfilled`]:
    'Payment request email for corresponding instalment has been successfully sent to the customer',
  [`${patchUpdatePaymentPlanLineSentDate.name}_rejected`]:
    'The payment request email was not sent to the customer due to an error',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_fulfilled`]: 'Document requested successfully',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_rejected`]: 'An issue occurred during new document request',
  [`${patchSetDocumentRequiredIsNotSent.name}_fulfilled`]: 'Document successfully marked as not sent',
  [`${patchSetDocumentRequiredIsNotSent.name}_rejected`]: 'An issue has arisen while marking the document as not sent',
  [`${patchUploadFileToDocumentationRequired.name}_fulfilled`]: 'Documentation successfully uploaded',
  [`${patchUploadFileToDocumentationRequired.name}_rejected`]: 'An issue occurred during documentation upload',
  [`${patchSetDocumentStatus.name}_fulfilled`]: 'Document status successfully changed',
  [`${patchSetDocumentStatus.name}_rejected`]: 'An issue occurred while changing document status',
  [`${patchSyncBorrowerDocumentationByLoanId.name}_fulfilled`]: 'Documentation successfully synchronized',
  [`${patchSyncBorrowerDocumentationByLoanId.name}_rejected`]: 'An issue occurred during documentation synchronization',
  [`${patchUploadDocumentationToLender.name}_fulfilled`]:
    'Documentation successfully sent to the financial institution',
  [`${patchUploadDocumentationToLender.name}_rejected`]:
    'An issue occurred while sending documentation to the financial institution',
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_fulfilled`]: 'Requested document successfully removed',
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_rejected`]:
    'An issue occurred while removing requested document',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_fulfilled`]: 'Pricing code removed successfully',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_rejected`]: 'Failed to add pricing code.',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_fulfilled`]:
    'Failed to remove pricing code.',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_rejected`]: 'Failed to remove pricing code.',
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_fulfilled`]: 'Branding information updated successfully.',
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_rejected`]: 'An issue occurred while updating information.',
  [`${postCreateUser.name}_fulfilled`]: 'New credentials created successfully.',
  [`${postCreateUser.name}_rejected`]: 'There was an issue while trying to create credentials.',
  [`${patchChangeLoanStatus.name}_fulfilled`]: 'Loan status change processed successfully',
  [`${patchChangeLoanStatus.name}_rejected`]: 'There was an issue changing the loan status',
  [`${patchProcessLoanApplicationInLenderManually.name}_fulfilled`]: 'Lender approval status changed successfully',
  [`${patchProcessLoanApplicationInLenderManually.name}_rejected`]:
    'There was a problem changing the lender approval status',
  [`${patchSetAreDocumentsConfirmed.name}_fulfilled`]: 'Documentation successfully confirmed',
  [`${patchSetAreDocumentsConfirmed.name}_rejected`]: 'An issue occurred while confirming documentation',

  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_fulfilled`]:
    'A contract signing reminder has been sent to the merchant successfully.',
  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_rejected`]:
    'An issue occurred while sending a contract signing reminder to the merchant.',
  [`${patchCreateSignatureRequestForMerchantContract.name}_fulfilled`]:
    'A new contract has been sent to the merchant successfully.',
  [`${patchCreateSignatureRequestForMerchantContract.name}_rejected`]:
    'An issue occurred while sending the new contract to the merchant.',
  [`${patchUploadFileToDocumentationRequired.name}_fulfilled`]: 'Documentation successfully uploaded',
  [`${patchUploadFileToDocumentationRequired.name}_rejected`]: 'An issue occurred during documentation upload',
  [`${patchSetDocumentStatus.name}_fulfilled`]: 'Document status successfully changed',
  [`${patchSetDocumentStatus.name}_rejected`]: 'An issue occurred while changing document status',
  [`${postCreateCheckoutSession.name}_fulfilled`]: 'Checkout created',
  [`${postCreateCheckoutSession.name}_rejected`]: 'A problem has occurred while creating the checkout.',
  [`${patchSetRangesForAgent.name}_fulfilled`]: 'Rate limits modified successfully',
  [`${patchSetRangesForAgent.name}_rejected`]: 'There was an issue modifying the rate limits',
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_fulfilled`]: 'Checkout successfully cancelled',
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_rejected`]:
    'A problem ocurred while cancelling the checkout session',
  patchCreateApplicationsByPaymentMethodType_rejected: 'A problem ocurred while evaluating the checkout.',
  [`${patchUpdateLoanApplicationInLender.name}_fulfilled`]:
    'The data has been successfully updated at the financial institution',
  [`${patchUpdateLoanApplicationInLender.name}_rejected`]:
    'A problem has occurred while trying to update the data at the financial institution',
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_fulfilled`]:
    'The loan conditions have been successfully updated',
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_rejected`]:
    'An issue occurred while trying to update the loan conditions',
  [`${postCloneOrUpdateAgent.name}_fulfilled`]: 'The agent was successfully created/updated',
  [`${postCloneOrUpdateAgent.name}_rejected`]: 'There was a problem while trying to create/update the agent',
  [`${patchUpdateBorrowerDetails.name}_rejected`]:
    'The combination of email and phone number entered does not match the registered information for this client',
  [`${patchSetCart.name}_fulfilled`]: 'The checkout has been successfully updated',
  [`${patchSetCart.name}_rejected`]: 'There was a problem while trying to update the checkout',
  [`${patchUpdateDownPayment.name}_fulfilled`]: 'The checkout has been successfully updated',
  [`${patchUpdateDownPayment.name}_rejected`]: 'There was a problem while trying to update the checkout',
  [`${patchUpdatePaymentMethodOptions.name}_fulfilled`]:
    'The payment method configuration of the checkout has been successfully updated',
  [`${patchUpdatePaymentMethodOptions.name}_rejected`]:
    'There was a problem while trying to update the payment method configuration of the checkout',
  [`${patchPaymentMethodModification.name}_fulfilled`]: 'Vehicle data has been successfully updated',
  [`${patchPaymentMethodModification.name}_rejected`]: 'There was a problem while trying to update the vehicle data',
  [`${postPaymentMethodModificationPreview.name}_rejected`]:
    'There was a problem while trying to preview the vehicle data changes',

  // ─── Document Extractor Dialog ────────────────────────────────────────────────
  // Dialog
  DOCUMENT_EXTRACTOR_BUTTON_TEXT: 'Autofill with AI',
  DOCUMENT_EXTRACTOR_DIALOG_TITLE: 'Autofill with AI',
  DOCUMENT_EXTRACTOR_DIALOG_DESCRIPTION:
    'Upload the documentation you have to automatically extract the data and pre-fill the form.',
  DOCUMENT_EXTRACTOR_EXTRACT: 'Extract',
  DOCUMENT_EXTRACTOR_CONFIRM_AND_PREFILL: 'Confirm & pre-fill',
  DOCUMENT_EXTRACTOR_EXTRACTING: 'Extracting documents...',
  DOCUMENT_EXTRACTOR_APPLYING: 'Applying extracted data...',
  DOCUMENT_EXTRACTOR_DROP_FILES: 'Drop files here or click to select',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_PREFIX: 'max',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_SUFFIX: 'MB per file',
  DOCUMENT_EXTRACTOR_DRAG_REORDER_HINT: 'Drag to reorder — documents higher in the list take priority.',
  // Pre-fill confirmation
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_TITLE: 'Fill form with extracted data?',
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_DESCRIPTION:
    'Any form fields that were already filled and match the extracted data will be overridden. This action cannot be undone.',
  // File entry row
  DOCUMENT_EXTRACTOR_DATA_TITLE: 'Extracted data',
  DOCUMENT_EXTRACTOR_NO_EXTRACTED_DATA_YET: 'This document has not been parsed yet.',
  DOCUMENT_EXTRACTOR_EXPAND_ALL: 'Expand all',
  DOCUMENT_EXTRACTOR_COLLAPSE_ALL: 'Collapse all',
  DOCUMENT_EXTRACTOR_STATUS_EXTRACTED: 'Extracted',
  DOCUMENT_EXTRACTOR_STATUS_FAILED: 'Failed',
  DOCUMENT_EXTRACTOR_STATUS_PENDING: 'Pending',
  DOCUMENT_EXTRACTOR_DOC_TYPE_AUTO_DETECT: 'Auto-detect',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_TITLE: 'Remove file?',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_DESCRIPTION: 'will be removed from the list.',
  DOCUMENT_EXTRACTOR_DUPLICATE_DOC_TYPE_WARNING:
    'Multiple documents of the same type detected. The document higher in the list takes priority.',
  DOCUMENT_EXTRACTOR_EXTRACTION_FAILED_SELECT_TYPE: 'Extraction failed. Select a document type above and retry.',
  DOCUMENT_EXTRACTOR_LOW_CONFIDENCE_PREFIX: 'Low confidence',
  DOCUMENT_EXTRACTOR_REVIEW_DATA: 'Review the extracted data carefully.',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_PREFIX: 'This PDF has',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_SUFFIX: 'pages. Only the first relevant page was processed.',
  // Document type labels
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT: 'DNI (front)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_BACK: 'DNI (back)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT_BACK: 'DNI (front and back)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_FRONT: 'NIE (front)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_BACK: 'NIE (back)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_EU_GREEN_CARD: 'NIE (green card)',
  DOCUMENT_EXTRACTOR_TYPE_PAYROLL: 'Payroll',
  DOCUMENT_EXTRACTOR_TYPE_PENSION_REVALUATION: 'Pension revaluation',
  DOCUMENT_EXTRACTOR_TYPE_PERSONAL_INCOME_TAX: 'Personal income tax',
  DOCUMENT_EXTRACTOR_TYPE_BANK_CERTIFICATE: 'Bank certificate',
  DOCUMENT_EXTRACTOR_TYPE_VEHICLE_INSPECTION: 'Vehicle inspection',
  // Validation errors
  DOCUMENT_EXTRACTOR_ERROR_UNSUPPORTED_FORMAT: 'unsupported format. Accepted:',
  DOCUMENT_EXTRACTOR_ERROR_FILE_TOO_LARGE: 'exceeds the maximum size of',
  DOCUMENT_EXTRACTOR_ERROR_EXTRACTION_FAILED: 'Extraction failed. Please try again.',
  DOCUMENT_EXTRACTOR_ERROR_RETRY_FAILED: 'Retry failed. Please try again.',
  DOCUMENT_EXTRACTOR_ERROR_PDF_ROTATE_FAILED: 'Failed to rotate PDF. Please try again.',

  // LENDER ORCHESTRATION (MERC-135)
  LENDER_ORCHESTRATION: 'Lender orchestration',
  LENDER_ORCHESTRATION_SUBTITLE: 'Application distribution',
  LENDER_ORCHESTRATION_SUBTITLE_TEXT: 'Configuration per payment method, applied to every agent of the merchant.',
  LENDER_ORCHESTRATION_COLUMN_STRATEGY: 'Sending',
  LENDER_ORCHESTRATION_COLUMN_MODE: 'Mode',
  LENDER_ORCHESTRATION_COLUMN_STOP: 'Stop',
  LENDER_ORCHESTRATION_COLUMN_RANKING: 'Ranking',
  LENDER_ORCHESTRATION_MIXED: 'Mixed',
  LENDER_ORCHESTRATION_UNIFY: 'Unify',
  LENDER_ORCHESTRATION_DEFAULT_TAG: 'default',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_CELL: 'Priority lender ·',
  LENDER_ORCHESTRATION_API_INFO_TITLE: 'Merchants integrated through the API',
  LENDER_ORCHESTRATION_API_INFO_TEXT: 'They can set another orchestration in each checkout session. This configuration applies when the session does not set one.',
  LENDER_ORCHESTRATION_LOAD_ERROR: 'The lender orchestration could not be loaded',
  CONFIGURATION_ERROR: 'Configuration error',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL: 'Parallel',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_SUMMARY: 'All at once',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_DESCRIPTION: 'The application goes to every lender at the same time. When they answer, the ranking picks among those that approve. Highest approval; more credit bureau checks for your customer.',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL: 'Waterfall',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_SUMMARY: 'One by one',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_DESCRIPTION: 'It goes to the first lender of the ranking and waits for its answer before moving to the next one. It stops at the answer you choose in step 3. Fewer bureau checks and control of the split.',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC: 'Automatic',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_TITLE: 'The platform, automatically',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_SUMMARY: 'Moves on as soon as each answer arrives',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_DESCRIPTION: 'The application follows the ranking order as soon as each answer arrives. Your team does not have to do anything.',
  LENDER_ORCHESTRATION_MODE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_MODE_MANUAL_TITLE: 'Your team, by hand',
  LENDER_ORCHESTRATION_MODE_MANUAL_SUMMARY: 'Your team sends and records each answer',
  LENDER_ORCHESTRATION_MODE_MANUAL_DESCRIPTION: 'Nothing is sent automatically: your team processes each application manually. The ranking is only a recommendation.',
  LENDER_ORCHESTRATION_STOP_YES: 'Approved',
  LENDER_ORCHESTRATION_STOP_YES_TITLE: 'When one approves',
  LENDER_ORCHESTRATION_STOP_YES_SUMMARY: 'Only an approval stops',
  LENDER_ORCHESTRATION_STOP_YES_DESCRIPTION: 'Only an approval stops the waterfall. If a lender fails, rejects or leaves the application under review, the next one is consulted.',
  LENDER_ORCHESTRATION_STOP_MAYBE: 'Approved or under review',
  LENDER_ORCHESTRATION_STOP_MAYBE_TITLE: 'When one approves or reviews',
  LENDER_ORCHESTRATION_STOP_MAYBE_SUMMARY: 'An under-review answer also stops',
  LENDER_ORCHESTRATION_STOP_MAYBE_DESCRIPTION: 'A lender that keeps the operation under review already stops the waterfall. If it fails or rejects, the next one is consulted.',
  LENDER_ORCHESTRATION_STOP_NO: 'First answer',
  LENDER_ORCHESTRATION_STOP_NO_TITLE: 'With the first one that answers',
  LENDER_ORCHESTRATION_STOP_NO_SUMMARY: 'Any answer, except a technical failure',
  LENDER_ORCHESTRATION_STOP_NO_DESCRIPTION: 'Approving, leaving under review or rejecting stop the waterfall. Only in case of a technical failure does it move to the next one.',
  LENDER_ORCHESTRATION_STOP_ERROR: 'Only the first',
  LENDER_ORCHESTRATION_STOP_ERROR_TITLE: 'Only the first, whatever happens',
  LENDER_ORCHESTRATION_STOP_ERROR_SUMMARY: 'A single lender, whatever happens',
  LENDER_ORCHESTRATION_STOP_ERROR_DESCRIPTION: 'Only the first lender of the ranking is consulted. Whatever its answer, even a technical failure, no other lender is consulted.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR: 'Lowest cost and APR',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_SUMMARY: 'Cheapest for you first, then lowest APR',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_DESCRIPTION: 'First the lender that costs you the least. At equal cost, the one with the lowest APR for your customer.',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY: 'Highest profitability',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_SUMMARY: 'Most profitable for you first',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_DESCRIPTION: 'First the lender with which the operation is most profitable for you.',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET: 'Prefer 0% interest',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_SUMMARY: '0% interest lenders first',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_DESCRIPTION: 'If a lender offers 0% interest to the customer, it goes first. Among several at 0%, the one that costs you the least.',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE: 'Priority lender, then price',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_SUMMARY: 'One fixed lender first, the rest by price',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_DESCRIPTION: 'The lender you choose always goes first if it prices the operation. The rest, by lowest cost and APR.',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION: 'The customer chooses',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_SUMMARY: 'The customer chooses in the checkout',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_DESCRIPTION: 'The customer sees the lenders\' offers in the checkout and chooses which one finances. The platform does not decide for them.',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA: 'Iberia',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_SUMMARY: 'Split agreed with Iberia Cards',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_DESCRIPTION: 'First-position split agreed with Iberia Cards: each lender wins the first position 10% of the time; price decides the rest. At 3 months, always by price.',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_SUMMARY: 'Order set in the session',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_DESCRIPTION: 'Order set in each checkout session.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA: 'Lowest instalment',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_SUMMARY: 'Lowest instalment first',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_DESCRIPTION: 'First the lender with the lowest instalment.',
  LENDER_ORCHESTRATION_QUESTION_STRATEGY: 'How is the application sent to the lenders?',
  LENDER_ORCHESTRATION_QUESTION_MODE: 'Who moves the waterfall forward? Waterfall only.',
  LENDER_ORCHESTRATION_QUESTION_STOP: 'Which answer stops the waterfall? Waterfall only. Same four-lender example in every option: the 1st fails, the 2nd rejects, the 3rd leaves it under review, the 4th approves.',
  LENDER_ORCHESTRATION_QUESTION_RANKING: 'In which order are lenders preferred? In waterfall it sets the consultation order; in parallel, which one wins among those that approve.',
  LENDER_ORCHESTRATION_PRIORITY_LENDER: 'Priority lender',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_TEXT: 'Limited to the lenders of the merchant.',
  LENDER_ORCHESTRATION_LOCKED_TITLE: 'Only a super_admin can change it',
  LENDER_ORCHESTRATION_LOCKED_TEXT: 'This value is restricted. You can change the rest of the configuration; it will be kept as it is.',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TITLE: 'Waterfall in manual mode',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TEXT: 'No application will be sent to a lender until your team records it. Operations stay under review meanwhile.',
  LENDER_ORCHESTRATION_ERROR_WATERFALL_BORROWER: 'The customer chooses only works with parallel sending',
  LENDER_ORCHESTRATION_ONLY_PARALLEL: 'Parallel sending only',
  LENDER_ORCHESTRATION_DEFAULT_HINT: 'Platform default for this type: $v1 · $v2',
  LENDER_ORCHESTRATION_RESET_DEFAULT: 'Reset to default',
  LENDER_ORCHESTRATION_APPLY: 'Apply to $v1 agents',
  LENDER_ORCHESTRATION_RESTRICTED: 'super_admin',
  LENDER_ORCHESTRATION_LENDERS_LOAD_ERROR: 'The lenders of each payment method could not be loaded',
  LENDER_ORCHESTRATION_READ_ONLY_TITLE: 'Only a super_admin can change this payment method',
  LENDER_ORCHESTRATION_READ_ONLY_TEXT: 'Its agents have different rankings and one of them is restricted. Unifying it needs a super_admin.',
  LENDER_ORCHESTRATION_APPLY_ONE: 'Apply to 1 agent',
  [`${patchSetProcessingConfigToMerchantAgents.name}_fulfilled`]: 'Lender orchestration applied.',
  [`${patchSetProcessingConfigToMerchantAgents.name}_rejected`]: 'The lender orchestration could not be applied.',
  LENDER_ORCHESTRATION_DIAGRAM_REQUEST: 'Application',
  LENDER_ORCHESTRATION_DIAGRAM_AT_ONCE: 'at once',
  LENDER_ORCHESTRATION_DIAGRAM_APPROVES: 'approves',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTS: 'rejects',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTED: 'rejected',
  LENDER_ORCHESTRATION_DIAGRAM_WHEN_ANSWERS: 'when it answers',
  LENDER_ORCHESTRATION_DIAGRAM_REVIEW: 'under review',
  LENDER_ORCHESTRATION_DIAGRAM_FAILS: 'fails',
  LENDER_ORCHESTRATION_DIAGRAM_ANY_RESULT: 'any result',
  LENDER_ORCHESTRATION_DIAGRAM_NOT_CONSULTED: 'not consulted',
  LENDER_ORCHESTRATION_DIAGRAM_WINS: 'wins',
  LENDER_ORCHESTRATION_DIAGRAM_IN_RANKING_ORDER: (
    <>
      in <tspan fontWeight={700}>ranking order</tspan>, one after another
    </>
  ),
  LENDER_ORCHESTRATION_DIAGRAM_PLATFORM: 'platform',
  LENDER_ORCHESTRATION_DIAGRAM_YOUR_TEAM: 'your team',
  LENDER_ORCHESTRATION_DIAGRAM_CONSULTING: 'consulting…',
  LENDER_ORCHESTRATION_DIAGRAM_WAITING: 'waiting',
  LENDER_ORCHESTRATION_DIAGRAM_AUTO_HINT: 'each answer triggers the next consultation',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT_TOP: 'the order is only a recommendation',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT: 'nothing is sent on its own · your team processes each one manually',
  LENDER_ORCHESTRATION_DIAGRAM_COST_FOR_YOU: 'what it costs you',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_APR: 'customer APR',
  LENDER_ORCHESTRATION_DIAGRAM_MIN_APR_HINT: 'A and B tie on cost → lowest APR wins',
  LENDER_ORCHESTRATION_DIAGRAM_PROFITABILITY: 'profitability of the operation for you',
  LENDER_ORCHESTRATION_DIAGRAM_COSTS_YOU: 'costs you',
  LENDER_ORCHESTRATION_DIAGRAM_ALWAYS_FIRST: 'the one you choose, always 1st',
  LENDER_ORCHESTRATION_DIAGRAM_REST_BY_PRICE: 'the rest, by lowest cost and APR',
  LENDER_ORCHESTRATION_DIAGRAM_NO_PRICING_FALLBACK: 'if it does not price the operation, only price counts',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_CHECKOUT: 'Customer checkout',
  LENDER_ORCHESTRATION_DIAGRAM_INSTALMENTS_OF: 'instalments of',
  LENDER_ORCHESTRATION_DIAGRAM_FIRST_POSITIONS: '10% of first positions',
  LENDER_ORCHESTRATION_DIAGRAM_RESERVED_EACH: 'reserved for each lender',
  LENDER_ORCHESTRATION_DIAGRAM_REMAINING: 'remaining 70%',
  LENDER_ORCHESTRATION_DIAGRAM_BY_COST_APR: 'by lowest cost and APR',
  LENDER_ORCHESTRATION_DIAGRAM_THREE_MONTHS: 'at 3 months: always by price',
};

export const en_alt_setup_fee = {
  SETUP_FEE: 'Setup fee',
};

export default en;
